import _, { get, each } from 'lodash'
import { HYDRATE } from 'next-redux-wrapper'
import Axios from 'axios'
import { createStore } from 'redux'
import { applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { fromJS, List, Map, isImmutable } from 'immutable'
import * as actionTypes from './actionTypes'
import uuid from 'uuid/v4'
import moment from 'moment'
import { isNaN } from 'lodash'
import { getElementDataRoot } from '../../constants/getElementDataRoot'
import { setInitialProjectUIState } from '../../constants/setInitialProjectUIState'
import { getGridData } from '../../constants/getGridData'
import { getParentIdInModal, getValueForModeJS, LAYOUT_MODE } from '../../constants/toUnits'
import { getDefaultStyles } from '../../constants/getDefaultStyles'
import {
  getOpposite,
  getStyleRef,
  mapChoicesByRecords,
  processActionsSFItem,
  parseURLParameters,
  toJS,
  resetLoadingFlags,
  formatComplexSFData,
  formatSFMappingResult,
  formatSFDateValue,
  getPreviewFlatSFMapping,
  getPreviewFlatSFMappingSettings,
  fixActionID,
  updatePageMongoKeyIssue,
  fixID,
  updateTabValueJS,
  updateTabValue,
  clearRecursiveElements,
  getElemReadOnlyRules,
  shouldSkipEmptyRowCheck,
} from '../../lib/common'
import { setVisibilityOfSFMappingElem } from '../../lib/setVisibilityOfSFMappingElem'
import { setActivePanel } from '../../lib/setActivePanel'
import { copyPropertiesToDevice } from '../../lib/copyPropertiesToDevice'
import {
  doProcessRules,
  getInitialParams,
  getParams,
  processSingleRule,
  getSystemVariable,
  isNeedProcessQueCondition,
  hideSFLoadingMessages,
  setValueByField,
  getState,
  makeFormViewList,
} from '../../lib/processPortalRules'
import { setupRulesHashMap, setWidgetElemStaticVal, getChildUIDs, getPlaceToStyle } from '../../lib/widgets'
import { DEVICE_DEFAULT_MAX_SIZE } from '../../lib/DEVICE_DEFAULT_MAX_SIZE'
import { IS_SERVER } from '../../constants/ssr'
import { getPreviewDynamicData } from '../../lib/projectAxios'
import { processRemoveChildElements } from './processRemoveChildElements'
import { getUID } from '../../lib/guid'
import { getPanelsInitialState } from '../../lib/panelUtils'
import { LIST_BASED_FIELDS } from '../../constants/LIST_BASED_FIELDS'
import { isWidgetType, findMaxProjectID, ALL_SIZE_KEYS, ALL_SIZE_KEYS_WITH_FONT } from '../../constants/CardComponent'
import { safeUpdateFooterElement } from '../../lib/safeChangeUtils'
import { disableHistory } from '../../constants/HISTORY_ENTRY_COUNT'
import { TAB_TYPES, fixProjectElementsKeys } from '../../lib/tab-utils'
import { processApplyOnloadACRules } from '../../lib/processACRules'
import { mergeDeep as jsMergeDeep } from '../../lib/mergeDeep'
import { LANDING_TYPE, WORKFLOW_TYPE } from '../../constants/features'
import { moveElementsToAutoFit } from '../../lib/moveElementsToAutoFit'
import { LayoutNames } from '../../constants/LayoutNames'
import { STATIC_COND_CACHE } from './processCondCache'
import { getMappingCount } from '../../constants/getMappingCount'
import { processUpdateFormFieldStyles } from '../../lib/processUpdateFormFieldStyle'
import { IS_WORKER } from '../../constants/isWorker'
import {
  collectPowerTableInputColumn,
  getPowerTableInputColumnDefaults,
} from '../../components/WidgetBuilder/UI/Components/Elements/PowerTable/utils'
import { parseArrayValues, parseValue } from './indexScripts/parseTextFieldValues'
import { processCondRulesBatch } from './indexScripts/processCondRulesBatch'
import { setElementValueBatch } from './indexScripts/setElementValueBatch'
import { getActivePageField, logError } from '../../lib/error-logger'
import { applyKanbanUpdate, startKanbanUpdate } from './indexScripts/applyKanbanUpdate'
import { getRootParent } from './getRootParent'
import { concatParams } from './projectPreviewNavigate'
import { safeSetIn } from '../../lib/immutable-tools'
import { ftReplaceState } from '../../lib/browserWindowLib'
import { getPageState } from './getPageState'
import { deepMergeOverrideArrays } from '../../utils/immutableUtils'

if (process.env.NODE_ENV === 'production') {
  moment.suppressDeprecationWarnings = true
}

const SAFE_KEYS = ['Menu', 'title', 'signinText', 'signoutText', 'drawerTitle']

const PRESERVE_STATE_ELEMENTS = ['TextReview'] // State of these elements inside repeat container is not cleared (but still updated) on receiving new state from SF Get.

const pageOnceActionStatus = {}

const safeMapToJS = (obj) => {
  if (isImmutable(obj)) {
    return obj.toJS()
  } else if (_.isObject(obj)) {
    return obj
  } else {
    return {}
  }
}

const getInitialLayoutMode = (def = 'lg') => {
  var moveToDevice = def
  if (typeof window === 'undefined') {
    return moveToDevice
  }
  if (_.startsWith(window.location.pathname, '/project')) {
    return moveToDevice
  }
  try {
    var windowWidth = window.innerWidth
    var params = parseURLParameters()
    if (params.device) {
      moveToDevice = params.device
    } else if (
      window.compiledDevicesStyle &&
      window.compiledDevicesStyle.pageWidth &&
      window.compiledDevicesStyle.pageWidth <= windowWidth
    ) {
      moveToDevice = 'lg'
    } else if (windowWidth > DEVICE_DEFAULT_MAX_SIZE.lg) {
      moveToDevice = 'lg'
    } else if (windowWidth > DEVICE_DEFAULT_MAX_SIZE.md) {
      moveToDevice = 'md'
    } else if (windowWidth > DEVICE_DEFAULT_MAX_SIZE.sml) {
      moveToDevice = 'sml'
    } else if (windowWidth > DEVICE_DEFAULT_MAX_SIZE.sm) {
      moveToDevice = 'sm'
    } else if (windowWidth > DEVICE_DEFAULT_MAX_SIZE.xs) {
      moveToDevice = 'xs'
    } else {
      moveToDevice = 'ss'
    }
  } catch (error) {
    console.error(error)
  }
  return moveToDevice
}

const fillRepeatStripDefaults = (state, pageUID, repeatedStrip) => {
  try {
    let pageID = state.get('page')
    _.each(repeatedStrip, (stripID) => {
      let stripParams = state.getIn(['pages', pageID, 'Props', 'elements', stripID, 'props', 'params'], List())
      let stripData = state.getIn(['state', pageUID, stripID], Map())
      if (!isImmutable(stripData)) {
        stripData = Map()
      }
      let childrens = getChildUIDs(state, stripID)

      let size = getMappingCount(stripData.toJS())
      stripParams.map((param) => {
        if (param.get('paramType') === 'static') {
          stripData = stripData.set(
            param.get('id'),
            fromJS(_.times(size, (n) => stripData.getIn([param.get('id'), n], param.get('value', ''))))
          )
        }
      })

      let layoutMode = state.getIn(['layoutMode'], 'lg')
      _.each(childrens, function (childID) {
        if (!stripData.get(childID)) {
          let elem = state.getIn(['pages', pageID, 'Props', 'elements', childID], Map())
          if (elem.get('type') !== 'FormField' && !TAB_TYPES.includes(elem.get('type'))) {
            return true
          }
          let value = elem.getIn(['props', layoutMode, 'value'])
          let defValue
          if (isImmutable(elem) && elem.getIn(['props', 'control']) === 'daterange') {
            if (elem.getIn(['props', layoutMode, 'startDate']) || elem.getIn(['props', layoutMode, 'endDate'])) {
              defValue = _.times(size, function () {
                return {
                  startDate: new moment(elem.getIn(['props', layoutMode, 'startDate']) || new Date()),
                  endDate: new moment(elem.getIn(['props', layoutMode, 'endDate']) || new Date()),
                }
              })
              stripData = stripData.set(childID, fromJS(defValue))
            }
          } else if (value !== '' && value !== undefined) {
            if (TAB_TYPES.includes(elem.get('type'))) {
              let el = elem.toJS()
              if (_.get(el, 'props.source', '') != 'sf') {
                let val = getValueForModeJS(el, layoutMode, ['props'], ['value'], '')
                let ftIsFirst = false
                let ftIsLast = false
                let tabs = updateTabValueJS(_.filter(_.get(el, ['props', layoutMode, 'tabs'], []), (tab) => !tab?.hide))
                let valueIndex = _.findIndex(tabs, (tab) => tab.ftValue === val)
                if (valueIndex === 0) {
                  ftIsFirst = true
                }
                if (_.size(tabs) - 1 === valueIndex) {
                  ftIsLast = true
                }
                defValue = _.times(size, function () {
                  return {
                    ftListValue: val,
                    ftIsFirst,
                    ftIsLast,
                  }
                })
              }
            } else if (
              LIST_BASED_FIELDS.includes(elem.getIn(['props', 'control'])) &&
              elem.getIn(['props', 'source']) === 'static'
            ) {
              let items = elem.getIn(['props', 'items'], List())
              let item = items.find((v) => v.get('value') === value)
              if (elem.getIn(['props', 'control']) === 'radio') {
                if (item) {
                  defValue = _.times(size, function () {
                    return {
                      ftListValue: value,
                      ftListLabel: item.get('label'),
                    }
                  })
                } else {
                  defValue = _.times(size, function () {
                    return {
                      ftListValue: value,
                      ftListLabel: '',
                    }
                  })
                }
              } else {
                if (item) {
                  defValue = {
                    ftListValue: _.times(size, function () {
                      return value
                    }),
                    ftListLabel: _.times(size, function () {
                      return item.get('label')
                    }),
                  }
                } else {
                  defValue = {
                    ftListValue: _.times(size, function () {
                      return value
                    }),
                  }
                }
              }
            } else {
              defValue = _.times(size, function () {
                return value
              })
            }
            if (defValue !== undefined) {
              stripData = stripData.set(childID, fromJS(defValue))
            }
          }
        }
      })
      state = state.setIn(['state', pageUID, stripID], stripData)
    })
  } catch (err) {
    console.error(err)
  }
  return state
}

export const getRepeatRootParent = (uid, elements, prev = []) => {
  const parent = isImmutable(elements) ? elements.getIn([uid, 'parent']) : _.get(elements, [uid, 'parent'])
  if (parent && !prev.includes(uid)) {
    let parentType = isImmutable(elements) ? elements.getIn([parent, 'type']) : _.get(elements, [parent, 'type'])
    if (parentType === 'RepeatAutoFit') {
      return parent
    } else {
      return getRepeatRootParent(parent, elements, [...prev, uid])
    }
  } else {
    return null
  }
}

const getPageSurveyResumeState = (retState, pageState, answers, newPageUID) => {
  let pageId = retState.get('page')
  let elements = retState.getIn(['pages', pageId, 'Props', 'elements'])
  _.each(answers, function (value, uid) {
    if (elements.get(uid)) {
      try {
        value = JSON.parse(value)
      } catch (err) {
        return true
      }

      let elem = elements.get(uid)

      let fieldTye = elem.getIn(['type'])
      if (fieldTye == 'FormField') {
        fieldTye = elem.getIn(['props', 'control'])
      }

      switch (fieldTye) {
        case 'Matrix':
        case 'signature':
        case 'fileupload':
          break
        case 'Ranking':
          let val = {}
          _.each(value, function (row, index) {
            if (row) {
              val[row.uid] = index + 1
            }
          })
          pageState = _.set(pageState, [newPageUID, uid], val)
          break
        case 'lookup':
          if (value && value.value) {
            value = value.value
          } else {
            value = {}
          }
          pageState = _.set(pageState, [newPageUID, uid, 'ft_value'], value.value)
          pageState = _.set(pageState, [newPageUID, uid, 'ft_text'], value.label)
          break
        case 'multiSelect':
        case 'SurveyList':
        case 'select':
        case 'radio':
        case 'buttongroup':
        case 'ImageChoice':
        case 'CES':
          if (value && value.value) {
            value = value.value
          } else {
            value = {}
          }
          pageState = _.set(pageState, [newPageUID, uid, 'ftListValue'], value.value)
          pageState = _.set(pageState, [newPageUID, uid, 'ftListLabel'], value.label)
          break
        case 'Range':
          if (value && value.value) {
            value = value.value
          } else {
            value = {}
          }
          pageState = _.set(pageState, [newPageUID, uid, 'min'], value.min)
          pageState = _.set(pageState, [newPageUID, uid, 'max'], value.max)
          break
        default:
          pageState = _.set(pageState, [newPageUID, uid], value.value)
          break
      }
    }
  })
  let localState = retState.set('state', fromJS(pageState))
  let containerID = retState.getIn(['pages', pageId, 'Props', 'Grid', 0])
  let container = elements.get(containerID)
  if (container) {
    let list = makeFormViewList(container, 'lg', localState)
    let lastSelectedStep
    _.each(list, function (row, index) {
      if (row && row.children) {
        _.each(row.children, function (child) {
          if (child && answers[child]) {
            if (list[index + 1]) {
              lastSelectedStep = list[index + 1]
            } else {
              lastSelectedStep = row
            }
          }
        })
      }
    })
    if (lastSelectedStep && !lastSelectedStep.isFinish) {
      pageState = _.set(pageState, [newPageUID, containerID, 'ftListValue'], lastSelectedStep.id)
      pageState = _.set(pageState, [newPageUID, containerID, 'ftListLabel'], lastSelectedStep.label)
    }
  }
  return pageState
}

const fturl = typeof window !== 'undefined' && !IS_WORKER ? window.location.href : undefined
const BASE_URL = IS_SERVER || IS_WORKER ? `//${process.env.NEXT_PUBLIC_HOST}/` : `//${window.location.hostname}/`
let axiosParams = {
  baseURL: BASE_URL,
  headers: {
    fturl,
  },
}
if (!IS_SERVER) {
  axiosParams.headers.sfAuthHash = get(getPreviewDynamicData(), ['ssoParams', 'sfAuthHash'])
}
export const axios = Axios.create(axiosParams)

const HISTORY_ENTRY_COUNT = 20

const HISTORY_PREV = ['history', 'prev']
const CURRENT_PROJECT = (state) =>
  fromJS({
    project: Map(),
    pages: Map(),
  })

const integerizeKeys = (stringMap) =>
  stringMap.reduce((results, value, key) => {
    const integerizedKey = parseInt(key, 10)
    const fixedKey = isNaN(integerizedKey) ? key : integerizedKey
    return results.set(fixedKey, Map.isMap(value) ? integerizeKeys(value) : value)
  }, Map())

const panels = getPanelsInitialState()

let appInitialState = fromJS({
  isShowInvalidLicenseModal: false,
  history: {
    prev: [],
    next: [],
  },
  session: {
    isAuth: false,
    userInfo: {},
  },
  sf: {
    isLoadingObjects: false,
    isLoadingFields: false,
    isLoadingReports: false,
    isLoadingReportData: false,
    objects: [],
    fields: {},
    links: {},
    alive: {
      status: false,
    },
    connection: {},
    reports: [],
    report: null,
  },
  notifications: [],
  lang: {},
  WIDGETS: {},
  panels,
})
// REDUCERS
export const reducer = (state = appInitialState, action) => {
  switch (action.type) {
    case actionTypes.FILES_LIMIT_REACHED: {
      return disableHistory(state)
        .setIn(
          ['panels', 'FILES_LIMIT_REACHED'],
          fromJS({
            open: action.payload.open,
            isAllowClose: action.payload.isAllowClose,
          })
        )
        .set('disableDelta', true)
    }
    case actionTypes.CHANGE_SYNC_STATUS: {
      return disableHistory(state).setIn(['coEdit', 'status'], action.payload.status).set('disableDelta', true)
    }
    case actionTypes.PROJECT_LAST_ID: {
      return state
        .setIn(['isProjectChanged'], true)
        .setIn(['isPageChanged'], true)
        .setIn(
          HISTORY_PREV,
          state.getIn(HISTORY_PREV, List()).size >= HISTORY_ENTRY_COUNT
            ? state.getIn(HISTORY_PREV, List()).shift().push(CURRENT_PROJECT(state))
            : state.getIn(HISTORY_PREV, List()).push(CURRENT_PROJECT(state))
        )
        .setIn(['project', 'Settings', 'lastID'], action.payload.id)
    }
    case actionTypes.PROJECT_FORM_ADD_ITEM: {
      return action.payload.store
    }
    case actionTypes.PROJECT_FORM_DEL_ITEM: {
      return action.payload.state
    }
    case actionTypes.PROJECT_PAGE_BREAK_CHANGE: {
      const isRepeat = action.payload.isRepeat
      const repeatUID = action.payload.repeatUID
      const index = action.payload.index
      return state.setIn(
        [
          'FTFORM',
          action.payload.pageUID,
          ...(isRepeat ? [repeatUID] : []),
          action.payload.uid,
          ...(isRepeat ? [index] : []),
        ],
        action.payload.page
      )
    }
    case actionTypes.PROJECT_FORM_DROP_ELEM: {
      return action.payload.store
    }
    case actionTypes.SET_STORE: {
      return isImmutable(action.payload.store) ? action.payload.store : state
    }
    case actionTypes.PROCESS_PAGE_ON_LOAD: {
      const pageID = state.get('page')
      const page = state.getIn(['project', 'Pages'], List()).find((page) => page.get('_id') === pageID)

      if (!page) {
        return state
      }

      const action = page.get('action', List())
      const smartVParams = _.get(getPreviewDynamicData(), 'svParams', {})
      let retState = state

      if (!pageOnceActionStatus[pageID]) {
        const action = page.get('onceAction', List())
        retState = processSingleRule(
          fromJS({
            isActionRule: true,
            isNotSetValueRule: true,
            action,
          }),
          [],
          getState(retState),
          getParams(retState),
          smartVParams,
          retState,
          false,
          true
        )
        pageOnceActionStatus[pageID] = true
      }

      retState = processSingleRule(
        fromJS({
          isActionRule: true,
          isNotSetValueRule: true,
          action,
        }),
        [],
        getState(retState),
        getParams(retState),
        smartVParams,
        retState,
        false,
        true
      )

      if (retState.getIn(['redirectToPage'], '') !== '') {
        const pageUID = retState.getIn(['redirectToPage'], '')
        retState = retState.setIn(['redirectToPage'], '')
        setTimeout(() => {
          if (typeof window.__FT_PROJECT__API__?.goToPage === 'function') {
            window.__FT_PROJECT__API__.goToPage(pageUID)
          }
        }, 100)
      }
      return retState
    }
    case actionTypes.PROJECT_FINISH_ANIMATION: {
      const { path, animation } = action.payload

      return state.setIn(
        path,
        state.getIn(path, List()).filter((v) => v !== animation)
      )
    }
    case actionTypes.UPDATE_PUBLISHED_TIME: {
      return state.setIn(['project', 'PublishedAt'], new Date()).setIn(['project', 'Status'], 'Live')
    }
    case HYDRATE:
      return disableHistory(state)
        .merge(fromJS(action.payload).setIn(['panels'], fromJS(getPanelsInitialState())))
        .set('layoutMode', getInitialLayoutMode())
    case actionTypes.PROJECT_CLEAR_POST_MSG_TASK: {
      const { PageID, uid } = action.payload
      return state.setIn(['postMessagesTasks', PageID], state.getIn(['postMessagesTasks', PageID], Map()).delete(uid))
    }
    case actionTypes.PROCESS_PARAMS_UPDATED: {
      let params = state.getIn(['portal', 'paramsUpdated'], List())
      let ret = state.setIn(['portal', 'paramsUpdated'], List())
      params.map((v) => {
        let uid = v.getIn(['key', 0])
        if (uid) {
          ret = doProcessRules(ret, Boolean(_.get(window.__FT_APP_STATE__, 'portal')), [], [uid], null, false, false)
        }
      })
      return ret
    }
    case actionTypes.CLEAR_RECENT_UPDATES:
      return state.setIn(['sys'], List())
    case actionTypes.PROJECT_COPY_STL_FOR_MODE: {
      let retState = state
      let devPage = retState.get('devPage')
      const uidGen = getUID(retState)
      const keep = action.payload.keep ///style // all // content
      const isInheritStyle = keep === 'style' || keep === 'all'
      const isInheritContent = keep === 'content' || keep === 'all'
      const toMode = action.payload.mode
      let parentModes = LAYOUT_MODE.slice(0, LAYOUT_MODE.indexOf(toMode) + 1)
      let revercedModes = [...parentModes].reverse()
      const pageID = retState.get('page')
      let fromMode = _.last(parentModes)

      let isStyleCopied = false
      let isManualMode = action.payload.version == 'v1'
      if (action.payload.version) {
        retState = retState.set('versionForRecalculate', action.payload.version)
      }
      let isDevPage = false
      if (['signin', 'login', 'profile', 'register'].indexOf(devPage) > -1) {
        isDevPage = true
        let styles = retState.getIn(['project', 'Settings', 'styles'], Map())

        let smartVFields = [
          'SmartVLoginForm',
          'SmartVLoginPage',
          'SmartVSignUpPage',
          'SmartVVerificationPage',
          'SmartVProfilePage',
          'SmartVLoginField',
          'SmartVRegField',
          'SmartVProfileField',
          'SmartVLoginFormField',
          'SmartVVerfField',
        ]

        _.each(smartVFields, function (key) {
          if (!styles.getIn([key, 'IsConfiguredDevice', toMode]) || isInheritStyle) {
            let localFormMode = fromMode
            for (let i = parentModes.length - 1; i >= 0; i--) {
              if (parentModes[i] != toMode) {
                localFormMode = parentModes[i]
                if (styles.getIn([key, 'IsConfiguredDevice', localFormMode]) || localFormMode == 'lg') {
                  break
                }
              }
            }
            let copyStyle = styles.getIn([key, localFormMode])
            if (copyStyle) {
              styles = styles.setIn([key, toMode], copyStyle)
              styles = styles.setIn([key, 'IsConfiguredDevice', toMode], true)
            }
          }
        })
        retState = retState.setIn(['project', 'Settings', 'styles'], styles)
      }

      for (let i = parentModes.length - 1; i >= 0; i--) {
        if (parentModes[i] != toMode) {
          fromMode = parentModes[i]

          if (fromMode == 'lg') {
            break
          }
          if (state.getIn(['pages', pageID, 'Props', 'IsConfiguredDevice', fromMode])) {
            if (isManualMode && state.getIn(['pages', pageID, 'Props', 'isConfiguredAutoFit', fromMode])) {
              continue
            }
            break
          }
        }
      }
      let elements = retState.getIn(['pages', pageID, 'Props', 'elements'], Map())

      let isAutoFitComponent = (elem, elemUID) => {
        try {
          if (!elem || !elem.get('parent') || !elements.get(elem.get('parent'))) {
            return {
              status: false,
            }
          }
          let parentID = elem.get('parent')
          let parent = elements.get(parentID)

          if (parent.get('type') == 'Strip') {
            let colName = elem.getIn(['props', 'lg', 'gridArea'])
            if (elements.get(`fit_${parentID}_${colName}`)) {
              let children = elements.getIn([`fit_${parentID}_${colName}`, 'children'], List())
              children = children.push(elemUID)
              elements = elements.setIn([`fit_${parentID}_${colName}`, 'children'], children)
              elem = elem.setIn(['props', toMode, 'gridArea'], 'ft_auto_fit')
              elem = elem.setIn(['props', toMode, 'isConfiguredAutoFit'], true)
              return {
                status: true,
                elem: elem,
                elements: elements,
              }
            }
          } else if (TAB_TYPES.includes(parent.get('type'))) {
            let isFound = false
            let tabs = parent.getIn(['props', toMode, 'tabs'], List())
            tabs = tabs.map((tab) => {
              let tabChildren = tab.getIn(['children'], List())
              if (tab && tabChildren.includes(elemUID)) {
                tabChildren = tabChildren.filter((uid) => {
                  return uid != elemUID
                })
                tab = tab.setIn(['children'], tabChildren)
                if (elements.get(`fit_tab_${parentID}_${tab.get('uid')}`)) {
                  let children = elements.getIn([`fit_tab_${parentID}_${tab.get('uid')}`, 'children'], List())
                  children = children.push(elemUID)
                  elements = elements.setIn([`fit_tab_${parentID}_${tab.get('uid')}`, 'children'], children)
                  elem = elem.setIn(['props', toMode, 'isConfiguredAutoFit'], true)
                  isFound = true
                }
              }
              return tab
            })

            if (isFound) {
              elements = elements.setIn([parentID, 'props', toMode, 'tabs'], tabs)
              return {
                status: true,
                elem: elem,
                elements: elements,
              }
            }
          }
        } catch (err) {
          console.error(err)
        }
        return {
          status: false,
        }
      }

      function processElements(elem, elemUID) {
        if (!elements.get(elemUID)) {
          return elem
        }
        elem = elements.get(elemUID)
        if (String(elemUID).indexOf('fit_') > -1) {
          elem = elem.setIn(['props', toMode, 'gridArea'], 'none')
          return elem
        }
        const animationKeys = ['duration', 'delay', 'offset']
        _.each(animationKeys, (key) => {
          if (elem.hasIn(['props', fromMode, 'animation', key])) {
            if (!elem.hasIn(['props', toMode, 'animation', key]) || isInheritContent) {
              elem = elem.setIn(['props', toMode, 'animation', key], elem.getIn(['props', fromMode, 'animation', key]))
            }
          }
        })
        _.each(['in', 'out'], (key) => {
          if (elem.hasIn(['props', fromMode, 'animation', key, 'type'])) {
            if (!elem.hasIn(['props', toMode, 'animation', key, 'type']) || isInheritContent) {
              elem = elem.setIn(
                ['props', toMode, 'animation', key, 'type'],
                elem.getIn(['props', fromMode, 'animation', key, 'type'])
              )
            }
          }
        })
        let isProcessLoop = true,
          isProcessAutoFit = retState.getIn(['pages', pageID, 'Props', 'isConfiguredAutoFit', toMode], false)
        if (elem.hasIn(['props', toMode]) && elem.getIn(['props', toMode]).size > 1) {
          isProcessAutoFit = false
        }
        if (elem.get('type') === 'Widget' && elem.getIn(['props', 'data', 'Type']) === 'chart') {
          elem.getIn(['props', 'data', 'Props', fromMode], Map()).map((v, k) => {
            if (!elem.hasIn(['props', 'data', 'Props', toMode, k])) {
              elem = elem.setIn(['props', 'data', 'Props', toMode, k], v)
            }
          })
        }
        if (elem.get('type') === 'PowerTable') {
          if (elem.getIn(['props', toMode, 'isConfigured'])) {
            isProcessLoop = false
          } else {
            elem = elem.setIn(['props', toMode, 'isConfigured'], true)

            try {
              const processColumn = (col) => {
                if (Map.isMap(col.get('isVisible')) && col.getIn(['isVisible', toMode]) === undefined) {
                  col = col.setIn(['isVisible', toMode], col.getIn(['isVisible', fromMode]))
                }
                if (col.getIn(['meta', 'subCtrl', 'Props', 'columns'], List()).size > 0) {
                  return col.setIn(
                    ['meta', 'subCtrl', 'Props', 'columns'],
                    col.getIn(['meta', 'subCtrl', 'Props', 'columns'], List()).map(processColumn)
                  )
                }
                return col
              }

              elem = elem.setIn(['props', 'columns'], elem.getIn(['props', 'columns'], List()).map(processColumn))
            } catch (error) {
              console.error(error)
            }
          }
        }
        if (keep === 'none' && elem.hasIn(['props', fromMode, 'position', 'floatType'])) {
          if (!elem.hasIn(['props', toMode, 'position', 'floatType']) || isInheritStyle) {
            elem = elem.setIn(
              ['props', toMode, 'position', 'floatType'],
              elem.getIn(['props', fromMode, 'position', 'floatType'])
            )
          }
        }
        if (keep === 'none' && elem.hasIn(['props', fromMode, 'position', 'floatPosition'])) {
          if (!elem.hasIn(['props', toMode, 'position', 'floatPosition']) || isInheritStyle) {
            elem = elem.setIn(
              ['props', toMode, 'position', 'floatPosition'],
              elem.getIn(['props', fromMode, 'position', 'floatPosition'])
            )
          }
        }
        if (keep === 'none' && !elem.hasIn(['props', fromMode, 'isHidden'])) {
          if (!elem.hasIn(['props', toMode, 'isHidden']) || isInheritContent) {
            elem = elem.setIn(['props', toMode, 'isHidden'], elem.hasIn(['props', fromMode, 'isHidden'], false))
          }
        }
        if (isProcessLoop) {
          elem.getIn(['props', fromMode], Map()).map((v, k) => {
            if (elem.get('type') === 'Tab') {
              if (toMode != 'lg' && toMode != 'md' && toMode != 'sml') {
                elem = elem.setIn(['props', toMode, 'isVerticalTab'], false)
              }
            }
            if (!(elem.get('type') === 'Form' && ['cols', 'children'].includes(k))) {
              if (
                (!elem.hasIn(['props', toMode, k]) || (isInheritContent && k !== 'gridArea')) &&
                k !== 'isConfiguredAutoFit' &&
                k !== 'IsConfiguredDevice'
              ) {
                if (
                  (['position', 'isHidden', 'isHideIcons', 'isHideDescr', 'hideOnPage'].includes(k) ||
                    _.startsWith(k, 'isHiddenCol')) &&
                  keep !== 'none'
                ) {
                } else {
                  elem = elem.setIn(['props', toMode, k], v)
                }
              }
            }
          })
        }
        if (elem.get('type') === 'PowerTable') {
          let cols = toJS(elem.getIn(['props', 'columns'], Map())) || {}
          _.each(cols, function (col) {
            if (col && col.isVisible && typeof col.isVisible == 'object') {
              if (col.isVisible[toMode] === undefined || isInheritContent) {
                col.isVisible[toMode] = col.isVisible[fromMode]
              }
            }
            if (col && !col.meta) {
              col.meta = {}
            }
            if (!col.meta.device) {
              col.meta.device = {}
            }
            if (col && (typeof col?.meta?.device?.[toMode] === 'undefined' || isInheritContent)) {
              if (typeof col?.meta?.device?.[fromMode] !== 'undefined') {
                col.meta.device[toMode] = col.meta.device[fromMode]
                if (!_.size(col.meta.device[toMode])) {
                  col.meta.device[toMode].isHidden = false
                }
              } else {
                col.meta.device[toMode] = {
                  isHidden: false,
                }
              }
            }
          })
          elem = elem.setIn(['props', 'columns'], fromJS(cols))
        } else if (elem.get('type') === 'Form') {
          let children = toJS(elem.getIn(['props', fromMode, 'children'], Map())) || {}
          const cols = ~~elem.getIn(['props', fromMode, 'cols'], '1')
          if (cols > 2 && toMode === 'sm' && (!elem.hasIn(['props', toMode, 'children']) || isInheritContent)) {
            let nextChildren = {}
            const rows = _.keys(children)
            let index = 0
            _.each(children, (child, id) => {
              if (child) {
                child.id = id
              }
            })
            children = _.sortBy(children, function (row) {
              return parseInt(row.index)
            })
            _.each(children, (row, rowID) => {
              let cols = _.keys(_.get(row, 'children', {}))
              if (cols.length > 0) {
                if (row.isCustomMerged) {
                  let groups = {}
                  _.each(row.mergeList, (group, id) => {
                    groups[group] = groups[group] ?? []
                    groups[group].push(id)
                  })
                  _.each(groups, (list) => {
                    if (list.length > 1) {
                      let firstCol = _.minBy(
                        list,
                        (id) => row.children?.[id]?.index ?? _.size(row.children?.[id]?.children)
                      )
                      _.each(list, (id) => {
                        if (id !== firstCol) {
                          let child = row.children?.[id]?.children || []
                          let allChild = row.children?.[firstCol]?.children || []
                          _.set(
                            row,
                            ['children', firstCol, 'children'],
                            _.compact(_.uniq(_.concat([], allChild, child)))
                          )
                          _.unset(row, ['children', id])
                        }
                      })
                    }
                  })
                } else if (row.isMerged) {
                  let cols = _.keys(row.children)
                  let firstCol = _.minBy(cols, (id) => row.children?.[id]?.index)
                  _.each(cols, (id) => {
                    if (id !== firstCol) {
                      let child = _.get(row, ['children', id, 'children'], [])
                      _.set(
                        row,
                        ['children', firstCol, 'children'],
                        _.compact(_.uniq(_.concat([], child, _.get(row, ['children', firstCol, 'children'], []))))
                      )
                      _.unset(row, ['children', id])
                    }
                  })
                }
                let childList = _.get(row, 'children', {})
                _.each(childList, function (col, colId) {
                  if (col) {
                    col.id = colId
                  }
                })
                let rowChild = _.sortBy(childList, function (col) {
                  return parseInt(col.index)
                })
                _.each(rowChild, (col, colIndex) => {
                  col.children = _.filter(col?.children, (id) => elements.hasIn([id]))
                  if (colIndex > 0 && row.isMerged && _.size(col?.children) === 0) {
                    return null
                  }
                  let colID = col.id
                  delete col.id
                  let id = rows[index]
                  if (!Boolean(rows[index])) {
                    id = uidGen.genID('row')
                  }
                  nextChildren[id] = {
                    index,
                    originRow: row.id,
                    tag: row.tag,
                    children: {
                      [colID]: col,
                    },
                  }
                  index++
                })
              }
            })
            if (
              !elem.hasIn(['props', toMode, 'children']) ||
              isInheritContent ||
              _.size(toJS(elem.hasIn(['props', toMode, 'children']))) === 0
            ) {
              elem = elem.setIn(['props', toMode, 'children'], fromJS(nextChildren))
            }
            elem = elem.setIn(['props', toMode, 'rows'], String(_.size(_.keys(nextChildren))))
            elem = elem.setIn(['props', toMode, 'cols'], '1')
            elements = elements.setIn([elemUID], elem)
          } else if (
            cols > 1 &&
            ['xs', 'ss'].indexOf(toMode) !== -1 &&
            (!elem.hasIn(['props', toMode, 'children']) || isInheritContent)
          ) {
            let nextChildren = {}
            const rows = _.keys(children)
            let index = 0
            _.each(children, (child, id) => {
              if (child) {
                child.id = id
              }
            })
            children = _.sortBy(children, function (row) {
              return parseInt(row.index)
            })
            _.each(children, (row, rowID) => {
              if (row.isCustomMerged) {
                let groups = {}
                _.each(row.mergeList, (group, id) => {
                  groups[group] = groups[group] ?? []
                  groups[group].push(id)
                })
                _.each(groups, (list) => {
                  if (list.length > 1) {
                    let firstCol = _.minBy(
                      list,
                      (id) => row.children?.[id]?.index ?? _.size(row.children?.[id]?.children)
                    )
                    _.each(list, (id) => {
                      if (id !== firstCol) {
                        let child = row.children?.[id]?.children || []
                        let allChild = row.children?.[firstCol]?.children || []
                        _.set(row, ['children', firstCol, 'children'], _.compact(_.uniq(_.concat([], allChild, child))))
                        _.unset(row, ['children', id])
                      }
                    })
                  }
                })
              } else if (row.isMerged) {
                let cols = _.keys(row.children)
                let firstCol = _.minBy(cols, (id) => row.children?.[id]?.index)
                _.each(cols, (id) => {
                  if (id !== firstCol) {
                    let child = _.get(row, ['children', id, 'children'], [])
                    _.set(
                      row,
                      ['children', firstCol, 'children'],
                      _.compact(_.uniq(_.concat([], child, _.get(row, ['children', firstCol, 'children'], []))))
                    )
                    _.unset(row, ['children', id])
                  }
                })
              }
              let cols = _.keys(_.get(row, 'children', {}))
              if (cols.length > 0) {
                let childList = _.get(row, 'children', {})
                _.each(childList, function (col, colId) {
                  if (col) {
                    col.id = colId
                  }
                })
                let rowChild = _.sortBy(childList, function (col) {
                  return parseInt(col.index)
                })
                _.each(rowChild, (col, colIndex) => {
                  col.children = _.filter(col?.children, (id) => elements.hasIn([id]))
                  if (row.isMerged) {
                    if (colIndex > 0 && _.size(col.children) === 0) {
                      return true
                    }
                  }
                  let colID = col.id
                  delete col.id
                  let id = rows[index]
                  if (!Boolean(rows[index])) {
                    id = uidGen.genID('row')
                  }
                  nextChildren[id] = {
                    index,
                    originRow: row.id,
                    tag: row.tag,
                    children: {
                      [colID]: col,
                    },
                  }
                  index++
                })
              }
            })
            if (
              !elem.hasIn(['props', toMode, 'children']) ||
              isInheritContent ||
              _.size(toJS(elem.hasIn(['props', toMode, 'children']))) === 0
            ) {
              elem = elem.setIn(['props', toMode, 'children'], fromJS(nextChildren))
            }
            elem = elem.setIn(['props', toMode, 'rows'], String(_.size(_.keys(nextChildren))))
            elem = elem.setIn(['props', toMode, 'cols'], '1')
            elements = elements.setIn([elemUID], elem)
          }
          if (!elem.hasIn(['props', toMode, 'children']) || isInheritContent) {
            elem = elem
              .setIn(['props', toMode, 'children'], fromJS(children))
              .setIn(['props', toMode, 'rows'], String(_.size(_.keys(children))))
              .setIn(['props', toMode, 'cols'], elem.getIn(['props', fromMode, 'cols'], '1'))
          }
          const allChildren = toJS(elem.getIn(['children'], List())) || []
          let missingChildren = []
          let presentChildren = []
          elem = elem.setIn(
            ['props', toMode, 'children'],
            elem.getIn(['props', toMode, 'children'], Map()).delete('undefined')
          )
          elem.getIn(['props', toMode, 'children'], Map()).map((child, id) => {
            child.get('children', Map()).map((col, colID) => {
              presentChildren = [...presentChildren, ...(toJS(col.get('children', List())) || [])]
            })
          })
          missingChildren = _.difference(allChildren, presentChildren)
          if (missingChildren.length > 0) {
            // rowsSize = current number of rows; serves as the next free sequential position.
            // Setting index = rowsSize appends the new row after existing rows, then we increment
            // so each appended row receives a unique, increasing index.
            let rowsSize = elem.getIn(['props', toMode, 'children'], Map()).size         
            const isValidId = (id) => !_.isNil(id) && String(id) !== 'undefined'
            _.each(missingChildren, (missId) => {
              const colChildren =
                isValidId(missId) ? [missId] : []
              const row = {
                // assign the next free sequential position
                index: rowsSize,
                children: {
                  [uidGen.genID('col')]: {
                    index: 0, // to avoid NAN in an empty column header
                    children: colChildren,
                  },
                },
                isMerged: true,
              }
              elem = elem.setIn(['props', toMode, 'children', uidGen.genID('row')], fromJS(row))
              // increment to advance the index for the next appended row
              rowsSize = rowsSize + 1
            })
            elem = elem.setIn(['props', toMode, 'rows'], String(rowsSize))
          }
        } else if (TAB_TYPES.includes(elem.get('type'))) {
          let tabs = toJS(elem.getIn(['props', 'lg', 'tabs'], List())) || []
          if (elem.hasIn(['props', toMode, 'tabs'])) {
            _.each(toJS(elem.getIn(['props', toMode, 'tabs'], List())), (tab) => {
              let lgTabIndex = _.findIndex(tabs, (v) => v.id === tab.id)
              if (lgTabIndex !== -1) {
                tabs[lgTabIndex].info = jsMergeDeep(tabs[lgTabIndex].info, tab.info)
              }
            })
          }
          if (!elem.getIn(['props', toMode, 'isConfiguredAutoFit'], false)) {
            if (!elem.hasIn(['props', toMode, 'tabs']) || isInheritContent) {
              elem = elem.setIn(['props', toMode, 'tabs'], fromJS(tabs))
            } else if (!elem.hasIn(['props', toMode, 'tabs'], List())?.size) {
              elem = elem.setIn(['props', toMode, 'tabs'], fromJS(tabs))
            }
          }
          elements = elements.setIn([elemUID], elem)
        }

        if (isProcessAutoFit) {
          let result = isAutoFitComponent(elem, elemUID)
          if (result.status) {
            elem = result.elem
            elements = result.elements
          }
        }

        elem = copyPropertiesToDevice(
          elem,
          toMode,
          false,
          isInheritContent,
          state.getIn(['pages', pageID, 'Props', 'IsConfiguredDevice'], Map())
        )

        if (elem.get('type') === 'Animation') {
          let lgOptions = elem.getIn(['props', 'lg', 'options'], List())
          let toModeOptions = elem.getIn(['props', toMode, 'options'], List())
          const imagesHash = lgOptions.reduce(
            (r, v) => ({
              ...r,
              [v.get('id')]:
                v.get('type', 'img') === 'lottie'
                  ? v.get('code', '')
                  : v.get('type', 'img') === 'img'
                    ? v.get('src')
                    : v.get('svg'),
            }),
            {}
          )
          toModeOptions = toModeOptions.map((option) => {
            if (option.get('type') === 'lottie') {
              const code = option.get('code', '')
              if (imagesHash[option.get('id')] === code) {
                return option.set('code', 'LG_DEVICE')
              }
            } else if (option.get('type') === 'svg') {
              const svg = option.get('svg', '')
              if (imagesHash[option.get('id')] === svg) {
                return option.set('svg', 'LG_DEVICE')
              }
            }
            return option
          })
          elem = elem.setIn(['props', toMode, 'options'], toModeOptions)
        }

        elements = elements.setIn([elemUID], elem)
        return elem
      }

      if (!isDevPage) {
        elements.map(processElements)
        retState = retState.setIn(['pages', pageID, 'Props', 'elements'], elements)
      }
      const projectType = retState.getIn(['project', 'ProjectType'], 'web')
      const isSurvey = ['survey', 'surveyEmail'].includes(projectType)

      const styleMapperFn = (style, styleID) => {
        let ret = style
        if (!ret.getIn(['IsConfiguredDevice', toMode]) || (isInheritStyle && !_.startsWith(styleID, 'fit_'))) {
          let localFromMode = fromMode
          if (!ret.getIn(['IsConfiguredDevice', localFromMode])) {
            let elemFromModes = LAYOUT_MODE.slice(0, LAYOUT_MODE.indexOf(localFromMode) + 1)
            elemFromModes = elemFromModes.reverse()
            for (let i = 0; i < elemFromModes.length; i++) {
              let tmpFrom = elemFromModes[i]
              if (ret.getIn(['IsConfiguredDevice', toMode]) || tmpFrom == 'lg') {
                localFromMode = tmpFrom
                break
              }
            }
          }

          isStyleCopied = true
          if (style.get('type') !== 'Strip') {
            ret = ret.setIn(['IsConfiguredDevice', toMode], true)
          }
          let fromModeStyles = ret.get(localFromMode, Map())
          if (isInheritStyle) {
            const toModeStyle = style.get(toMode, Map())
            const processKeepSizes =
              (path = []) =>
              (style, key) => {
                if (isImmutable(style) && key !== 'areas') {
                  return style.map(processKeepSizes([...path, key]))
                } else if (ALL_SIZE_KEYS_WITH_FONT.includes(key) || _.startsWith(key, 'row')) {
                  let keepValue = toModeStyle.getIn([...path, key])
                  return keepValue
                } else {
                  return style
                }
              }
            fromModeStyles = deepMergeOverrideArrays(toModeStyle, fromModeStyles).map(processKeepSizes())
          }
          if (style.get('type') === 'Strip') {
            const toModeStyles = style.get(toMode, Map())
            const mergedStyles = deepMergeOverrideArrays(fromModeStyles, toModeStyles)
            ret = ret.set(toMode, mergedStyles)
          } else {
            ret = ret.set(toMode, fromModeStyles)
          }

          if (style.get('type') === 'Strip') {
            const areas = style.getIn([localFromMode, 'areas'], List())
            if (areas && isImmutable(areas)) {
              areas.forEach((row) => {
                if (row && isImmutable(row)) {
                  row.forEach((col) => {
                    const colStyle = style.getIn([localFromMode, `ft__${col}`], Map())
                    const toModeStyle = ret.getIn([toMode, `ft__${col}`], Map())
                    const mergedStyles = deepMergeOverrideArrays(colStyle, toModeStyle)
                    ret = ret.setIn([toMode, `ft__${col}`], mergedStyles)
                  })
                }
              })
            }
            if (localFromMode === 'lg' || localFromMode === 'md' || localFromMode === 'sml') {
              if (['sm', 'xs', 'ss'].indexOf(toMode) !== -1) {
                const areas = style.getIn([localFromMode, 'areas'], List())
                const areasJS = _.flatten(toJS(areas))
                const areasChunk = _.chunk(areasJS, 1)

                ret = ret.set(
                  toMode,
                  ret.get(toMode, Map()).filter((v, k) => !_.startsWith(k, 'column'))
                )

                ret = ret
                  .setIn([toMode, 'areas'], fromJS(areasChunk))
                  .setIn([toMode, 'rows'], areasChunk.length)
                  .setIn([toMode, 'columns'], '1')
              }
            }
          } else if (isSurvey && style.get('type') === 'Image' && !isInheritStyle) {
            if (!ret.getIn([toMode, 'root', 'height'])) {
              ret = ret.setIn([toMode, 'root', 'height'], 'auto')
            }
          }

          if (ret.has('isGrow') && !isInheritStyle) {
            const grow = ret.get('isGrow', Map()).map((area) => area.set(toMode, area.get(localFromMode)))
            ret = ret.set('isGrow', grow)
          }

          if (!isInheritStyle) {
            let isHidden = ret.getIn(['isHidden'], Map()).set(toMode, ret.getIn(['isHidden', localFromMode]))

            isHidden = isHidden.map((val) => {
              if (Map.isMap(val)) {
                return val.set(toMode, val.get(localFromMode))
              } else {
                return val
              }
            })

            ret = ret.setIn(['isHidden'], isHidden)
          }
        }

        //when switch device, but missing strip areas list, force copy it from
        try {
          if (
            (style.get('type') === 'Strip' && ret.getIn([toMode, 'areas'], List()).size === 0) ||
            !List.isList(ret.getIn([toMode, 'areas'], List()))
          ) {
            const modesToCheck = [...parentModes.reverse()]
            _.each(modesToCheck, (mode) => {
              let areas = ret.getIn([mode, 'areas'], List())
              const isMobileMode = ['sm', 'xs', 'ss'].includes(mode)
              if (isMobileMode) {
                const plainAreas = _.flatten(areas.toJS())
                areas = fromJS(plainAreas, (r, v) => [...r, v], [])
              }
              if (areas.size > 0) {
                ret = ret
                  .setIn([toMode, 'areas'], areas)
                  .setIn([toMode, 'rows'], areas.size)
                  .setIn([toMode, 'columns'], areas.get(0, List()).size)
                return false
              }
            })
          }
        } catch (error) {
          console.error(error)
        }

        return ret
      }

      retState = retState.setIn(
        ['pages', pageID, 'Props', 'styles'],
        retState.getIn(['pages', pageID, 'Props', 'styles'], Map()).map(styleMapperFn)
      )

      elements = retState.getIn(['project', 'Settings', 'elements'], Map())
      elements.map(processElements)

      retState = retState.setIn(
        ['project', 'Settings', 'styles'],
        retState.getIn(['project', 'Settings', 'styles'], Map()).map(styleMapperFn)
      )

      let isHideHeader = retState.getIn(['pages', pageID, 'Props', 'isHideHeader', fromMode], false)
      if (retState.getIn(['pages', pageID, 'Props', 'isHideHeader', toMode]) === undefined) {
        retState = retState.setIn(['pages', pageID, 'Props', 'isHideHeader', toMode], isHideHeader)
      }
      retState = retState.setIn(['project', 'Settings', 'elements'], elements)
      if (!retState.getIn(['project', 'Settings', 'theme', toMode, 'Header', 'IsConfiguredDevice'], false)) {
        _.each(['Header', 'Drawer', 'Footer', 'Window', 'Page'], (key) => {
          let style = retState.getIn(['project', 'Settings', 'theme', fromMode, key], Map())
          if (key === 'Page') {
            style = style.set(
              'root',
              style.get('root', Map()).filter((v, k) => ['width', 'widthUnit'].indexOf(k) == -1)
            )
          }
          if (key === 'Header' || key === 'Footer') {
            style = style.setIn(['IsConfiguredDevice'], false)
            if (toMode !== 'lg') {
              style = style
                .setIn(['root', 'widthUnit'], 'px')
                .setIn(['root', 'marginLeft'], 'auto')
                .setIn(['root', 'marginRight'], 'auto')
                .setIn(['root', 'width'], DEVICE_DEFAULT_MAX_SIZE[toMode])
            }
          }
          retState = retState.setIn(['project', 'Settings', 'theme', toMode, key], style)
        })
      }

      if (isStyleCopied) {
        retState = retState.setIn(['isProjectChanged'], true).setIn(['isPageChanged'], true)
      }

      let themeUI = retState.getIn(['project', 'Settings', 'SmartV', 'ui'], Map())
      if (themeUI.size > 0) {
        for (let i = parentModes.length - 1; i >= 0; i--) {
          if (parentModes[i] !== toMode) {
            fromMode = parentModes[i]

            if (fromMode == 'lg') {
              break
            }
            if (themeUI.getIn(['IsConfiguredDevice', fromMode])) {
              break
            }
          }
        }
        themeUI = themeUI.map((style, key) => {
          let fromStyle = style.get(fromMode, Map())
          let toStyle = style.get(toMode, Map())
          return ['IsConfiguredDevice', 'isConfiguredAutoFit'].includes(key)
            ? style
            : style.set(toMode, deepMergeOverrideArrays(fromStyle, toStyle))
        })
        themeUI = themeUI.setIn(['IsConfiguredDevice', toMode], true)
        retState = retState.setIn(['project', 'Settings', 'SmartV', 'ui'], themeUI)
      }

      return retState.setIn(['project', 'Settings', 'lastID'], uidGen.lastID)
    }
    case actionTypes.REPOSITION_ELEMENTS_ON_DROP: {
      return action.payload.state
    }
    case actionTypes.CHANGE_BACKDROP_STATUS: {
      return state.setIn(['backdropStatus'], action.payload.backdropStatus)
    }
    case actionTypes.PROJECT_BUILDER_CHANGE_ACTIVE_PAGE:
      return disableHistory(state)
        .setIn(['devPage'], action.payload.page)
        .setIn(['isPageChanged'], false)
        .setIn(['panels', 'elemenSettings'], Map())
        .setIn(['panels', 'elementStyle'], Map())
    case actionTypes.PROJECT_CHANGE_MODAL_STATE: {
      return state.setIn(['panels', action.payload.modal], fromJS(action.payload.state))
    }
    case actionTypes.PROJECT_CHANGE_UI_ADD_WIDGET: {
      return state.setIn(['panels', 'confWidgetEl'], fromJS(action.payload.props))
    }
    case actionTypes.PROJECT_SET_UI_ADD_WIDGET: {
      const { type, uid, area, left, top, subType, isShiftKey, column } = action.payload
      let retState = state.setIn(
        ['panels', 'confWidgetEl'],
        Map({
          show: true,
          mode: 'create',
          type,
          uid,
          area,
          left,
          top,
          subType,
          isShiftKey,
          column,
        })
      )
      if (!retState.setIn(['panels', 'elements', 'pin'], false)) {
        retState = retState.setIn(['panels', 'elements', 'show'], false)
      }

      return retState
    }
    case actionTypes.PROJECT_APPLY_THEME: {
      return action.payload.store
    }
    case actionTypes.BUILDER_CLR_UI_STATE: {
      return disableHistory(state).set(
        'panels',
        Map({
          view: true,
        })
      )
    }
    case actionTypes.PROJECT_PROCESS_COND_QUE_CACHE: {
      let retState = state
      let __cond__cache__ = retState.getIn(['__cond__cache__'], Map())
      const smartVParams = _.get(getPreviewDynamicData(), 'svParams', {})
      retState = retState.setIn(['__cond__cache__', 'processed'], Map())
      let processedList = __cond__cache__.get('processed', Map())
      if (!processedList.size) {
        __cond__cache__.set('processed', __cond__cache__.get('list'))
      }
      const oldState = state.get('prevRulesState', Map()).toJS()
      const oldParams = state.get('prevRulesParams', Map()).toJS()

      __cond__cache__.get('processed', Map()).map((val, key) => {
        let isNeedProcess = true
        if (retState.getIn(['__cond__cache__', 'nodes', key], List()).size > 0) {
          retState.getIn(['__cond__cache__', 'nodes', key], List()).map((conf) => {
            retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).push(conf))
          })
          retState = retState.deleteIn(['__cond__cache__', 'nodes', key])
        } else {
          let rules = retState.getIn(['__cond__cache__', 'list', key], List())
          while (rules.size && isNeedProcess) {
            let processRule = rules.get(0, Map())
            rules = rules.remove(0)
            retState = retState.setIn(['__cond__cache__', 'list', key], rules)
            if (processRule.get('isActionRule')) {
              retState = processSingleRule(
                fromJS({
                  isActionRule: processRule.get('isActionRule'),
                  isTableRule: processRule.get('isTableRule'),
                  options: processRule.getIn(['options'], Map()),
                  action: fromJS([processRule.get('providedCurrentRule', Map())]),
                  index: processRule.get('index'),
                }),
                processRule.get('path', List()).toJS(),
                retState.getIn(['state'], Map()).toJS(),
                getParams(retState),
                smartVParams,
                retState,
                processRule.get('isOnlyEffects'),
                processRule.get('isOnload'),
                oldState,
                oldParams,
                processRule.get('fullPath', List()).toJS(),
                key
              )
            } else {
              retState = processSingleRule(
                processRule.get('providedCurrentRule', Map()),
                processRule.get('path', List()).toJS(),
                retState.getIn(['state'], Map()).toJS(),
                getParams(retState),
                smartVParams,
                retState,
                processRule.get('isOnlyEffects'),
                processRule.get('isOnload'),
                oldState,
                oldParams,
                processRule.get('fullPath', List()).toJS(),
                key
              )
            }
            isNeedProcess = isNeedProcessQueCondition(retState, key)
          }
        }
      })
      retState = resetLoadingFlags(retState)
      return retState
    }
    case actionTypes.PROJECT_PROCESS_COND_CACHE: {
      const cache = state.getIn(['__cache__'], List())
      let retState = state.setIn(
        ['__cache__'],
        cache.filter((v) => !STATIC_COND_CACHE.includes(v.get('type')))
      )
      const redirect = cache.findLast((el) => el.get('type') === 'redirectToPage')
      const profileRedirect = cache.findLast((el) => el.get('type') === 'redirectToProfile')
      let isCartEmpty = false
      const catalogRedirect = cache.findLast((el) => {
        if (el.get('type') === 'redirectToCatalog') {
          isCartEmpty = el.get('isCartEmpty', false)
          return true
        } else {
          return false
        }
      })
      const cartRedirect = cache.findLast((el) => el.get('type') === 'redirectToCart')
      const productRedirect = cache.findLast((el) => el.get('type') === 'redirectToProduct')
      const checkoutRedirect = cache.findLast((el) => el.get('type') === 'redirectToCheckout')
      let loginRedirect = cache.findLast((el) => el.get('type') === 'redirectToLogin')
      const registrationRedirect = cache.findLast((el) => el.get('type') === 'redirectToRegistration')
      cache.map((entry) => {
        switch (entry.get('type')) {
          case 'redirect':
            const target = entry.getIn(['payload', 'target'])
            if (target === 'modal') {
              let params = entry.getIn(['payload', 'params'], Map()).toJS()

              let isPrivateModal = false
              if (!entry.getIn(['payload', 'isExternal'], false)) {
                if (
                  state.getIn(['project', 'Settings', 'isTokenPrivate'], false) &&
                  get(getPreviewDynamicData(), ['ssoParams', 'data', 'isTokenAuth'])
                ) {
                  isPrivateModal = true
                } else if (state.getIn(['project', 'Settings', 'isSSOPrivate'], false)) {
                  isPrivateModal = true
                }
              }
              if (isPrivateModal) {
                retState = retState.setIn(
                  ['__cache__'],
                  retState.getIn(['__cache__'], List()).push(
                    fromJS({
                      type: 'OpenPrivateModal',
                      payload: {
                        url: entry.getIn(['payload', 'uri']),
                        width: entry.getIn(['payload', 'width'], ''),
                        height: entry.getIn(['payload', 'height'], ''),
                        hideMenu: entry.getIn(['payload', 'hideMenu'], ''),
                        positionOfModal: entry.getIn(['payload', 'positionOfModal'], 'center'),
                        forceEmbedPosition: entry.getIn(['payload', 'forceEmbedPosition'], false),
                        isExternal: entry.getIn(['payload', 'isExternal'], false),
                        isScrolling: entry.getIn(['payload', 'isScrolling'], false),
                        isHideHeader: entry.getIn(['payload', 'isHideHeader'], false),
                        top: entry.getIn(['payload', 'top']),
                        clientY: entry.getIn(['payload', 'clientY']),
                        params: params,
                      },
                    })
                  )
                )
              } else {
                retState = retState
                  .setIn(
                    ['widgets', 'RedirectModal', 'allowCustomTitle'],
                    entry.getIn(['payload', 'allowCustomTitle'], false)
                  )
                  .setIn(['widgets', 'RedirectModal', 'modalTitle'], entry.getIn(['payload', 'modalTitle'], ''))
                  .setIn(['widgets', 'RedirectModal', 'needShow'], true)
                  .setIn(
                    ['widgets', 'RedirectModal', 'params'],
                    fromJS({
                      url: entry.getIn(['payload', 'uri']),
                      width: entry.getIn(['payload', 'width'], ''),
                      height: entry.getIn(['payload', 'height'], ''),
                      hideMenu: entry.getIn(['payload', 'hideMenu'], ''),
                      positionOfModal: entry.getIn(['payload', 'positionOfModal'], 'center'),
                      forceEmbedPosition: entry.getIn(['payload', 'forceEmbedPosition'], false),
                      isExternal: entry.getIn(['payload', 'isExternal'], false),
                      isScrolling: entry.getIn(['payload', 'isScrolling'], false),
                      isHideHeader: entry.getIn(['payload', 'isHideHeader'], false),
                      top: entry.getIn(['payload', 'top']),
                      clientY: entry.getIn(['payload', 'clientY']),
                      params: params,
                    })
                  )
              }
            } else {
              setTimeout(
                (otherURL) => {
                  if (target === 'top') {
                    try {
                      if (window.top) {
                        window.top.location.href = otherURL
                      }
                    } catch (err) {
                      window.location.href = otherURL
                    }
                  } else if (target === 'self') {
                    window.location.href = otherURL
                  } else if (target === 'parent') {
                    try {
                      if (window.parent) {
                        window.parent.location.href = otherURL
                      }
                    } catch (err) {
                      console.error(err)
                    }
                  } else if (target === 'blank' || target === '_blank') {
                    window.open(otherURL, '_blank')
                  }
                },
                50,
                entry.getIn(['payload', 'uri'])
              )
            }
            break
          case 'msgDlg':
            retState = retState.setIn(
              ['dialog', 'messages'],
              retState.getIn(['dialog', 'messages'], List()).push(entry.get('payload', Map()))
            )
            break
          case 'confirmDlg':
            retState = retState.setIn(
              ['dialog', 'confirm'],
              retState.getIn(['dialog', 'confirm'], List()).push(entry.get('payload', Map()))
            )
            break
        }
      })

      let isUserSignIn = false
      try {
        isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
      } catch (err) {
        console.error(err)
      }
      const isPublic = state.getIn(['project', 'isPublic'], false)
      if (!isPublic && !isUserSignIn) {
        let eCommercePage
        if (cartRedirect) {
          eCommercePage = 'e_cart'
        } else if (productRedirect) {
          eCommercePage = 'e_product'
        } else if (checkoutRedirect) {
          eCommercePage = 'e_checkout'
        } else if (catalogRedirect) {
          eCommercePage = 'e_catalog'
        }
        if (eCommercePage) {
          let pageAccess = state.getIn(['project', 'Settings', 'eCommerce', 'pages', eCommercePage, 'access'])
          if (pageAccess != 'public') {
            loginRedirect = true
          }
        }
      }
      if (loginRedirect) {
        if (!isPublic) {
          window.__FT__PROCESS_REDIRECT = true
          try {
            requestAnimationFrame(() => {
              window.__FT_PROJECT__API__.goToPage('signin').then(() => {
                window.__FT__PROCESS_REDIRECT = false
              })
            })
          } catch (error) {
            window.__FT__PROCESS_REDIRECT = false
          }
        }
        return retState
      } else if (registrationRedirect) {
        if (!isPublic) {
          window.__FT__PROCESS_REDIRECT = true
          try {
            requestAnimationFrame(() => {
              window.__FT_PROJECT__API__.goToPage('register').then(() => {
                window.__FT__PROCESS_REDIRECT = false
              })
            })
          } catch (error) {
            window.__FT__PROCESS_REDIRECT = false
          }
        }
        return retState
      }
      if (profileRedirect) {
        return retState
      }
      if (catalogRedirect) {
        try {
          if (isCartEmpty) {
            if (retState.getIn(['state', 'eCommerce', 'e_cart'], List()).size) {
              return retState
            }
          }
          window.__FT__PROCESS_REDIRECT = true
          try {
            requestAnimationFrame(() => {
              window.__FT_PROJECT__API__.goToPage('e_catalog').then(() => {
                window.__FT__PROCESS_REDIRECT = false
              })
            })
          } catch (error) {
            window.__FT__PROCESS_REDIRECT = false
          }
        } catch (error) {
          console.error('cannot go to catalog page', error)
        }
        return retState
      }
      if (cartRedirect) {
        if (!retState.getIn(['state', 'eCommerce', 'e_cart'], List()).size) {
          return retState
        }
        try {
          window.__FT__PROCESS_REDIRECT = true
          try {
            requestAnimationFrame(() => {
              window.__FT_PROJECT__API__.goToPage('e_cart').then(() => {
                window.__FT__PROCESS_REDIRECT = false
              })
            })
          } catch (error) {
            window.__FT__PROCESS_REDIRECT = false
          }
        } catch (error) {
          console.error('cannot go to catalog page', error)
        }
        return retState
      }
      if (productRedirect) {
        try {
          window.__FT__PROCESS_REDIRECT = true
          try {
            requestAnimationFrame(() => {
              window.__FT_PROJECT__API__.goToPage('e_product').then(() => {
                window.__FT__PROCESS_REDIRECT = false
              })
            })
          } catch (error) {
            window.__FT__PROCESS_REDIRECT = false
          }
        } catch (error) {
          console.error('cannot go to catalog page', error)
        }
        return retState
      }
      if (checkoutRedirect) {
        if (!retState.getIn(['state', 'eCommerce', 'e_cart'], List()).size) {
          return retState
        }
        try {
          window.__FT__PROCESS_REDIRECT = true
          try {
            requestAnimationFrame(() => {
              window.__FT_PROJECT__API__.goToPage('e_checkout').then(() => {
                window.__FT__PROCESS_REDIRECT = false
              })
            })
          } catch (error) {
            window.__FT__PROCESS_REDIRECT = false
          }
        } catch (error) {
          console.error('cannot go to checkouts page', error)
        }
        return retState
      }
      if (redirect) {
        const processRedirect = (n = 0) => {
          if (n > 20) {
            window.__FT__PROCESS_REDIRECT = false
            return null
          }
          if (typeof window.__FT_PROJECT__API__?.goToPage === 'function') {
            window.__FT__PROCESS_REDIRECT = true
            try {
              requestAnimationFrame(() => {
                window.__FT_PROJECT__API__
                  .goToPage(
                    redirect.getIn(['payload', 'uid'], ''),
                    redirect.getIn(['payload', 'params'], ''),
                    redirect.getIn(['payload', 'isForce'], false)
                  )
                  .then(() => {
                    window.__FT__PROCESS_REDIRECT = false
                  })
              })
            } catch (error) {
              window.__FT__PROCESS_REDIRECT = false
            }
          } else {
            setTimeout(processRedirect, 100, n + 1)
          }
        }
        if (window.__FT__PROCESS_REDIRECT) {
          return retState
        }
        processRedirect(0)
      }
      return retState
    }
    case actionTypes.PROJECT_TOGGLE_DRAWER:
      return state.setIn(
        ['panels', 'drawer'],
        action.payload.status === null ? !state.getIn(['panels', 'drawer'], false) : Boolean(action.payload.status)
      )
    case actionTypes.PROJECT_SET_PREVIEW_PAGE_DATA: {
      let retState = state.set('pages', state.get('pages', Map()).merge(fromJS(action.payload.pages)))
      return processApplyOnloadACRules(retState, false, action.payload.pages)
    }
    case actionTypes.PROJECT_SET_RESET_PAGE_PARAMS: {
      let oldPageId = action.payload.currentPageID
      let newPageID = action.payload.goToPage
      if (!newPageID) {
        newPageID = state.get('page')
      }

      if (oldPageId == newPageID && !action.payload.isForce) {
        return state
      }

      let ssoData = _.get(getPreviewDynamicData(), ['ssoParams', 'data'], {})
      let oldPageUID, newPageUID
      state.getIn(['project', 'Pages'], List()).map((page) => {
        if (page.get('_id') == oldPageId) {
          oldPageUID = page.get('uid')
        }
        if (page.get('_id') == newPageID) {
          newPageUID = page.get('uid')
        }
      })
      let retState = state
      let changesPath = []
      if (oldPageUID) {
        retState = retState.setIn(['filter', oldPageUID], Map())
        let oldPage = state.getIn(['pages', oldPageId], Map())
        oldPage.getIn(['Props', 'params'], List()).map((param) => {
          changesPath.push([oldPageUID, param.get('id')])
          retState = retState.setIn(['state', oldPageUID, param.get('id')], '')
        })
        oldPage.getIn(['Props', 'elements'], List()).map((elem, uid) => {
          if (elem.get('type') == 'InteractiveDocument') {
            if (elem.getIn(['props', 'genSource']) != 'titan') {
              if (Map.isMap(retState.getIn(['state', oldPageUID], Map()))) {
                retState = retState.setIn(
                  ['state', oldPageUID],
                  retState.getIn(['state', oldPageUID], Map()).delete(uid)
                )
              }
            }
          }
          if (elem.get('type') == 'FormField') {
            if (elem.getIn(['props', 'control']) == 'fileupload') {
              try {
                if (window.__FT_PROJECT__API__FILES__ && window.__FT_PROJECT__API__FILES__.files) {
                  if (window.__FT_PROJECT__API__FILES__.files[uid]) {
                    window.__FT_PROJECT__API__FILES__.files[uid] = {}
                  }
                }
              } catch (err) {
                console.error('err >>> ', err)
              }
            }
            retState = retState.setIn(['state', oldPageUID], retState.getIn(['state', oldPageUID], Map()).delete(uid))
          } else if (elem.get('type') === 'Strip') {
            retState = retState.setIn(['state', oldPageUID], retState.getIn(['state', oldPageUID], Map()).delete(uid))
            retState = retState.setIn(
              ['formFieldStatuses', oldPageUID],
              retState.getIn(['formFieldStatuses', oldPageUID], Map()).delete(uid)
            )
          } else if (elem.get('type') === 'PowerTable') {
            let inputColumns = collectPowerTableInputColumn(elem)
            _.each(inputColumns, (colId) => {
              retState = retState.setIn(
                ['state', oldPageUID],
                retState.getIn(['state', oldPageUID, uid], Map()).delete(colId)
              )
            })
          } else if (elem.get('type') === 'BarcodeReader') {
            retState = retState.setIn(['state', oldPageUID], retState.getIn(['state', oldPageUID], Map()).delete(uid))
          }
        })

        retState = retState.setIn(['postMessagesTasks', oldPageUID], Map())
      }
      if (newPageUID) {
        let urlParams = parseURLParameters()
        let newPage = state.getIn(['pages', newPageID], Map())
        let hashSetValues = {}
        retState = retState.setIn(['filter', newPageUID], Map())
        retState.getIn(['pageJob'], List()).map((row) => {
          if (row.get('action') === 'set_page_params') {
            hashSetValues = {
              ...hashSetValues,
              ...row.get('params', Map()).toJS(),
            }
          }
        })
        try {
          let appendToURL = {}
          if (hashSetValues.ftcategory) {
            appendToURL.ftcategory = hashSetValues.ftcategory
            retState = retState.setIn(['state', 'eCommerce', 'selected', 'ftValue'], hashSetValues.ftcategory)
          }
          if (hashSetValues.ftsubcategory) {
            appendToURL.ftsubcategory = hashSetValues.ftsubcategory
            retState = retState.setIn(['state', 'eCommerce', 'subSelected', 'ftValue'], hashSetValues.ftsubcategory)
          }
          if (typeof window !== 'undefined' && typeof window?.history?.replaceState === 'function') {
            const redirectParams = []
            _.each(hashSetValues, (v, k) => redirectParams.push(`${k}=${encodeURIComponent(v)}`))
            ftReplaceState({}, '', concatParams(location.href, redirectParams.join('&')))
          }
        } catch (error) {
          console.error(error)
        }
        retState = retState.setIn(['pageJob'], List())
        newPage.getIn(['Props', 'params'], List()).map((param) => {
          changesPath.push([newPageUID, param.get('id')])
          let value = param.get('value', '')
          if (param.get('valueType', '') === 'system') {
            value = getSystemVariable(param.get('systemValue'), retState)
          } else if (hashSetValues[param.get('name')] !== null && hashSetValues[param.get('name')] !== undefined) {
            value = hashSetValues[param.get('name')]
          } else if (_.get(ssoData, [`${newPageUID}:${param.get('id')}`]) !== undefined) {
            value = _.get(ssoData, [`${newPageUID}:${param.get('id')}`])
          } else if (urlParams[param.get('name')] !== undefined) {
            value = urlParams[param.get('name')]
          }
          retState = retState.setIn(['state', newPageUID, param.get('id')], value)
        })

        const layoutMode = state.getIn(['layoutMode'], 'lg')
        let freshState = get(getPreviewDynamicData(), ['freshState'])
        if (freshState && freshState.isCustomDomainOpened !== undefined) {
          retState = retState.setIn(['project', 'Settings', 'isCustomDomainOpened'], freshState.isCustomDomainOpened)
        }

        let pageState = getPageState(newPageUID, newPage.toJS(), newPageID, layoutMode)

        if (retState.getIn(['project', 'ProjectType']) == 'survey') {
          try {
            let dynamicData = document.getElementById('__FT__STATIC__')
            if (dynamicData) {
              let dd = JSON.parse(dynamicData.textContent)
              if (dd && dd.surveyResponses && dd.surveyResponses.status) {
                pageState = getPageSurveyResumeState(retState, pageState, dd.surveyResponses.answers, newPageUID)
              }
            }
          } catch (err) {
            console.error(err)
          }
        }

        // Create fresh state for the new page similar to PROJECT_SET_PREVIEW_DATA
        const currentState = retState.getIn(['state'], Map()).toJS()
        if (pageState[newPageUID] && currentState[newPageUID]) {
          // Shallow merge: pageState values override currentState values for the same keys
          const merged = {
            ...currentState[newPageUID],
            ...pageState[newPageUID],
          }
          retState = retState.setIn(['state', newPageUID], fromJS(merged))
        } else {
          retState = retState.setIn(['state'], fromJS(jsMergeDeep(currentState, pageState)))
        }

        newPage.getIn(['Props', 'elements'], List()).map((elem, uid) => {
          if (_.get(ssoData, [`${newPageUID}:${uid}`]) !== undefined) {
            retState = retState.setIn(['state', newPageUID, uid], _.get(ssoData, [`${newPageUID}:${uid}`]))
          }
          if (elem.get('type') == 'FormField') {
            retState = retState.setIn(
              ['formFieldStatuses', newPageUID],
              retState.getIn(['formFieldStatuses', newPageUID], Map()).delete(uid)
            )
          }
        })
      }

      //no old page, it's onload action
      if (!oldPageId) {
        return retState
      }
      if (changesPath.length) {
        return doProcessRules(
          retState,
          Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
          [],
          [],
          changesPath,
          false,
          false
        )
      }
      return retState
    }
    case actionTypes.PROJECT_SET_IS_DISALLOW_PREVIEW: {
      return state.set('isDisallowProjectPreview', true)
    }
    case actionTypes.PROJECT_SET_PREVIEW_PAGE: {
      if (state.get('page') == action.payload.pageID && !action.payload.isForce) {
        return state
      }
      let projectPages = _.find(state.getIn(['project', 'Pages'], List()).toJS(), function (page) {
        return page && page._id == action.payload.pageID
      })
      if (state.getIn(['project', 'Settings', 'isTokenPrivate'], false)) {
        if (!get(getPreviewDynamicData(), ['ssoParams', 'data', 'isTokenAuth'])) {
          let retState = state.setIn(
            ['__cache__'],
            state.getIn(['__cache__'], List()).push(
              fromJS({
                type: 'redirectToDisabled',
                payload: {},
              })
            )
          )
          return retState
        }
      } else if (state.getIn(['project', 'Settings', 'isSSOPrivate'], false)) {
        if (projectPages && projectPages.access != 'public') {
          if (!get(getPreviewDynamicData(), ['ssoParams', 'data'])) {
            const projectID = state.getIn(['project', 'URL'])
            if (!IS_SERVER) {
              if (window.__FT_PROJECT__API__) {
                window.__FT_PROJECT__API__.FTRedirectToProjectURL(`/${projectPages.url}`)
              } else {
                window.location.href = `/ftproject/${projectID}/${projectPages.url}`
              }
            }
            return state
          }
        }
      }
      let pageDefaultRules = {}
      let rulesState = {}
      let retState = state
      try {
        const RepeatedStripsID = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
        const layoutMode = retState.getIn(['layoutMode'], 'lg')
        const pageID = action.payload.pageID
        retState.getIn(['project', 'Settings', 'elements'], Map()).map((iElem, elemUID) => {
          if (!Map.isMap(iElem)) {
            return true
          }
          const elem = iElem.toJS()
          let parentType = getParentIdInModal(
            retState,
            retState.getIn(['project', 'Settings', 'elements', elemUID, 'parent']),
            true
          )
          if (!['Header', 'Footer'].includes(elem.type) && ['Header', 'Footer'].includes(parentType)) {
            if (
              _.get(elem, ['props', layoutMode, 'hideOnPage', pageID]) ||
              _.get(elem, ['props', 'isInvisibleByDefault'])
            ) {
              const parent = get(elem, 'parent')
              let currentPageUID = parent
              if (RepeatedStripsID.indexOf(parent) !== -1) {
                if (!rulesState[currentPageUID]) {
                  rulesState[currentPageUID] = {}
                }
                if (!rulesState[currentPageUID][parent]) {
                  rulesState[currentPageUID][parent] = {}
                }
                rulesState[currentPageUID][parent][elemUID] = new Array(100).fill(['hide'])
              } else {
                if (!rulesState[parentType]) {
                  rulesState[parentType] = {}
                }
                if (!rulesState[parentType][elemUID] || !rulesState[parentType][elemUID].length) {
                  rulesState[parentType][elemUID] = ['hide']
                }
              }
            } else if (!_.get(elem, ['props', 'isInvisibleByDefault'])) {
              const parent = get(elem, 'parent')
              let currentPageUID = parent
              if (RepeatedStripsID.indexOf(parent) !== -1) {
                if (!rulesState[currentPageUID]) {
                  rulesState[currentPageUID] = {}
                }
                if (!rulesState[currentPageUID][parent]) {
                  rulesState[currentPageUID][parent] = {}
                }
                rulesState[currentPageUID][parent][elemUID] = new Array(100).fill([])
              } else {
                if (!rulesState[parentType]) {
                  rulesState[parentType] = {}
                }
                if (!rulesState[parentType][elemUID] || !rulesState[parentType][elemUID].length) {
                  rulesState[parentType][elemUID] = []
                }
              }
            }
          }
        })
      } catch (error) {
        console.error(error)
      }

      const uid = projectPages?.uid
      const page = state.getIn(['pages', action.payload.pageID, 'Props', 'elements'], Map()).toJS()
      const layoutMode = state.getIn(['layoutMode'], 'lg')
      if (page && uid) {
        pageDefaultRules = pageDefaultRules[uid] || {}
        _.each(page, (elem, id) => {
          if (_.get(elem, 'type') == 'Tab') {
            const tabs = get(elem, ['props', layoutMode, 'tabs'], [])
            _.each(tabs, (tab) => {
              if (tab && tab.hide) {
                let pathToRule = [uid, `${id}-tab`, tab.id]
                const rules = _.get(pageDefaultRules, pathToRule, [])
                if (_.isArray(rules)) {
                  _.set(pageDefaultRules, pathToRule, [...rules, 'hide'])
                }
                _.set(pageDefaultRules, pathToRule, [...rules, 'hide'])
              }
            })
          }
          if (_.get(elem, 'type') === 'Strip' && _.size(_.get(elem, 'props.isInvisibleCol')) > 0) {
            _.each(_.get(elem, 'props.isInvisibleCol', {}), (hide, col) => {
              if (hide) {
                let rules = _.get(pageDefaultRules, [uid, `${id}-${col}`], [])
                if (state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).indexOf(id) > -1) {
                  rules = _.get(pageDefaultRules, [uid, id, `${id}-${col}`, 0], [])
                }
                let parent = _.get(elem, 'parent')
                if (
                  state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).findIndex((v) => v === parent) !== -1
                ) {
                  if (_.isArray(rules)) {
                    _.set(pageDefaultRules, [uid, parent, `${id}-${col}`, 0], [...rules, 'hide'])
                  }
                } else {
                  if (state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).indexOf(id) > -1) {
                    if (!rules || !_.isArray(rules)) {
                      rules = []
                    }
                    _.set(pageDefaultRules, [uid, id, `${id}-${col}`, 0], [...rules, 'hide'])
                  } else if (_.isArray(rules)) {
                    _.set(pageDefaultRules, [uid, `${id}-${col}`], [...rules, 'hide'])
                  }
                }
              }
            })
          }

          try {
            let oldRules = state.getIn(['rules', uid, id])
            if (oldRules && List.isList(oldRules)) {
              let rules = _.get(pageDefaultRules, [uid, id], [])
              oldRules = oldRules.toJS()
              if (oldRules.includes('isJs')) {
                _.each(oldRules, (val) => {
                  if (!['hide', 'show'].includes(val)) {
                    rules.push(val)
                  }
                })
                if (state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).indexOf(id) > -1) {
                  _.set(pageDefaultRules, [uid, id, id, 0], rules)
                } else {
                  _.set(pageDefaultRules, [uid, id], rules)
                }
              }
            }
          } catch (err) {
            console.error(err)
          }
          if (_.get(elem, 'props.isInvisibleByDefault') || _.get(elem, 'props.isDefaultInvisibleByDefault')) {
            let rules = _.get(pageDefaultRules, [uid, id], [])

            const elementContainedInRepeatedStrips = state
              .getIn(['project', 'Settings', 'RepeatedStripsID'], List())
              .includes(id)

            if (elementContainedInRepeatedStrips) {
              rules = _.get(pageDefaultRules, [uid, id, id, 0], [])
            }

            const parent = getRootParent(id, page)
            const repeatParent = getRepeatRootParent(id, page)
            const parentContainedInRepeatedStrips = state
              .getIn(['project', 'Settings', 'RepeatedStripsID'], List())
              .some((v) => v === parent)
            const repeatParentContainedInRepeatedStrips =
              repeatParent &&
              state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).some((v) => v === repeatParent)

            let elementPath
            if (repeatParentContainedInRepeatedStrips || parentContainedInRepeatedStrips) {
              let hierarchicalParent = repeatParentContainedInRepeatedStrips ? repeatParent : parent
              hierarchicalParent = elementContainedInRepeatedStrips ? id : hierarchicalParent

              elementPath = [uid, hierarchicalParent, id, 0]
            } else {
              elementPath = [uid, id, ...(elementContainedInRepeatedStrips ? [id, 0] : [])]
              rules = elementContainedInRepeatedStrips && (!rules || !_.isArray(rules)) ? [] : rules
            }

            if (elementPath && _.isArray(rules)) {
              _.set(pageDefaultRules, elementPath, [...rules, 'hide'])
            }
          }
        })
      }
      retState = state
        .set('page', action.payload.pageID)
        .setIn(['panels', 'drawer'], false)
        .set(
          'rules',
          state
            .get('rules', Map())
            .set('Footer', fromJS(rulesState.Footer || {}))
            .set('Header', fromJS(rulesState.Header || {}))
            .set(uid, fromJS(pageDefaultRules[uid] || {}))
        )
      return retState
    }
    case actionTypes.PROJECT_UPDATE_PROPS: {
      return action.payload.state
    }
    case actionTypes.PROJECT_DELETE_PAGE: {
      return action.payload.state
    }
    case actionTypes.WB_SET_PARAMS_TO_STATE: {
      let retState = state
      const { params } = action.payload
      let changesPath = []
      retState.getIn(['project', 'params'], List()).map((row) => {
        if (!row.get('isReadOnly')) {
          if (params[row.get('id')] !== undefined) {
            retState = retState.setIn(['params', row.get('id')], params[row.get('id')])
            changesPath.push([row.get('id')])
          }
        }
      })
      let pageID = retState.get('page')
      if (pageID) {
        const currentPageUID = retState
          .getIn(['project', 'Pages'], List())
          .find((page) => page.get('_id') === pageID)
          ?.get?.('uid')

        let page = retState.getIn(['pages', pageID], Map())
        page.getIn(['Props', 'params'], List()).map((row) => {
          if (!row.get('isReadOnly')) {
            if (params[`${currentPageUID}:${row.get('id')}`] !== undefined) {
              retState = retState.setIn(
                ['state', currentPageUID, row.get('id')],
                params[`${currentPageUID}:${row.get('id')}`]
              )
              changesPath.push([currentPageUID, row.get('id')])
            }
          }
        })
      }
      if (changesPath.length) {
        return doProcessRules(
          retState,
          Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
          [],
          [],
          changesPath,
          false,
          false
        )
      }
      return retState
    }
    case actionTypes.PROJECT_PREVIEW_SET_ON_LOAD_DATA: {
      if (IS_SERVER) {
        return state
      } else {
        let moveToDevice = getInitialLayoutMode(state.get('layoutMode', 'lg'))
        let retState = processApplyOnloadACRules(getInitialParams(state.set('layoutMode', moveToDevice)))
        let currentPageUID
        let pageID = retState.get('page')
        _.each(retState.getIn(['project', 'Pages'], List()).toJS(), function (page) {
          if (page && page._id == pageID) {
            currentPageUID = page.uid
          }
        })

        if (['survey', 'surveyEmail'].includes(retState.getIn(['project', 'ProjectType']))) {
          try {
            let dynamicData = document.getElementById('__FT__STATIC__')
            if (dynamicData) {
              let freshData = JSON.parse(dynamicData.textContent)
              if (freshData.surveyFreshParams) {
                let hashParams = {}
                _.each(freshData.surveyFreshParams, (row) => {
                  if (row && row.id) {
                    hashParams[row.id] = row
                    retState = retState.setIn(['params', row.id], row.value)
                  }
                })
                let projectParams = retState.getIn(['project', 'params'], List()).toJS()
                _.each(projectParams, (row) => {
                  if (row && hashParams[row.id]) {
                    hashParams[row.id].value = row.value
                    delete hashParams[row.id]
                  }
                })

                _.each(hashParams, (row) => {
                  projectParams.push(row)
                })

                retState = retState.setIn(['project', 'params'], fromJS(projectParams))
              }
            }
          } catch (err) {
            console.error(err)
          }
        }

        const rules = retState.getIn(['project', 'Settings', 'rules'], Map()).toJS()
        let currentRules = retState.getIn(['rules'], Map()).toJS()
        currentRules[currentPageUID] = currentRules[currentPageUID] || {}
        currentRules[currentPageUID] = {}
        let rulesState = {}
        const RepeatedStripsID = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
        const lib = retState.getIn(['project', 'Settings', 'library'], Map()).toJS()
        each(rules, (rule, currentUID) => {
          rulesState[currentUID] = {}
          _.each(rule, (currentRule) => {
            setupRulesHashMap(rule, currentUID, null, RepeatedStripsID, lib)
            _.each(currentRule.actions, (action, key) => {
              if (_.get(currentRules, String(key).split(':')) === undefined) {
                _.set(rulesState, String(key).split(':'), [])
              } else {
                _.set(rulesState, String(key).split(':'), _.get(currentRules, String(key).split(':'), []))
              }
            })
          })
        })

        try {
          const RepeatedStripsID = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
          const layoutMode = retState.getIn(['layoutMode'], 'lg')
          const pageID = retState.getIn(['page'])
          retState.getIn(['project', 'Settings', 'elements'], Map()).map((iElem, elemUID) => {
            if (!Map.isMap(iElem)) {
              return true
            }
            const elem = iElem.toJS()
            let parentType = getParentIdInModal(
              retState,
              retState.getIn(['project', 'Settings', 'elements', elemUID, 'parent']),
              true
            )
            if (!['Header', 'Footer'].includes(elem.type) && ['Header', 'Footer'].includes(parentType)) {
              if (_.get(elem, ['props', layoutMode, 'hideOnPage', pageID])) {
                const parent = get(elem, 'parent')
                let currentPageUID = parent
                if (RepeatedStripsID.indexOf(parent) !== -1) {
                  if (!rulesState[currentPageUID]) {
                    rulesState[currentPageUID] = {}
                  }
                  if (!rulesState[currentPageUID][parent]) {
                    rulesState[currentPageUID][parent] = {}
                  }
                  rulesState[currentPageUID][parent][elemUID] = new Array(100).fill(['hide'])
                } else {
                  if (!rulesState[parentType]) {
                    rulesState[parentType] = {}
                  }
                  if (!rulesState[parentType][elemUID] || !rulesState[parentType][elemUID].length) {
                    rulesState[parentType][elemUID] = ['hide']
                  }
                }
              }
            }
          })
        } catch (error) {
          console.error(error)
        }

        if (retState.getIn(['project', 'Settings', 'eCommerce', 'enable'], false)) {
          retState.getIn(['project', 'Settings', 'eCommerce', 'pages'], Map()).map((page, id) => {
            page = page.set('params', retState.getIn(['project', 'Settings', 'eCommerce', 'params', id], Map()))
            retState = retState.setIn(['pages', id], page)
          })
        }

        try {
          let projectJs = retState.getIn(['project'], Map()).toJS()
          retState.getIn(['project', 'Settings', 'elements'], Map()).map((elem, elemUID) => {
            if (elem && elem.getIn(['props', 'isInvisibleByDefault'])) {
              const parent = getParentIdInModal(retState, elem.get('parent'), true)
              const repeatParent = getRepeatRootParent(
                elemUID,
                retState.getIn(['project', 'Settings', 'elements'], Map())
              )
              const pathForElementHiddenRule = repeatParent ? [parent, repeatParent, elemUID] : [parent, elemUID]
              _.set(rulesState, pathForElementHiddenRule, fromJS(['hide']))
              try {
                if (retState.getIn(['state', parent, elemUID]) === undefined) {
                  let elemState = getPageState(parent, projectJs, null, 'lg', elemUID)
                  _.each(elemState, function (val, uid) {
                    retState = retState.setIn(['state', parent, uid], fromJS(val))
                  })
                }
              } catch (err) {
                console.error(err)
              }
            } else if (
              elem &&
              elem.get('type') === 'Strip' &&
              elem.getIn(['props', 'isInvisibleCol'], Map()).size > 0
            ) {
              elem.getIn(['props', 'isInvisibleCol'], Map()).map((hide, col) => {
                let parent = getParentIdInModal(retState, elem.get('parent'), true)
                if (hide) {
                  _.set(rulesState, [parent, `${elemUID}-$col}`], fromJS(['hide']))
                }
              })
            } else {
              let parent = getParentIdInModal(retState, elem.get('parent'), true)
              try {
                if (retState.getIn(['state', parent, elemUID]) === undefined) {
                  let elemState = getPageState(parent, projectJs, null, 'lg', elemUID)
                  _.each(elemState, function (val, uid) {
                    retState = retState.setIn(['state', parent, uid], fromJS(val))
                  })
                }
              } catch (err) {
                console.error(err)
              }
            }
          })
        } catch (err) {
          console.error(err)
        }

        if (currentPageUID) {
          _.each(retState.getIn(['pages', pageID, 'Props', 'elements'], List()).toJS(), function (elem, elemUID) {
            if (_.get(elem, 'type') === 'Strip') {
              _.each(_.get(elem, 'props.isInvisibleCol', {}), (hide, col) => {
                if (hide) {
                  let parent = getRootParent(elemUID, retState.getIn(['pages', pageID, 'Props', 'elements'], Map()))
                  if (RepeatedStripsID.indexOf(parent) !== -1 || RepeatedStripsID.indexOf(elemUID) !== -1) {
                    if (RepeatedStripsID.indexOf(elemUID) != -1) {
                      parent = elemUID
                    }
                    const stripData = retState.getIn(['state', currentPageUID, parent])
                    let maxRows
                    if (stripData && isImmutable(stripData)) {
                      maxRows = getMappingCount(stripData.toJS())
                    }
                    if (!maxRows) {
                      maxRows = 1
                    }

                    if (!rulesState[currentPageUID]) {
                      rulesState[currentPageUID] = {}
                    }
                    if (!rulesState[currentPageUID][parent]) {
                      rulesState[currentPageUID][parent] = {}
                    }
                    rulesState[currentPageUID][parent][`${elemUID}-${col}`] = new Array(maxRows).fill(['hide'])
                  } else {
                    if (!rulesState[currentPageUID]) {
                      rulesState[currentPageUID] = {}
                    }
                    if (
                      !rulesState[currentPageUID][`${elemUID}-${col}`] ||
                      !rulesState[currentPageUID][`${elemUID}-${col}`].length
                    ) {
                      rulesState[currentPageUID][`${elemUID}-${col}`] = ['hide']
                    }
                  }
                }
              })
            }
            if (get(elem, ['props', 'isInvisibleByDefault'])) {
              let parent = getRootParent(elemUID, retState.getIn(['pages', pageID, 'Props', 'elements'], Map()))
              const repeatParent = getRepeatRootParent(
                elemUID,
                retState.getIn(['pages', pageID, 'Props', 'elements'], Map())
              )
              if (repeatParent && RepeatedStripsID.indexOf(repeatParent) !== -1) {
                if (RepeatedStripsID.indexOf(elemUID) != -1) {
                  parent = elemUID
                }
                const stripData = retState.getIn(['state', currentPageUID, repeatParent])
                let maxRows
                if (stripData && isImmutable(stripData)) {
                  maxRows = getMappingCount(stripData.toJS())
                }
                if (!maxRows) {
                  maxRows = 1
                }

                if (!rulesState[currentPageUID]) {
                  rulesState[currentPageUID] = {}
                }
                if (!rulesState[currentPageUID][repeatParent]) {
                  rulesState[currentPageUID][repeatParent] = {}
                }
                rulesState[currentPageUID][repeatParent][elemUID] = new Array(maxRows).fill(['hide'])
              } else if (RepeatedStripsID.indexOf(parent) !== -1 || RepeatedStripsID.indexOf(elemUID) !== -1) {
                if (RepeatedStripsID.indexOf(elemUID) != -1) {
                  parent = elemUID
                }
                const stripData = retState.getIn(['state', currentPageUID, parent])
                let maxRows
                if (stripData && isImmutable(stripData)) {
                  maxRows = getMappingCount(stripData.toJS())
                }
                if (!maxRows) {
                  maxRows = 1
                }

                if (!rulesState[currentPageUID]) {
                  rulesState[currentPageUID] = {}
                }
                if (!rulesState[currentPageUID][parent]) {
                  rulesState[currentPageUID][parent] = {}
                }
                rulesState[currentPageUID][parent][elemUID] = new Array(maxRows).fill(['hide'])
              } else {
                if (!rulesState[currentPageUID]) {
                  rulesState[currentPageUID] = {}
                }
                if (!rulesState[currentPageUID][elemUID] || !rulesState[currentPageUID][elemUID].length) {
                  rulesState[currentPageUID][elemUID] = ['hide']
                }
              }
            }
          })
        }

        return setInitialProjectUIState(retState.set('rules', fromJS(rulesState)))
      }
    }
    case actionTypes.PROJECT_SET_PREVIEW_DATA: {
      const rules = get(action.payload.project, 'Settings.rules', {})
      const rulesState = {}
      const currentParams = state
      const query = get(action, 'payload.query', {})

      let allRepeatedStripsID = get(action.payload.project, 'Settings.RepeatedStripsID', []) || {}
      const collectRepeatSections = (elem, id) => {
        if (elem.type === 'RepeatAutoFit') {
          allRepeatedStripsID.push(id)
        }
      }
      _.each(get(action, 'payload.project.Settings.elements', {}), collectRepeatSections)
      _.each(get(action, ['payload', 'pages', action.payload.page, 'Props', 'elements'], {}), collectRepeatSections)
      allRepeatedStripsID = _.uniq(allRepeatedStripsID)
      _.set(action.payload.project, 'Settings.RepeatedStripsID', allRepeatedStripsID)

      const RepeatedStripsID = get(action.payload.project, 'Settings.RepeatedStripsID', [])
      each(rules, (rule, currentUID) => {
        rulesState[currentUID] = {}
        _.each(rule, (currentRule) => {
          setupRulesHashMap(rule, currentUID, null, RepeatedStripsID)
          _.each(currentRule.actions, (action, key) => {
            _.set(rulesState, String(key).split(':'), [])
          })
        })
      })

      let currentPageUID
      _.each(get(action.payload.project, 'Pages', []), function (page) {
        if (page && page._id == action.payload.page) {
          currentPageUID = page.uid
        }
      })
      _.each(['md', 'sm', 'xs', 'ss'], (key) => {
        _.unset(action.payload.project, ['Settings', 'theme', key])
      })

      const isEffectedFormulaFields = {}
      const processFormulaFields = function (list) {
        _.each(list, function (row) {
          if (row) {
            if (['numeric', 'customJS', 'string'].indexOf(row.paramType) > -1) {
              let mapTo = get(row, ['customField', 'settings', 'mapResultTo'], [])
              _.each(mapTo, function (key) {
                if (String(key).indexOf('#-#') > -1) {
                  key = String(key).split('#-#')[1]
                }
                key = String(key).split(':')
                if (RepeatedStripsID.indexOf(key[1]) === -1) {
                  key = key[1]
                } else {
                  key = key[2]
                }
                if (key) {
                  isEffectedFormulaFields[key] = true
                }
              })
            }
          }
        })
      }
      processFormulaFields(get(action.payload.project, 'params', []))

      if (currentPageUID) {
        processFormulaFields(get(action.payload.pages, [action.payload.page, 'Props', 'params'], []))
        _.each(get(action.payload.pages, [action.payload.page, 'Props', 'elements'], []), function (elem, elemUID) {
          if (get(elem, ['props', 'isInvisibleByDefault'])) {
            const parent = getRootParent(
              elemUID,
              get(action.payload.pages, [action.payload.page, 'Props', 'elements'], {})
            )
            const repeatParent = getRepeatRootParent(
              elemUID,
              get(action.payload.pages, [action.payload.page, 'Props', 'elements'], {})
            )
            if (repeatParent && RepeatedStripsID.includes(repeatParent)) {
              if (!rulesState[currentPageUID]) {
                rulesState[currentPageUID] = {}
              }
              if (!rulesState[currentPageUID][repeatParent]) {
                rulesState[currentPageUID][repeatParent] = {}
              }
              rulesState[currentPageUID][repeatParent][elemUID] = new Array(100).fill(['hide'])
            } else if (RepeatedStripsID.indexOf(parent) !== -1 || elem?.type === 'RepeatAutoFit') {
              if (!rulesState[currentPageUID]) {
                rulesState[currentPageUID] = {}
              }
              if (!rulesState[currentPageUID][parent]) {
                rulesState[currentPageUID][parent] = {}
              }
              rulesState[currentPageUID][parent][elemUID] = new Array(100).fill(['hide'])
            } else {
              if (!rulesState[currentPageUID]) {
                rulesState[currentPageUID] = {}
              }
              if (!rulesState[currentPageUID][elemUID] || !rulesState[currentPageUID][elemUID].length) {
                rulesState[currentPageUID][elemUID] = ['hide']
              }
            }
          }
          if (
            (_.get(elem, 'type') === 'Strip' || elem?.type === 'RepeatAutoFit') &&
            _.get(elem, ['props', 'isInvisibleCol'])
          ) {
            _.each(_.get(elem, ['props', 'isInvisibleCol'], {}), (hide, col) => {
              if (hide) {
                const parent = getRootParent(
                  elemUID,
                  get(action.payload.pages, [action.payload.page, 'Props', 'elements'], {})
                )
                if (RepeatedStripsID.indexOf(parent) !== -1) {
                  if (!rulesState[currentPageUID]) {
                    rulesState[currentPageUID] = {}
                  }
                  if (!rulesState[currentPageUID][parent]) {
                    rulesState[currentPageUID][parent] = {}
                  }
                  rulesState[currentPageUID][parent][`${elemUID}-${col}`] = new Array(100).fill(['hide'])
                } else {
                  if (!rulesState[currentPageUID]) {
                    rulesState[currentPageUID] = {}
                  }
                  if (
                    !rulesState[currentPageUID][`${elemUID}-${col}`] ||
                    !rulesState[currentPageUID][`${elemUID}-${col}`].length
                  ) {
                    rulesState[currentPageUID][`${elemUID}-${col}`] = ['hide']
                  }
                }
              }
            })
          }
        })
      }
      if (!action.payload.project) {
        return state
      }
      action.payload.project = _.set(action.payload.project, 'isEffectedFormulaFields', isEffectedFormulaFields)

      let retState = state.set('project', fromJS(action.payload.project))
      let layoutMode = getInitialLayoutMode(state.getIn(['layoutMode'], 'lg'))
      if (query.device) {
        layoutMode = LAYOUT_MODE.includes(query.device) ? query.device : 'lg'
      }
      _.each(get(action.payload.project, ['Settings', 'elements'], []), function (elem, elemUID) {
        if (get(elem, ['props', 'isInvisibleByDefault'])) {
          const parent = get(elem, 'parent')
          let currentPageUID = parent
          if (RepeatedStripsID.indexOf(parent) !== -1) {
            if (!rulesState[currentPageUID]) {
              rulesState[currentPageUID] = {}
            }
            if (!rulesState[currentPageUID][parent]) {
              rulesState[currentPageUID][parent] = {}
            }
            rulesState[currentPageUID][parent][elemUID] = new Array(100).fill(['hide'])
          } else {
            if (!rulesState[currentPageUID]) {
              rulesState[currentPageUID] = {}
            }
            if (!rulesState[currentPageUID][elemUID] || !rulesState[currentPageUID][elemUID].length) {
              rulesState[currentPageUID][elemUID] = ['hide']
            }
          }
        }
        let parentType = getParentIdInModal(
          retState,
          retState.getIn(['project', 'Settings', 'elements', elemUID, 'parent']),
          true
        )
        if (!['Header', 'Footer'].includes(elem.type) && ['Header', 'Footer'].includes(parentType)) {
          if (_.get(elem, ['props', layoutMode, 'hideOnPage', action.payload.page])) {
            const parent = get(elem, 'parent')
            let currentPageUID = parent
            if (RepeatedStripsID.indexOf(parent) !== -1) {
              if (!rulesState[currentPageUID]) {
                rulesState[currentPageUID] = {}
              }
              if (!rulesState[currentPageUID][parent]) {
                rulesState[currentPageUID][parent] = {}
              }
              rulesState[currentPageUID][parent][elemUID] = new Array(100).fill(['hide'])
            } else {
              if (!rulesState[parentType]) {
                rulesState[parentType] = {}
              }
              if (!rulesState[parentType][elemUID] || !rulesState[parentType][elemUID].length) {
                rulesState[parentType][elemUID] = ['hide']
              }
            }
          }
        }
      })
      let appState = action.payload.ssoData
      let appParams = {}
      const pageUID = _.find(action.payload.project.Pages, (page) => page._id === action.payload.page)?.uid
      if (query?.ftproduct) {
        _.set(appState, ['eCommerce', 'product'], query?.ftproduct || null)
      }
      if (query?.ftcategory) {
        _.set(appState, ['eCommerce', 'search'], '')
        _.set(appState, ['eCommerce', 'selected', 'ftValue'], query?.ftcategory || null)
      }
      if (query?.ftsubcategory) {
        _.set(appState, ['eCommerce', 'subSelected', 'ftValue'], query?.ftsubcategory || null)
      }

      _.each(_.get(action.payload.project, ['Settings', 'elements'], {}), (elem, id) => {
        if (elem?.type === 'ECommerceCategories') {
          let parent = getParentIdInModal(state, elem.parent, true)
          _.set(appState, [parent, id, 'selected', 'ftValue'], query?.ftcategory || null)
          _.set(appState, [parent, id, 'subSelected', 'ftValue'], query?.ftsubcategory || null)
        }
      })

      const params = _.get(action.payload.project, ['params'], [])
      _.each(query, (value, key) => {
        const param = _.find(params, (v) => v?.name === key)
        if (param && param?.setInURL && param.paramType !== 'system') {
          _.set(appParams, param?.id, value)
        }
      })
      if (pageUID) {
        appState = jsMergeDeep(
          appState,
          getPageState(pageUID, get(action.payload.pages, [action.payload.page], {}), null, layoutMode)
        )
        appState.device = LayoutNames[layoutMode]

        _.each(_.get(action.payload.pages, [action.payload.page, 'Props', 'elements'], {}), (elem, id) => {
          if (elem?.type === 'ECommerceCategories') {
            let parent = getParentIdInModal(state, elem.parent, true)
            if (!_.includes(allRepeatedStripsID, parent)) {
              _.set(appState, [pageUID, parent, id, 'selected', 'ftValue'], query?.ftcategory || null)
              _.set(appState, [pageUID, parent, id, 'subSelected', 'ftValue'], query?.ftsubcategory || null)
            }
          }
        })
      }

      _.each(_.get(action.payload.project, ['Settings', 'ui', 'Drawer'], []), (uid) => {
        let drawer = _.get(action.payload.project, ['Settings', 'elements', uid], {})
        if (
          _.get(drawer, ['props', 'lg', 'isPersistent']) &&
          !_.get(drawer, ['props', 'isInvisibleByDefault'], false)
        ) {
          _.set(appState, ['project', uid], false)
          _.set(appState, ['drawer'], uid)
          return false
        }
      })

      return setInitialProjectUIState(
        getInitialParams(
          setWidgetElemStaticVal(
            retState
              .set('params', fromJS(appParams))
              .set('state', fromJS(appState))
              .set('project', fromJS(action.payload.project))
              .set('page', action.payload.page)
              .set('pages', fromJS(action.payload.pages))
              .set('rules', fromJS(rulesState))
              .set('session', fromJS(action.payload.session))
              .set('layoutMode', layoutMode)
              .set('isEmbeddedToSF', action.payload.isEmbeddedToSF ?? false)
              .setIn(['license', 'allowWeb'], action.payload.allowWeb)
              .setIn(['license', 'allowTitanSign'], action.payload.allowTitanSign)
          )
        )
      )
    }
    case actionTypes.SET_SHOW_ELEMENT_STYLE_PANEL: {
      let retState = disableHistory(state)
      _.each(action.payload.panel, function (val, key) {
        retState = retState.setIn(['panels', 'elementStyle', key], fromJS(val))
      })
      retState = setActivePanel(retState, 'elementStyle')
      return retState
    }
    case actionTypes.SET_POSITION_PROJECT_PANEL: {
      let { panel, style } = action.payload
      let sett = disableHistory(state).getIn(['panels', panel], Map())
      _.each(style, function (val, key) {
        sett = sett.set(key, val)
      })
      let retState = state.setIn(['panels', panel], sett)
      return retState
    }
    case actionTypes.SET_ACTIVE_PROJECT_PANEL: {
      let retState = disableHistory(state).setIn(['panels', action.payload.panel, 'open'], true)
      retState = setActivePanel(retState, action.payload.panel)
      return retState
    }
    case actionTypes.SET_SHOW_PROJECT_STYLE_PANEL: {
      let retState = disableHistory(state)
      _.each(action.payload.panel, function (val, key) {
        retState = retState.setIn(['panels', 'themeSettings', key], fromJS(val))
      })
      if (!action.payload.panel.customProp) {
        retState = retState.setIn(['panels', 'themeSettings', 'customProp'], fromJS(null))
      }
      retState = setActivePanel(retState, 'themeSettings')
      if (action.payload.panel?.elem) {
        retState = retState.set('selected', List([action.payload.panel?.elem]))
      }
      return retState
    }

    case actionTypes.SET_CLEAR_SELECTION: {
      return state.set('selected', List(['']))
    }

    case actionTypes.PROCESS_OPEN_PROJECT: {
      const defaultTheme = getDefaultStyles()
      const serverTheme = action.payload.theme || {}
      let theme = _.merge({}, defaultTheme, serverTheme, _.get(action.payload.project, 'Settings.theme', {}))
      _.set(theme, ['lg', 'Strip', 'root', 'backgroundImage'], '')
      let badElements = []
      _.each(_.get(action.payload.project, ['Settings', 'elements'], {}), (elem, key) => {
        let type = elem?.type
        if (!type && !SAFE_KEYS.includes(key)) {
          badElements.push(key)
        }
      })
      let isProjectChanged = false
      if (_.size(_.get(action.payload.project, ['Name'], '')) > 80) {
        _.set(action.payload.project, ['Name'], String(_.get(action.payload.project, ['Name'], '')).substring(0, 80))
        isProjectChanged = true
      }
      _.set(action.payload.project, ['Settings', 'AutomaticActions', 'rules'], {})
      _.each(action.payload.project?.Settings?.params, (param, index) => {
        if (param.isACParam) {
          _.set(action.payload.project, ['Settings', 'params', index, 'name'], 'access_profile')
        }
      })
      let projectElements = _.omit(_.get(action.payload.project, ['Settings', 'elements'], {}), badElements)
      let projectStyles = _.omit(_.get(action.payload.project, ['Settings', 'styles'], {}), badElements)
      projectElements = clearRecursiveElements(projectElements, projectStyles)
      _.set(action.payload.project, ['Settings', 'elements'], projectElements)
      _.set(action.payload.project, ['Settings', 'styles'], projectStyles)

      let badPageElements = {}
      _.each(action.payload.pages, (page, pageID) => {
        badPageElements[pageID] = []
        _.each(_.get(page, ['Props', 'elements'], {}), (elem, id) => {
          if (!elem.type) {
            badPageElements[pageID].push(id)
          }
        })
        let pageElements = _.omit(_.get(page, ['Props', 'elements'], {}), badPageElements[pageID])
        let pageStyles = _.omit(_.get(page, ['Props', 'styles'], {}), badPageElements[pageID])
        pageElements = clearRecursiveElements(pageElements, pageStyles)
        _.set(action.payload.pages, [pageID, 'Props', 'elements'], pageElements)
        _.set(action.payload.pages, [pageID, 'Props', 'styles'], pageStyles)
      })

      _.each(['md', 'sm', 'xs', 'ss'], (key) => {
        _.unset(theme, key)
      })
      _.each(
        _.get(action.payload.project, ['Settings', 'eCommerce', 'pages', 'e_product', 'Props', 'productAttr'], []),
        (attr, index) => {
          if (!attr.uid) {
            _.set(
              action.payload.project,
              ['Settings', 'eCommerce', 'pages', 'e_product', 'Props', 'productAttr', index, 'uid'],
              uuid()
            )
          }
        }
      )
      _.set(action.payload.project, 'Settings.theme', theme)
      if (!IS_SERVER) {
        window.autoSaveIterations = 0
      }

      if (_.get(action.payload.project, ['Settings', 'ac', 'enabled'])) {
        const smartvParams = _.get(action.payload.project, ['Settings', 'SmartV', 'parameters'], [])
        let acParam = _.find(smartvParams, (param) => param.isACParam)
        if (acParam) {
          let projectParams = _.get(action.payload.project, ['Settings', 'params'], [])
          projectParams = _.filter(
            projectParams,
            (param) => !param.isACParam || (param.isACParam && param.id === acParam?.param?.value)
          )
          _.set(action.payload.project, ['Settings', 'params'], projectParams)
        }
      }

      try {
        _.each(action.payload.pages, (page, pageID) => {
          updatePageMongoKeyIssue(action.payload.pages, fixActionID)
        })
      } catch (error) {
        console.error(error)
      }
      try {
        fixProjectElementsKeys(
          _.get(action.payload.project, 'Settings.elements', {}),
          _.get(action.payload.project, 'Settings.styles', {})
        )

        _.each(action.payload.pages, (page, pageID) => {
          fixProjectElementsKeys(
            _.get(action.payload.pages, [pageID, 'Props', 'elements'], {}),
            _.get(action.payload.pages, [pageID, 'Props', 'styles'], {})
          )
        })
      } catch (error) {
        console.error('cannot update styles keys', error)
      }

      if (_.get(action.payload.project, 'Settings.Footer.enable', false)) {
        let styleFooter = _.get(action.payload.project, 'Settings.styles.Footer', [])
        _.each(LAYOUT_MODE, function (mode) {
          if (styleFooter && styleFooter[mode]) {
            if (!styleFooter[mode].areas) {
              styleFooter[mode].areas = []
            }
            if (!styleFooter[mode].areas[0]) {
              styleFooter[mode].areas[0] = []
            }
            if (!styleFooter[mode].areas[0].length) {
              styleFooter[mode].areas[0][0] = 'a'
            }
          }
        })
        _.each(_.get(action.payload.project, ['Settings', 'elements', 'Footer', 'children'], []), (child) => {
          _.each(LAYOUT_MODE, function (mode) {
            let props = _.get(action.payload.project, ['Settings', 'elements', child, 'props'], {})
            if (!_.isEmpty(props) && !props?.[mode]?.gridArea) {
              _.set(action.payload.project, ['Settings', 'elements', child, 'props', mode, 'gridArea'], 'a')
            }
          })
        })
      }

      const lastID = findMaxProjectID(action.payload.project, action.payload.pages)

      safeUpdateFooterElement(action.payload.project)

      if (typeof window?.__FT__BUILDER_API__?.changePage === 'function') {
        window?.__FT__BUILDER_API__?.changePage(action.payload.project?.Pages?.[0]?._id, action?.payload?.project?._id)
      }

      let homePageID = _.first(_.keys(action.payload.pages)) || action.payload.project?.Pages?.[0]?._id
      const homePage = _.find(action.payload.project?.Pages, (page) => page.isHome)
      if (homePage) {
        homePageID = homePage._id
      }

      let appState = {}

      _.each(_.get(action.payload.project, ['Settings', 'ui', 'Drawer'], []), (uid) => {
        let drawer = _.get(action.payload.project, ['Settings', 'elements', uid], {})
        if (_.get(drawer, ['props', 'lg', 'isPersistent']) && !_.get(drawer, ['props', 'lg', 'isHidden'])) {
          _.set(appState, ['project', uid], false)
          _.set(appState, ['drawer'], uid)
          return false
        }
      })
      let devPage = null
      if (_.get(action.payload.project, 'ProjectType') === 'sfForm') {
        homePageID = null
        devPage = 'profile'
      }

      return processUpdateFormFieldStyles(
        state
          .set('slide', 'main')
          .setIn(['coEdit', 'changesPath'], List())
          .setIn(['project'], fromJS(action.payload.project))
          .setIn(['pages'], fromJS(action.payload.pages))
          .setIn(['isProjectChanged'], isProjectChanged)
          .setIn(['isPageChanged'], false)
          .setIn(['iAllPagesChanged'], false)
          .setIn(['effectedPages'], Map())
          .setIn(['workflowState'], Map())
          .setIn(['state'], fromJS(appState))
          .setIn(['layoutMode'], 'lg')
          .set('page', homePageID)
          .setIn(['project', 'Settings', 'lastID'], lastID)
          .set('devPage', devPage)
      )
    }
    case actionTypes.PROCESS_NEW_PROJECT: {
      let store = action.payload.store
      if (store.getIn(['project', 'ProjectType']) == WORKFLOW_TYPE) {
        store = store.setIn(
          ['panels', 'newPageWindow'],
          fromJS({
            show: true,
            isPageSelection: true,
            nodeID: 'ftstart',
          })
        )
      }

      return store.set('slide', 'main').setIn(['state'], Map())
    }
    case actionTypes.WB_LOAD_PREVIEW_CUSTOM_SCRIPT: {
      return state.setIn(['customScripts', action.payload.type], true)
    }
    case actionTypes.WB_ELEM_INLINE_CHANGE: {
      const { uid, html, ownHeight, height, type } = action.payload
      const selected = uid
      const layoutMode = state.getIn(['layoutMode'], 'lg')
      if (!selected) {
        return state
      }
      let retState = state.setIn(['isPageChanged'], true)

      const pageID = state.get('page')
      const isProject =
        retState.getIn(['project', 'Settings', 'elements'], Map()).filter((elem, elemUID) => elemUID === selected)
          .size > 0

      if (retState.hasIn([...getElementDataRoot(isProject ? 'project' : pageID), 'elements', selected])) {
        retState = retState.setIn(
          [...getElementDataRoot(isProject ? 'project' : pageID), 'elements', selected, 'props', layoutMode, 'text'],
          html
        )
        if (!type) {
          let disableInherit = retState.getIn([
            ...getElementDataRoot(isProject ? 'project' : pageID),
            'elements',
            selected,
            'props',
            layoutMode,
            'position',
            'disableInherit',
          ])
          if (disableInherit && ownHeight) {
            retState = retState.setIn(
              [
                ...getElementDataRoot(isProject ? 'project' : pageID),
                'elements',
                selected,
                'props',
                layoutMode,
                'position',
              ],
              retState
                .getIn(
                  [
                    ...getElementDataRoot(isProject ? 'project' : pageID),
                    'elements',
                    selected,
                    'props',
                    layoutMode,
                    'position',
                  ],
                  Map()
                )
                .set('height', ownHeight)
                .set('heightUnit', 'px')
            )
          } else if (ownHeight) {
            const ref = getStyleRef(retState, selected)
            if (height) {
              retState = retState.setIn(
                [...getElementDataRoot(isProject ? 'project' : pageID), 'styles', ref, layoutMode, 'root'],
                retState
                  .getIn(
                    [...getElementDataRoot(isProject ? 'project' : pageID), 'styles', ref, layoutMode, 'root'],
                    Map()
                  )
                  .set('height', ownHeight)
                  .set('heightUnit', 'px')
              )
            }
          }
          if (height) {
            const parent = retState.getIn([
              ...getElementDataRoot(isProject ? 'project' : pageID),
              'elements',
              selected,
              'parent',
            ])
            let disableInherit = retState.getIn([
              ...getElementDataRoot(isProject ? 'project' : pageID),
              'elements',
              parent,
              'props',
              layoutMode,
              'position',
              'disableInherit',
            ])
            const ref = getStyleRef(retState, parent)
            if (disableInherit && height) {
              retState = retState.setIn(
                [
                  ...getElementDataRoot(isProject ? 'project' : pageID),
                  'elements',
                  parent,
                  'props',
                  layoutMode,
                  'position',
                ],
                retState
                  .getIn(
                    [
                      ...getElementDataRoot(isProject ? 'project' : pageID),
                      'elements',
                      parent,
                      'props',
                      layoutMode,
                      'position',
                    ],
                    Map()
                  )
                  .set('minHeight', height)
                  .set('minHeightUnit', 'px')
              )
            } else if (height) {
              retState = retState.setIn(
                [...getElementDataRoot(isProject ? 'project' : pageID), 'styles', ref, layoutMode, 'root'],
                retState
                  .getIn(
                    [...getElementDataRoot(isProject ? 'project' : pageID), 'styles', ref, layoutMode, 'root'],
                    Map()
                  )
                  .set('minHeight', height)
                  .set('minHeightUnit', 'px')
              )
            }
          }
        }
      }

      return retState
    }
    case actionTypes.WB_VIEW_THEME_UPDATE_STYLES: {
      let retState = state.setIn(['isPageChanged'], true)
      const { styles } = action.payload

      let projectTheme = state.getIn(['project', 'Settings', 'theme'], Map())
      const layoutMode = state.getIn(['layoutMode'], 'lg')

      _.each(styles, function (style, styleKey) {
        if (Object.keys(style).length) {
          _.each(style, function (val, key) {
            projectTheme = projectTheme.setIn([layoutMode, styleKey, 'root', key], val)
          })
          projectTheme = projectTheme.setIn([layoutMode, styleKey, 'IsConfiguredDevice'], true)
        }
      })

      retState = retState.setIn(['project', 'Settings', 'theme'], projectTheme)

      return retState
    }
    case actionTypes.WB_VIEW_ITEM_UPDATE_STYLES: {
      const { styles, positions, customPageID } = action.payload
      let retState = state
        .setIn(['isPageChanged'], true)
        .setIn(
          ['recalcDeviceElement'],
          fromJS({
            uid: null,
          })
        )
        .setIn(['widgets', 'recalcUI'], false)
      let layoutMode = state.getIn(['layoutMode'], 'lg')
      if (state.getIn(['recalcDeviceElement', 'grid'], List()).size) {
        layoutMode = 'lg'
      }
      const page = state.get('page')

      const root = getElementDataRoot(customPageID || page)

      _.each(styles, (style, key) => {
        const element = retState.getIn([...root, 'elements', key])
        const type = retState.getIn([...root, 'elements', key, 'type'])
        if (!isImmutable(element) || !type) {
          return
        }
        const ref = getStyleRef(retState, key, customPageID)
        if (TAB_TYPES.indexOf(type) > -1) {
          let tabs = element.getIn(['props', layoutMode, 'tabs'])
          if (!isImmutable(tabs)) {
            return
          }
          let keysUpdate = ['root', 'content']
          tabs.map((tab) => {
            if (tab) {
              keysUpdate.push(tab.get('id'))
            }
          })

          let tabsStyle = style.tabs
          delete style.tabs
          _.each(keysUpdate, function (key) {
            if (key) {
              let newStyle = fromJS(style)

              if (tabsStyle && tabsStyle[key]) {
                newStyle = newStyle.set('height', tabsStyle[key])
              } else if (key == 'root' || key == 'content') {
                if (!['CarouselContainer', 'Accordion', 'MultiStepper'].includes(element.get('type'))) {
                  newStyle = newStyle.set('height', 'auto')
                }
              }
              retState = retState.setIn(
                [...root, 'styles', ref, layoutMode, key],
                retState.getIn([...root, 'styles', ref, layoutMode, key], Map()).merge(newStyle)
              )
            }
          })
        } else if (type === 'Strip') {
          const stripStyle = retState.getIn([...root, 'styles', ref], Map())

          const { areas } = getGridData(stripStyle, layoutMode)
          let areasJS = areas.toJS()
          _.each(style, (heightStyle, area) => {
            if (area == 'IsConfiguredDevice') {
              retState = retState.setIn([...root, 'styles', ref, area], fromJS(heightStyle))
            } else if (_.startsWith(area, 'column') || (_.startsWith(area, 'row') && heightStyle)) {
              retState = retState.setIn([...root, 'styles', ref, layoutMode, area], heightStyle)
            } else if (['minHeight', 'minHeightUnit'].indexOf(area) > -1) {
              retState = retState.setIn([...root, 'styles', ref, layoutMode, 'root', area], heightStyle)
            } else {
              const rowIndex = _.findIndex(areasJS, (row) => row.indexOf(area) !== -1)
              if (rowIndex !== -1) {
                retState = retState
                  .setIn([...root, 'styles', ref, layoutMode, `row${rowIndex}`], heightStyle.height)
                  .setIn([...root, 'styles', ref, layoutMode, `row${rowIndex}Unit`], heightStyle.heightUnit)
              }
            }
          })
        } else {
          if (root[0] != 'project') {
            let globalClass = retState.getIn(['project', 'Settings', 'styles', ref])
            if (isImmutable(globalClass) && globalClass.get('isGlobal')) {
              globalClass = globalClass.setIn(
                [layoutMode, 'root'],
                globalClass.getIn([layoutMode, 'root'], Map()).merge(fromJS(style))
              )
              retState = retState.setIn(['project', 'Settings', 'styles', ref], globalClass)
            }
          }

          const type = retState.getIn([...root, 'styles', ref, 'type'])

          if (element.getIn(['props', layoutMode, 'position', 'disableInherit'])) {
            _.each(style, (val, sKey) => {
              retState = retState.setIn([...root, 'elements', key, 'props', layoutMode, 'position', sKey], val)
            })
          } else {
            retState = retState.setIn(
              [...root, 'styles', ref, layoutMode, 'root'],
              retState.getIn([...root, 'styles', ref, layoutMode, 'root'], Map()).merge(fromJS(style))
            )
          }

          if (['Button', 'Link'].includes(type)) {
            retState = retState
              .setIn(
                [...root, 'styles', ref, layoutMode, 'rootHover'],
                retState.getIn([...root, 'styles', ref, layoutMode, 'rootHover'], Map()).merge(fromJS(style))
              )
              .setIn(
                [...root, 'styles', ref, layoutMode, 'rootActive'],
                retState.getIn([...root, 'styles', ref, layoutMode, 'rootActive'], Map()).merge(fromJS(style))
              )
          }
        }
      })
      _.each(positions, (position, key) => {
        retState = retState.setIn(
          [...root, 'elements', key, 'props', layoutMode, 'position'],
          retState.getIn([...root, 'elements', key, 'props', layoutMode, 'position'], Map()).merge(fromJS(position))
        )
      })
      return retState
    }
    case actionTypes.WIDGET_VIEW_ITEM_ALIGN_ELEMS: {
      return action.payload.state
    }
    case actionTypes.WB_VIEW_REORDER_ZINDEX: {
      return action.payload.store
    }
    case actionTypes.WB_VIEW_REORDER_GRID: {
      return action.payload.state
    }
    case actionTypes.WB_SELECTION_LOCK:
      return disableHistory(state.setIn(['widgets', 'selectionStatus'], action.payload.isFixed))
    case actionTypes.FETCH_DATA_REQ: {
      const widgets = action.payload?.widgets ?? []
      let retState = state
      _.each(widgets, (path) => {
        retState = retState.setIn(['widgets', 'loading', ...path, 'status'], true)
      })
      return retState
    }
    case actionTypes.PROCESS_WB_ELEM_CUT: {
      return action.payload.state
    }
    case actionTypes.PROCESS_WB_ELEM_COPY: {
      return action.payload.state
    }
    case actionTypes.PROCESS_WB_ELEM_PASTE: {
      return action.payload.state
    }
    case actionTypes.PROCESS_WB_TEMPLATE_PASTE: {
      return action.payload.state
    }
    case actionTypes.PROCESS_AUTO_END:
      return state.setIn(['autoTrigStatus'], false)
    case actionTypes.PROCESS_AUTO_START:
      return state.setIn(['autoTrigStatus'], true)
    case actionTypes.CLOSE_DIALOG_MESSAGE: {
      const uid = action.payload.uid
      const index = state.getIn(['dialog', 'messages'], List()).findIndex((conf) => conf.get('uid') === uid)
      if (index !== -1) {
        return state.setIn(['dialog', 'messages'], state.getIn(['dialog', 'message'], List()).splice(index, 1))
      } else {
        return state
      }
    }
    case actionTypes.SHOW_DIALOG_MESSAGE:
      return state.setIn(
        ['dialog', 'messages'],
        state.getIn(['dialog', 'messages'], List()).push(fromJS(action.payload))
      )
    case actionTypes.QUERY_UNSHIFT:
      return state
    case actionTypes.QUERY_ADD: {
      const params = state.getIn(['sfActions', 'params'], List())
      const list = []
      params.map((sfConf, uid) => {
        const items = sfConf.get('customOrder', false)
          ? sfConf
              .get('items', List())
              .toList()
              .sort((a, b) => {
                if (!isImmutable(a)) {
                  return 0
                }
                if (~~a.get('order', 0) < ~~b.get('order', 0)) {
                  return -1
                }
                if (~~a.get('order', 0) > ~~b.get('order', 0)) {
                  return 1
                }
                if (~~a.get('order', 0) === ~~b.get('order', 0)) {
                  return 0
                }
              })
              .toJS()
          : sfConf.get('items', List()).toJS()
        list.push({
          items,
          index: sfConf.get('index'),
          processUID: sfConf.get('processUID'),
          processIndex: sfConf.get('processIndex'),
          elemUID: sfConf.get('elemUID'),
          ruleUID: sfConf.get('ruleUID'),
          actionRuleId: sfConf.get('actionRuleId'),
          nodeId: sfConf.get('nodeId'),
          runInBackground: sfConf.get('runInBackground', false),
          isVerifyCaptcha: sfConf.get('isVerifyCaptcha', false),
          isForceCaptcha: sfConf.get('isForceCaptcha', false),
          isParallelLoad: sfConf.get('isParallelLoad', false),
          ignoreValidations: sfConf.get('ignoreValidations', false),
          customOrder: sfConf.get('customOrder', false),
          options: sfConf.get('options', {}),
          widgetPath: sfConf.get('path', false)
            ? toJS(sfConf.get('path', List()))
            : toJS(sfConf.get('widgetPath', List())),
          isNode: sfConf.get('isNode'),
          node: sfConf.get('node'),
        })
      })
      const isEmpty = state.getIn(['query', 'list'], List()).size === 0
      const elems = []
      _.each(list, (item) => {
        if (item.customOrder) {
          let list = _.sortBy(item.items, (row) => parseInt(row.processIndex) || 0)
          _.each(list, (v, index) => {
            if (index > 0 && !item.isForceCaptcha) {
              item.isVerifyCaptcha = false
            }
            elems.push({
              ...v,
              widgetPath: _.isArray(item.widgetPath) ? item.widgetPath : [item.widgetPath],
              runInBackground: item.runInBackground,
              isVerifyCaptcha: item.isVerifyCaptcha,
              elemUID: item.elemUID,
              processUID: item.processUID,
              nodeId: item.nodeId,
              actionRuleId: item.actionRuleId,
              processIndex: item.processIndex,
              index: item.index,
              ruleUID: item.ruleUID,
              options: item.options,
              isParallelLoad: false,
              ignoreValidations: item.ignoreValidations,
            })
          })
        } else {
          let pushList = []
          let getList = []
          _.each(item.items, (v) => {
            if (v.isPush) {
              pushList.push(v)
            } else {
              getList.push(v)
            }
          })
          if (getList.length) {
            elems.push({
              isBulk: true,
              list: getList,
              value: _.map(getList, (row) => row.value).join('_'),
              widgetPath: _.isArray(item.widgetPath) ? item.widgetPath : [item.widgetPath],
              runInBackground: item.runInBackground,
              isVerifyCaptcha: item.isVerifyCaptcha,
              elemUID: item.elemUID,
              ruleUID: item.ruleUID,
              nodeId: item.nodeId,
              actionRuleId: item.actionRuleId,
              processUID: item.processUID,
              processIndex: item.processIndex,
              isParallelLoad: item.isParallelLoad,
              index: item.index,
              options: item.options,
              ignoreValidations: item.ignoreValidations,
            })
            item.isVerifyCaptcha = false
          }
          if (pushList.length) {
            elems.push({
              isBulk: true,
              isPush: true,
              list: pushList,
              value: _.map(pushList, (row) => row.value).join('_'),
              widgetPath: _.isArray(item.widgetPath) ? item.widgetPath : [item.widgetPath],
              runInBackground: item.runInBackground,
              isVerifyCaptcha: item.isVerifyCaptcha,
              elemUID: item.elemUID,
              ruleUID: item.ruleUID,
              nodeId: item.nodeId,
              actionRuleId: item.actionRuleId,
              processUID: item.processUID,
              processIndex: item.processIndex,
              index: item.index,
              options: item.options,
            })
          }
        }
      })
      if (isEmpty) {
        let retState = resetLoadingFlags(state)
        let hashProcessUID = {}
        _.each(elems, function (row) {
          if (row && row.value && row.processUID) {
            if (!hashProcessUID[row.value]) {
              hashProcessUID[row.value] = []
            }
            hashProcessUID[row.value].push(row.processUID)
          }
        })

        return retState
          .setIn(
            ['query', 'list'],
            fromJS(
              _.uniqBy(elems, (v) => {
                if (v.value && hashProcessUID[v.value]) {
                  v.processList = hashProcessUID[v.value]
                }
                return v.value
              })
            )
          )
          .setIn(['query', 'status'], 'active')
          .setIn(['sfActions', 'needCall'], false)
          .setIn(['sfActions', 'params'], List())
      } else {
        let retState = resetLoadingFlags(state)
        return retState
          .setIn(
            ['query', 'list'],
            fromJS(_.uniqBy([...state.getIn(['query', 'list'], List()).toJS(), ...elems], (v) => v.value))
          )
          .setIn(['sfActions', 'needCall'], false)
          .setIn(['sfActions', 'params'], List())
      }
    }
    case actionTypes.CLEAR_SF_ACTIONS_QUERY: {
      let retState = state
      let list = state.getIn(['query', 'list'], List()).toJS()
      list = _.filter(list, (row) => {
        if (action.payload.values.indexOf(row.value) > -1) {
          if (row && row.elemUID) {
            retState = retState.setIn(['denideActionElements', row.elemUID], false)
          }
        }
        return action.payload.values.indexOf(row.value) == -1
      })

      if (list.length == state.getIn(['query', 'list'], List()).size) {
        list = []
      }

      if (action.payload.processedRules && Object.keys(action.payload.processedRules).length > 0) {
        let processed = retState.getIn(['__cond__cache__', 'processed'], Map()).toJS()
        retState = retState.setIn(
          ['__cond__cache__', 'processed'],
          fromJS({
            ...processed,
            ...action.payload.processedRules,
          })
        )
        retState = retState.setIn(['__cond__cache__', 'jobUID'], uuid())
      }
      retState = resetLoadingFlags(retState)

      retState = retState.setIn(['query', 'list'], fromJS(list))
      retState = hideSFLoadingMessages(retState)
      return retState
    }
    case actionTypes.RESET_PRINT_FLAG: {
      return state.setIn(['sfActions', 'isNeedPrint'], false)
    }
    case actionTypes.FORM_CLEAR_MESSAGES: {
      return state.setIn(['formMessages'], state.getIn(['formMessages']).remove(action.payload.uid))
    }
    case actionTypes.PROCESS_SF_PUSH: {
      let retState = state
      let isShowLoading = action.payload.isShowLoading
      let messages = fromJS(action.payload.loadingMessages)
      if (action.payload.response && action.payload.response.transaction) {
        retState = retState.setIn(['state', 'eCommerce', 'transaction'], fromJS(action.payload.response.transaction))
      }
      if (action.payload.captchaElem) {
        retState = retState.setIn(['denideActionElements', action.payload.captchaElem], true)
      }

      if (action.payload.elemUID) {
        let page = state.get('page')
        let elem = state.getIn(['pages', page, 'Props', 'elements', action.payload.elemUID], Map())
        if (elem.getIn(['type']) == 'Form') {
          isShowLoading = false
          messages = List()
          retState = retState.setIn(['formMessages', action.payload.elemUID], fromJS(action.payload.response))
        }
      }
      const currentPageUID = retState
        .getIn(['project', 'Pages'], List())
        .find((page) => page.get('_id') === retState.get('page'))
        ?.get?.('uid')
      retState = retState
        .setIn(['widgets', 'isPortalLoadData'], false)
        .setIn(['widgets', 'isShowLoading'], false)
        .setIn(['widgets', 'loadingMessages'], List())
        .setIn(['widgets', 'isShowSFMessage'], isShowLoading)
        .setIn(['widgets', 'sfPushMessages'], messages)

      let changesPath = []
      if (action.payload.formFieldsPushed) {
        try {
          _.each(action.payload.formFieldsPushed, (row) => {
            if (row && row.path) {
              retState = retState.setIn(row.path, false)
            }
          })
        } catch (err) {
          console.error(err)
        }
      }
      if (action.payload.resultRecords && action.payload.resultRecords.length) {
        _.each(action.payload.resultRecords, function (row) {
          if (String(row.paramID).startsWith('pageParam')) {
            let paramPath = String(row.paramID).split(':')
            if (paramPath[1] == currentPageUID) {
              changesPath.push([paramPath[1], paramPath[2]])
              retState = retState.setIn(['state', ...[paramPath[1], paramPath[2]]], row.recID)
            }
          } else {
            changesPath.push([row.paramID])
            retState = retState.setIn(
              ['params', ..._.initial(action.payload.paramPath), ...String(row.paramID).split(/:/g)],
              row.recID
            )
          }
        })
      } else {
        if (action.payload.recID !== undefined) {
          if (String(action.payload.paramID).startsWith('pageParam')) {
            let paramPath = String(action.payload.paramID).split(':')
            if (paramPath[1] == currentPageUID) {
              changesPath.push([paramPath[1], paramPath[2]])
              retState = retState.setIn(['state', ...[paramPath[1], paramPath[2]]], action.payload.recID)
            }
          } else {
            changesPath.push([action.payload.paramID])
            retState = retState.setIn(
              ['params', ..._.initial(action.payload.paramPath), ...String(action.payload.paramID).split(/:/g)],
              action.payload.recID
            )
          }
        }
      }

      if (retState.getIn(['query', 'list'], List()).size === 0) {
        retState = retState.setIn(['query', 'status'], 'none')
      }
      if (changesPath.length) {
        retState = doProcessRules(
          retState,
          Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
          [],
          [],
          changesPath,
          false,
          false
        )
      }
      return retState
    }
    case actionTypes.WIDGET_RELOAD_FINISH:
      return state.setIn(['portal', 'reloadWidgets'], false).setIn(['portal', 'paramsUpdated'], List())
    case actionTypes.SET_WIDGET_PARAM:
      if (_.isArray(action.payload.uid)) {
        return state.setIn(['params', ...action.payload.path, ...action.payload.uid], action.payload.value)
      } else {
        return state.setIn(['params', ...action.payload.path, action.payload.uid], action.payload.value)
      }
    case actionTypes.PROCESS_AUTO_TRIGGER:
      return state.setIn(
        ['autotrigger'],
        fromJS(_.defaultsDeep({}, action.payload.dep, state.getIn(['autotrigger'], Map()).toJS()))
      )
    case actionTypes.SET_STORE_PARAMS: {
      let retState = state
      if (action.payload.profileName) {
        retState = retState.setIn(['profileLabel'], action.payload.profileName)
      }
      const isLogged = Boolean(getPreviewDynamicData()?.user)
      retState = retState.setIn(['params', 'isLogged'], isLogged)
      let changedPath = []
      changedPath.push(['isLogged'])
      if (action.payload.params) {
        _.each(action.payload.params, function (val, key) {
          if (key == 'ftSessLeftTime') {
            let smartVSessionTime = parseInt(
              retState.getIn(['project', 'Settings', 'SmartV', 'smartVSessionTime'], 120),
              10
            )
            if (Number.isNaN(smartVSessionTime)) {
              smartVSessionTime = 120
            }
            val = parseInt(val)
            if (typeof val == 'number') {
              let left = Number(
                (parseInt(val, 10) + smartVSessionTime * 60 * 1000 - new Date().getTime()) / 1000
              ).toFixed(0)
              val = left
            } else {
              val = ''
            }
          }
          retState = retState.setIn(['params', key], val)

          changedPath.push([key])
        })
        retState = doProcessRules(retState, false, false, [], changedPath)
      }
      if (action.payload.isLoginSmartV) {
        retState = processApplyOnloadACRules(retState, true)
      }
      return retState
    }
    case actionTypes.SET_STORE_PARAM: {
      if (state.getIn(['params', action.payload.uid]) !== action.payload.value) {
        return doProcessRules(
          state.setIn(['params', action.payload.uid], action.payload.value),
          false,
          false,
          [],
          [[action.payload.uid]]
        )
      } else {
        return doProcessRules(
          state.setIn(['params', action.payload.uid], action.payload.value),
          false,
          false,
          [],
          [[...action.payload.path, action.payload.uid]]
        )
      }
    }
    case actionTypes.LIST_WIDGET_CHANGE_FIELD: {
      const { path, field, value } = action.payload
      let currentState = state.getIn(['state'], Map()).toJS()
      currentState = _.set(currentState, [...path, field].join('.'), value)
      const retState = state.setIn(['state'], fromJS(currentState))
      return retState
    }
    case actionTypes.PROJECT_FORM_RESET: {
      const { path, formState } = action.payload
      let currentState = state.getIn(['state'], Map()).toJS()
      currentState = _.set(currentState, [...path].join('.'), formState)
      const retState = state.setIn(['state'], fromJS(currentState))
      return retState
    }
    case actionTypes.PT_CHANGE_SELECTION: {
      const { path, selection, uid } = action.payload
      try {
        const rows = state.getIn(['state', ...path], Map())
        let size = ~~rows.get(`${uid}-totalRows`, 0)
        let selectCol = _.times(size, (n) => false)
        let values = rows.getIn([uid, 'value'], List())
        _.each(selection, (value) => {
          let index = values.findIndex((v) => v === value)
          if (index !== -1) {
            selectCol[index] = true
          }
        })
        return state.setIn(['state', ...path, uid, 'selected'], fromJS(selectCol))
      } catch (error) {
        return state
      }
    }
    case actionTypes.FORM_CHANGE_FILTER: {
      const { path, field, value } = action.payload
      try {
        return state.setIn(['filter', ...path, field], fromJS(value))
      } catch (error) {
        let currentState = state.getIn(['filter'], Map()).toJS()
        currentState = _.set(currentState, [...path, field].join('.'), value)
        const retState = state.setIn(['filter'], fromJS(currentState))
        return retState
      }
    }
    case actionTypes.FORM_CHANGE_FIELD: {
      const { path, field, value } = action.payload
      try {
        return state.setIn(['state', ...path, field], fromJS(value))
      } catch (error) {
        let currentState = state.getIn(['state'], Map()).toJS()
        currentState = _.set(currentState, [...path, field].join('.'), value)
        const retState = state.setIn(['state'], fromJS(currentState))
        return retState
      }
    }
    case actionTypes.CLOSE_LOADING_WINDOW: {
      try {
        if (window) {
          if (window.processingRequest) {
            if (Object.keys(window.processingRequest).length) {
              return state.setIn(
                ['__cache__'],
                state.getIn(['__cache__'], List()).push(
                  fromJS({
                    type: 'close_loading_message',
                    payload: {},
                  })
                )
              )
            }
          }
        }
      } catch (err) {
        console.error(err)
      }
      return state
        .setIn(['widgets', 'isShowLoading'], false)
        .setIn(['widgets', 'isPortalLoadData'], false)
        .setIn(['widgets', 'loadingMessages'], Map())
    }
    case actionTypes.SET_PAGE_LOADING_ELEMENTS: {
      let retState = state
      let loadingElements = retState.get('isLoadingElements', Map())
      _.each(action.payload.elements, function (isHide, fieldUID) {
        loadingElements = loadingElements.set(fieldUID, isHide)
      })
      return retState.set('isLoadingElements', loadingElements)
    }
    case actionTypes.SHOW_LOADING_WINDOW:
      return state
        .setIn(['widgets', 'isShowLoading'], true)
        .setIn(['widgets', 'isPortalLoadData'], true)
        .setIn(['widgets', 'clientY', 'sfMessages'], action.payload.clientY)
        .setIn(
          ['widgets', 'loadingMessages'],
          fromJS({
            isAlloClose: false,
            type: 'notify',
            list: action.payload.messages,
          })
        )
    case actionTypes.POST_MSG_SET_VAL: {
      const { statePatch } = action.payload
      let retState = state
      const changesPath = []
      let currentState = retState.getIn(['state'], Map()).toJS()
      _.each(statePatch, (v, k) => {
        if (String(k).indexOf(':') == -1) {
          if (retState.getIn(['params', k], '') != v) {
            changesPath.push([k])
            retState = retState.setIn(['params', k], v)
          }
        } else {
          const key = String(k).split(':')
          if (_.get(currentState, key, '') !== v) {
            _.set(currentState, key, v)
            changesPath.push(key)
          }
        }
      })
      retState = retState.setIn(['state'], fromJS(currentState))
      return doProcessRules(retState, false, [], [], changesPath, false, false)
    }
    case actionTypes.SHOW_SF_NOTIFY_MESSAGES: {
      return state
        .setIn(['widgets', 'isShowSFMessage'], true)
        .setIn(['widgets', 'sfPushMessages', 'list'], fromJS(action.payload.messages))
    }
    case actionTypes.SHOW_PAYMENT_MODAL: {
      if (action.payload.status) {
        let retState = state.setIn(
          ['__cache__'],
          state.getIn(['__cache__'], List()).push(
            fromJS({
              type: 'paymentIntegration',
              payload: {
                uid: state.getIn(['state', 'eCommerce', 'checkoutForm', 'paymentMethod']),
              },
            })
          )
        )
        return retState
      } else {
        return state.setIn(['widgets', 'isShowPaymentModal'], action.payload.status)
      }
    }
    case actionTypes.HIDE_SF_NOTIFY_MESSAGES: {
      return state
        .setIn(['widgets', 'isShowSFMessage'], false)
        .setIn(['widgets', 'sfMessages'], Map())
        .setIn(['widgets', 'firstErrorFieldIndex'], undefined)
        .setIn(['widgets', 'sfPushMessages'], Map())
    }
    case actionTypes.PROCESS_VISIBILITY_SF_MAPPING: {
      if (action.payload.isSFPush) {
        let hashPushMapping = {}
        let pushToSalesforce = state.getIn(['project', 'Settings', 'pushToSalesforce'], Map())
        if (!List.isList(pushToSalesforce)) {
          pushToSalesforce = List()
        }
        pushToSalesforce.map((row) => {
          hashPushMapping[row.get('uid')] = row.toJS()
        })
        let reState = state
        reState = resetLoadingFlags(reState)
        return processActionsSFItem(
          hashPushMapping,
          action.payload.list,
          true,
          'afterFinish',
          null,
          reState,
          action.payload.params
        )
      } else {
        let sfMapping = state.getIn(['project', 'Settings', 'sfMapping'], Map())
        if (!Map.isMap(sfMapping)) {
          sfMapping = Map()
        }
        let reState = setVisibilityOfSFMappingElem(sfMapping.toJS(), action.payload.list, false, null, state)
        reState = resetLoadingFlags(reState)
        return processActionsSFItem(
          sfMapping.toJS(),
          action.payload.list,
          true,
          'afterFinish',
          null,
          reState,
          action.payload.params
        )
      }
    }
    case actionTypes.PROCESS_SF_CHILD_MAPPING: {
      const path = action.payload.path
      const envParamsList = state
        .getIn(['project', 'params'], List())
        .filter((param) => param.get('isEnvVariable'))
        .map((param) => param.get('id'))
        .toJS()
      _.each(envParamsList, (paramId) => {
        _.unset(action.payload.data, ['data', `param#-#${paramId}`])
      })
      let retState = state
      const currentPageUID = retState
        .getIn(['project', 'Pages'], List())
        .find((page) => page.get('_id') === retState.get('page'))
        ?.get?.('uid')
      let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
      state.getIn(['project', 'Pages'], List()).map((page) => {
        const elems = _.keys(
          state
            .getIn(['pages', page.get('_id'), 'Props', 'elements'], Map())
            .filter(
              (elem) =>
                (elem.get('type') === 'Strip' &&
                  (elem.getIn(['props', 'isRepeat']) || elem.getIn(['props', 'isRepeatCol']))) ||
                elem.get('type') === 'RepeatAutoFit'
            )
            .toJS()
        )
        repeatRoot = [...repeatRoot, ...elems]
      })

      const sfListInfo = {}
      let flatSfList = getPreviewFlatSFMapping(_.get(action, 'payload.list', {}))
      let sfSettList = getPreviewFlatSFMappingSettings(
        retState.getIn(['project', 'Settings', 'sfMapping'], Map()).toJS()
      )
      _.each(flatSfList, (item) => {
        const sfItem = sfSettList[item.uid]
        if (sfItem && sfItem.gridFields) {
          sfListInfo[item.uid] = {
            isArray: sfItem.isArray,
            fields: sfItem.gridFields,
          }
        }
      })

      repeatRoot = _.uniq(repeatRoot)
      const changesPath = []
      let inData = _.omit(_.get(action.payload.data, 'data', {}), ['complex'])
      if (_.get(action.payload.data, 'data.complex')) {
        inData = formatComplexSFData(inData, _.get(action.payload.data, 'data.complex'))
      }
      let formatted = formatSFMappingResult({
        data: inData,
        settingsHash: _.get(action.payload.data, 'settingsHash', {}),
      })
      inData = formatted.data
      const keys = _.keys(inData)
      if (_.find(keys, (key) => key.startsWith('tableWidget') || key.indexOf('e_cart') > -1)) {
        const patch = {}
        let uniqueTableKeys = []
        _.each(inData, (value, key) => {
          if (key.startsWith('tableWidget') || key.indexOf('e_cart') > -1) {
            const path = _.last(String(key).split('#-#')).split(/:/g)
            let dataPath = _.initial(path).join('.')
            changesPath.push(path)

            if (key.startsWith('tableWidget')) {
              if (
                retState.getIn(['rules', path[0], path[1]]) &&
                !List.isList(retState.getIn(['rules', path[0], path[1]]))
              ) {
                retState = retState.setIn(['rules', path[0], path[1]], Map())
              }
            }

            if (uniqueTableKeys.indexOf(dataPath) == -1) {
              uniqueTableKeys.push(dataPath)
              changesPath.push(_.initial(path))
            }
            let fieldName = _.last(path)

            if (_.initial(path).length > 2 && key.indexOf('e_cart') > -1) {
              dataPath = _.slice(path, 0, 2).join('.')
              fieldName = path[2]
              let rest = _.slice(path, 3)
              value = _.set({}, rest, value)
            }

            if (key.indexOf('e_cart') > -1 && fieldName != 'var') {
              if (!_.isArray(value)) {
                if (value === '') {
                  value = []
                } else {
                  value = [value]
                }
              }
            }
            if (key.indexOf('e_cart') > -1 && fieldName == 'var') {
              let val = _.get(value, path[3], [])
              if (!_.isArray(val)) {
                if (val == '') {
                  val = []
                } else {
                  val = [val]
                }
              }
              _.set(patch, [dataPath, fieldName, path[3]], val)
            } else if (patch[dataPath]) {
              patch[dataPath][fieldName] = value
            } else {
              let ftGuid = []
              if (_.isArray(value)) {
                ftGuid = _.map(value, function () {
                  return uuid()
                })
              } else {
                ftGuid = [uuid()]
              }
              patch[dataPath] = {
                [fieldName]: value,
                ftGuid: ftGuid,
              }
            }
          }
        })
        const data = {}
        _.each(patch, (row, path) => {
          data[path] = []
          const keys = _.keys(row)
          if (_.isArray(row[_.first(keys)])) {
            _.each(_.get(row, _.first(keys), []), (val, index) => {
              const obj = {}
              _.each(keys, (key) => {
                if (row[key] && _.isObject(row[key]) && !_.isArray(row[key])) {
                  _.each(row[key], function (val, subKey) {
                    _.set(obj, [key, subKey], _.get(row, [key, subKey, index]))
                  })
                } else {
                  obj[key] = row[key][index]
                }
              })
              data[path].push(obj)
            })
          } else {
            const obj = {}
            _.each(keys, (key) => {
              obj[key] = row[key]
            })
            data[path].push(obj)
          }
          retState = retState.setIn(['state', ...action.payload.path, ...path.split('.')], fromJS(data[path]))
        })
        retState = resetLoadingFlags(retState)
        retState = retState
          .setIn(['widgets', 'isPortalLoadData'], false)
          .setIn(['widgets', 'isShowLoading'], action.payload.isShowLoading)
          .setIn(['widgets', 'loadingMessages'], fromJS(action.payload.loadingMessages))
          .setIn(['sfActions', 'needCall'], false)
          .setIn(['sfActions', 'params'], List())
      }
      if (_.find(keys, (key) => key.indexOf(':REPEAT:') !== -1)) {
        const patch = {}
        _.each(inData, (value, key) => {
          const [repeatPath, elemPath] = _.last(String(key).split('#-#')).split(':REPEAT:')
          if (
            key.startsWith('formWidget') &&
            !_.find(_.keys, (key) => key.startsWith('formWidget') && !_.endsWith(key, 'Id'))
          ) {
            if (patch[repeatPath]) {
              patch[repeatPath][[..._.initial(String(elemPath).split(':')), 'Id'].join(':')] = _.get(
                action.payload.data,
                ['data', _.find(keys, (key) => key.indexOf(repeatPath) !== -1 && _.endsWith(key, 'Id'))],
                []
              )
            } else {
              patch[repeatPath] = {
                [[..._.initial(String(elemPath).split(':')), 'Id'].join(':')]: _.get(
                  action.payload.data,
                  ['data', _.find(keys, (key) => key.indexOf(repeatPath) !== -1 && _.endsWith(key, 'Id'))],
                  []
                ),
              }
            }
          }
          if (patch[repeatPath]) {
            patch[repeatPath][elemPath] = value
          } else {
            patch[repeatPath] = {
              [elemPath]: value,
            }
          }
        })
        const data = {}
        _.each(patch, (row, path) => {
          data[path] = data[path] || {}
          let i = _.keys(data[path]).length
          const keys = _.keys(row)
          if (_.isArray(row[_.first(keys)])) {
            _.each(_.get(row, _.first(keys), []), (val, index) => {
              const obj = {}
              _.each(keys, (key) => {
                if (key.indexOf(':') === -1) {
                  obj[key] = row[key][index]
                } else {
                  const elemKey = key.split(':')
                  obj[_.first(elemKey)] = obj[_.first(elemKey)] || {}
                  obj[_.first(elemKey)] = _.set(obj[_.first(elemKey)], _.tail(elemKey), row[key][index])
                }
              })
              data[path][`i?${i}`] = obj
              i++
            })
          } else {
            const obj = {}
            _.each(keys, (key) => {
              if (key.indexOf(':') === -1) {
                obj[key] = row[key]
              } else {
                const elemKey = key.split(':')
                obj[_.first(elemKey)] = obj[_.first(elemKey)] || {}
                obj[_.first(elemKey)] = _.set(obj[_.first(elemKey)], _.tail(elemKey), row[key])
              }
            })
            data[path][`i?${i}`] = obj
            i++
          }
          retState = retState.setIn(['state', ...action.payload.path, ...path.split(':')], fromJS(data[path]))
        })
      }
      let currentParamsState = retState.getIn(['params'], Map()).toJS()
      let currentState = retState.getIn(['state'], Map()).toJS()
      let isCallFromRepeat = action.payload.repeatIndex !== null && action.payload.repeatIndex !== undefined
      let optionsMap = {}
      _.each(_.get(action.payload.data, 'metadata', {}), (value, key) => {
        if (value && value.items && String(key).indexOf('#-#') > -1) {
          let strKey = key.replace(':ft_picklist', '').replace(':ftListValue', '').replace(':ftListLabel', '')
          if (String(strKey).indexOf('e_catalog') === -1) {
            strKey = strKey.replace(':value', '')
          }
          let metaPath = ['meta', ...strKey.split('#-#')[1].split(':')]
          _.each(value.items, function (item) {
            if (item) {
              item.uid = uuid()
            }
          })
          retState = retState.setIn(metaPath, fromJS(value.items))
          if (value.controllerValues) {
            let metaPath2 = [...metaPath]
            metaPath2[metaPath2.length - 1] = metaPath2[metaPath2.length - 1] + '_sfControlValues'
            retState = retState.setIn(metaPath2, fromJS(value.controllerValues))
          } else {
            let metaPath2 = [...metaPath]
            metaPath2[metaPath2.length - 1] = metaPath2[metaPath2.length - 1] + '_sfControlValues'
            retState = retState.setIn(metaPath2, fromJS({}))
          }
        }
      })
      _.map(inData, (value, key) => {
        if (_.endsWith(key, ':ftListValue') || _.endsWith(key, ':ftListLabel') || _.endsWith(key, ':ftListIcon')) {
          let path = _.initial(String(key).split('#-#')[1].split(':'))
          const pathKey = key.split('#-#')[1].split(/\:/g)
          const isStripRepeat = _.find(pathKey, (key) => repeatRoot.indexOf(key) !== -1)
          if (isStripRepeat && !isCallFromRepeat) {
            return false
          }
          if (!_.isArray(value) && value) {
            let sfItem = _.find(sfListInfo, (item) => _.includes(item?.fields, key))
            let path = _.initial(String(key).split('#-#')[1].split(':'))
            if (sfItem && !sfItem.isArray) {
              if (
                retState.getIn(['meta', ...path], List()).size ||
                retState.getIn(['meta', path[0], path[2]], List()).size
              ) {
                return false
              }
            }
            if (!repeatRoot.includes(path[1])) {
              if (!sfItem) {
                if (retState.getIn(['meta', ...path], List()).size) {
                  return false
                }
              }
              value = [value]
            }
          }
          if (isCallFromRepeat && repeatRoot.includes(path[1])) {
            path = [path[0], 'child', path[1], action.payload.repeatIndex, path[2]]
          }
          let setKey = _.last(String(key).split('#-#')[1].split(':'))
            .replace('ftListValue', 'value')
            .replace('ftListLabel', 'label')
          if (_.has(optionsMap, path)) {
            if (!_.isArray(value) && value) {
              value = [value]
              inData[key] = value
            }
            _.each(value, (val, index) => {
              _.set(optionsMap, [...path, index, setKey], val)
              if (!_.get(optionsMap, [...path, index, 'uid'])) {
                _.set(optionsMap, [...path, index, 'uid'], uuid())
              }
            })
          } else {
            if (!_.isArray(value) && value) {
              value = [value]
              inData[key] = value
            }
            _.each(value, (val, index) => {
              _.set(optionsMap, [...path, index, setKey], val)
              if (!_.get(optionsMap, [...path, index, 'uid'])) {
                _.set(optionsMap, [...path, index, 'uid'], uuid())
              }
            })
          }
          let allMeta = retState.getIn(['metaInfo'], Map())
          let metaInfoPath = [..._.initial(String(key).split('#-#')[1].split(':'))]
          if (!isImmutable(allMeta)) {
            allMeta = Map()
          }

          let metaInfo = allMeta
            .getIn(metaInfoPath, Map())
            .set('processed', false)
            .set('isLock', true)
            .set('isDynamic', true)

          retState = retState.setIn(['metaInfo'], metaInfo)
        }
      })
      let meta = retState.get('meta', Map())?.toJS?.() || {}
      _.each(optionsMap, function (page, pageUID) {
        if (!meta[pageUID]) {
          meta[pageUID] = {}
        }
        if (page.child) {
          _.each(page.child, function (strip, stripId) {
            _.each(strip, function (row, index) {
              if (row) {
                _.each(row, function (elem, elemUID) {
                  _.set(meta, [pageUID, 'child', stripId, index, elemUID], elem)
                })
              }
            })
          })
        } else {
          _.each(page, function (elem, elemUID) {
            meta[pageUID][elemUID] = elem
          })
        }
      })
      retState = retState.setIn(['meta'], fromJS(meta))
      _.each(inData, (value, key) => {
        if (!key) {
          return true
        }
        if (String(key).indexOf('#-#') == -1) {
          key = '#-#' + key
        }
        const root = getElementDataRoot(retState.get('page'))
        const pathKey = String(key).split('#-#')[1].split(/\:/g)
        const isStripRepeat = _.find(pathKey, (key) => repeatRoot.indexOf(key) !== -1)
        if (!_.endsWith(key, ':ftListValue') && !_.endsWith(key, ':ftListLabel')) {
          let sfItem = _.find(sfListInfo, (item) => _.includes(item?.fields, key))
          if (sfItem && sfItem.isArray) {
            isCallFromRepeat = false
          }
        }
        if (isStripRepeat && !isCallFromRepeat && !_.endsWith(key, '-as:value') && !_.endsWith(key, '-as:text')) {
          const pageUID = pathKey[0]
          const repeatUID = pathKey[1]

          const repeatState = _.get(currentState, [pageUID, repeatUID])
          const updatedRepeatState = {}

          _.each(repeatState, (repeatElementState, repeatElementUID) => {
            const repeatElementType = retState.getIn([...root, 'elements', repeatElementUID, 'type'])

            if (PRESERVE_STATE_ELEMENTS.includes(repeatElementType)) {
              _.set(updatedRepeatState, [repeatElementUID], repeatElementState)
            }
          })

          currentState = _.set(currentState, [pageUID, repeatUID], updatedRepeatState)
        }
      })

      /*
       * MAIN FIELD PROCESSING LOOP
       * =========================
       * This section processes all Salesforce data fields and maps them to form state.
       *
       * Data Flow:
       * 1. Parameter fields (param*) → Update global form parameters
       * 2. Regular fields → Direct state assignment
       * 3. Repeated strip fields → Complex mapping based on data format:
       *    - Array data: Distributed across multiple repeat instances
       *    - Single data: Assigned to specific or first instance
       *
       * Key Concepts:
       * - repeatRoot: List of element IDs that are repeating sections
       * - isCallFromRepeat: Whether this mapping is triggered from within a repeat context
       * - Field type detection: Different handling for different SF field types
       */

      // Initialize tracking arrays for elements affected by this SF data mapping
      let effectedRepeatStrip = []
      let effectedPowerTable = {}
      let runValuesRules = []

      _.each(inData, (value, key) => {
        if (!key) {
          return true
        }
        if (String(key).indexOf('#-#') == -1) {
          key = '#-#' + key
        }
        let isPickListOptions = false,
          isRadioButton = false
        if ((_.endsWith(key, ':ftListValue') || _.endsWith(key, ':ftListLabel')) && _.isArray(value)) {
          isPickListOptions = true
          if (_.endsWith(key, ':ftListValue') && !isCallFromRepeat) {
            let key2 = String(key).replace('ftListValue', 'ftListLabel')
            if (!inData[key2] && value && typeof value[0] !== 'object') {
              isPickListOptions = false
            }
            const pathKey = String(key).split('#-#')[1]?.split(/\:/g)
            const isStripRepeat = _.find(pathKey, (key) => repeatRoot.indexOf(key) !== -1)
            if (isStripRepeat) {
              isPickListOptions = false
            }
          }
        }
        if (_.endsWith(key, ':ftListValue') || _.endsWith(key, ':ftListLabel')) {
          const pathKey = String(key).split('#-#')[1]?.split(/\:/g)
          const root = getElementDataRoot(retState.get('page'))
          const isStripRepeat = _.find(pathKey, (key) => repeatRoot.indexOf(pathKey[1]) !== -1)
          let uid = isStripRepeat ? pathKey[2] : pathKey[1]
          const source = retState.getIn([...root, 'elements', uid, 'props', 'source'])
          const control = retState.getIn([...root, 'elements', uid, 'props', 'control'])
          const type = retState.getIn([...root, 'elements', uid, 'type'])
          if (type == 'FormField') {
            if (source == 'static') {
              isPickListOptions = false
              if (isStripRepeat && isCallFromRepeat) {
                if (_.isArray(value)) {
                  value = value[0]
                }
              }
            }
          }
          if (control == 'radio') {
            isRadioButton = true
          }
        }
        if (isPickListOptions) {
          return true
        } else if (_.endsWith(key, ':ft_picklist') && _.isObject(value) && _.get(value, [0, 'multiMatchs']) == 'all') {
          retState = mapChoicesByRecords(retState, value, key, false)
        } else if (!_.startsWith(key, 'tableWidget') && key.indexOf(':REPEAT:') === -1) {
          if (_.startsWith(key, 'PowerTableWidget') || _.startsWith(key, 'KanbanWidget')) {
            if (!_.isArray(value) && value !== '') {
              value = [value]
            }
            try {
              let path = key.split('#-#')[1].split(':')
              if (_.startsWith(key, 'PowerTableWidget')) {
                effectedPowerTable[path[1]] = {
                  pageUID: path[0],
                  size: _.size(value),
                }
              }
              if (
                retState.getIn(['rules', path[0], path[1]]) &&
                !List.isList(retState.getIn(['rules', path[0], path[1]]))
              ) {
                if (
                  retState.getIn(['rules', path[0], path[1], 0]) == 'hide' ||
                  retState.getIn(['rules', path[0], path[1], '0', 0]) == 'hide'
                ) {
                  retState = retState.setIn(
                    ['rules', path[0], path[1]],
                    fromJS({
                      0: ['hide'],
                    })
                  )
                } else {
                  retState = retState.setIn(['rules', path[0], path[1]], Map())
                }
              }
            } catch (err) {
              console.error(err)
            }
          }

          if (value && (value.typelist == 'picklist' || value.typelist == 'multipicklist')) {
            value = value.value
          } else if (_.endsWith(key, ':ft_picklist')) {
            if (_.isArray(value) && value.length == 1) {
              if (value[0].advanced || value[0].value) {
                value = value[0]
              }
            }
          }
          if (_.startsWith(key, 'pageParam#-#') && !_.startsWith(key, 'pageParam#-#' + currentPageUID)) {
            value = ''
          }
          if (_.startsWith(key, 'param')) {
            currentParamsState = _.set(
              currentParamsState,
              [...path, ...key.split('#-#')[1].split(':')].join('.'),
              value
            )
            changesPath.push([...path, ...key.split('#-#')[1].split(':')])
          } else {
            const pathKey = key.split('#-#')[1].split(/\:/g)
            const isStripRepeat = _.find(pathKey, (key) => repeatRoot.indexOf(key) !== -1)
            if (_.endsWith(key, 'startDate') || _.endsWith(key, 'endDate')) {
              value = formatSFDateValue(value)
            }
            /*
             * REPEATED STRIPS DATA MAPPING FLOW
             * ================================
             * Repeated strips (child records) can receive data in different formats:
             * 1. Array format: ['value1', 'value2', 'value3'] - Multiple records from SF
             * 2. Single format: 'value1' - Single record from SF
             *
             * Each format requires different state mapping strategies to properly
             * populate the repeated form sections with the correct data structure.
             */
            if (isStripRepeat) {
              let fieldStatusKey
              if (pathKey.length > 3) {
                fieldStatusKey = _.initial(pathKey)
              } else {
                fieldStatusKey = [...pathKey]
              }
              retState = retState.setIn(['formFieldStatuses', ...fieldStatusKey], Map())

              /*
               * SCENARIO 1: Array Values (Multiple Records)
               * ==========================================
               * When SF returns multiple child records, each field comes as an array.
               * Example: 'firstName': ['John', 'Jane', 'Bob']
               *
               * Strategy: Map each array item to a separate repeat instance
               * - Create totalRows count based on array length
               * - Distribute values across repeat instances by index
               */
              if (_.isArray(value)) {
                effectedRepeatStrip.push(pathKey[1])
                changesPath.push([pathKey[0], `${pathKey[1]}-totalRows`])
                currentState = _.set(currentState, [pathKey[0], `${pathKey[1]}-totalRows`], value.length)
                retState = safeSetIn(retState, ['state', pathKey[0], `${pathKey[1]}-totalRows`], value.length)
                if (
                  isRadioButton ||
                  _.endsWith(key, 'ft_value') ||
                  _.endsWith(key, 'ft_text') ||
                  _.endsWith(key, 'startDate') ||
                  _.endsWith(key, 'endDate') ||
                  _.endsWith(key, 'min') ||
                  _.endsWith(key, 'max')
                ) {
                  let dataPath = key.split('#-#')[1].split(':')
                  _.each(value, (val, index) => {
                    currentState = _.set(
                      currentState,
                      [...path, ..._.initial(dataPath), index, _.last(dataPath)].join('.'),
                      val
                    )
                  })
                } else {
                  currentState = _.set(
                    currentState,
                    [...path, ...key.split('#-#')[1].split(':')].join('.'),
                    parseArrayValues(value)
                  )
                }
              } else {
                /*
                 * SCENARIO 2: Single Values (Single Record)
                 * ========================================
                 * When SF returns a single child record, each field comes as a single value.
                 * Example: 'firstName': 'John'
                 *
                 * Strategy depends on calling context:
                 * A) From repeat context: Direct assignment to specific instance
                 * B) From main context: Assignment to first instance (index 0)
                 *    - Processes all values including empty strings for proper field clearing
                 */
                effectedRepeatStrip.push(pathKey[1])

                // Sub-case A: Called from within a repeat instance
                if (isCallFromRepeat) {
                  if (
                    isRadioButton ||
                    _.endsWith(key, 'ft_value') ||
                    _.endsWith(key, 'ft_text') ||
                    _.endsWith(key, 'startDate') ||
                    _.endsWith(key, 'endDate') ||
                    _.endsWith(key, 'min') ||
                    _.endsWith(key, 'max')
                  ) {
                    let dataPath = key.split('#-#')[1].split(':')
                    currentState = _.set(
                      currentState,
                      [...path, ..._.initial(dataPath), action.payload.repeatIndex, _.last(dataPath)].join('.'),
                      value
                    )
                  } else {
                    currentState = _.set(
                      currentState,
                      [...path, ...key.split('#-#')[1].split(':'), action.payload.repeatIndex].join('.'),
                      parseValue(value)
                    )
                  }
                  // Sub-case B: Called from main context - assign to first repeat instance
                } else {
                  const shouldSkipEmptyRow = shouldSkipEmptyRowCheck(retState, pathKey, value)

                  if (
                    isRadioButton ||
                    _.endsWith(key, 'ft_value') ||
                    _.endsWith(key, 'ft_text') ||
                    _.endsWith(key, 'startDate') ||
                    _.endsWith(key, 'endDate') ||
                    _.endsWith(key, 'min') ||
                    _.endsWith(key, 'max')
                  ) {
                    if (!shouldSkipEmptyRow) {
                      let dataPath = key.split('#-#')[1].split(':')
                      currentState = _.set(
                        currentState,
                        [...path, ..._.initial(dataPath), 0, _.last(dataPath)].join('.'),
                        value
                      )
                    }
                  } else {
                    currentState = _.set(
                      currentState,
                      [...path, ...key.split('#-#')[1].split(':')].join('.'),
                      shouldSkipEmptyRow ? [] : parseArrayValues([value])
                    )
                  }
                }
              }
            } else {
              /*
               * SCENARIO 3: Regular Fields (Non-Repeated)
               * =======================================
               * Standard field mapping for non-repeated form elements.
               * Direct value assignment without array/instance considerations.
               */
              if (String(key).indexOf(':value') == -1 && String(key).indexOf(':text') == -1) {
                runValuesRules.push(key.split('#-#')[1])
              }
              if (!_.isArray(value) && String(key).toLowerCase().indexOf('gallery') > -1) {
                value = [value]
              }
              retState = retState.setIn(['formFieldStatuses', ...pathKey], Map())
              currentState = _.set(
                currentState,
                [...path, ...key.split('#-#')[1].split(':')].join('.'),
                parseValue(value)
              )
            }
            if (_.startsWith(key, 'listWidget')) {
              let ftGuildPath = [...pathKey]
              ftGuildPath[ftGuildPath.length - 1] = 'ftGuid'
              if (_.isArray(value)) {
                currentState = _.set(
                  currentState,
                  [...ftGuildPath],
                  fromJS(
                    _.map(value, function () {
                      return uuid()
                    })
                  )
                )
              } else {
                currentState = _.set(currentState, [...ftGuildPath], fromJS([uuid()]))
              }
            }
            if (_.startsWith(key, 'PowerTableWidget')) {
              const [pageUID, elementUID] = pathKey

              if (pageUID && elementUID && _.hasIn(currentState, [pageUID, elementUID, 'isProcessedOnloadRule'])) {
                currentState = _.set(currentState, [pageUID, elementUID, 'isProcessedOnloadRule'], List())
              }
            }
            changesPath.push(pathKey)
          }
        }
      })

      try {
        if (_.size(effectedPowerTable)) {
          _.each(effectedPowerTable, (row, elemID) => {
            let el = retState.getIn(['pages', retState.get('page'), 'Props', 'elements', elemID])
            if (el && row) {
              let inputColumns = getPowerTableInputColumnDefaults(el)
              _.each(inputColumns, (value, colId) => {
                let defVal = _.times(row.size, (n) => value)
                _.set(currentState, [row.pageUID, elemID, colId], fromJS(defVal))
              })
            }
          })
        }
      } catch (err) {
        console.error(err.stack)
      }
      try {
        if (runValuesRules.length && !action.payload.ignoreValidations) {
          const payload = {
            type: 'ValidateAction',
            payload: {
              action: 'onFieldGroup',
              elemList: runValuesRules,
              index: null,
              noReveal: true,
            },
          }
          retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).push(fromJS(payload)))
        }
        if (effectedRepeatStrip && effectedRepeatStrip.length && !action.payload.ignoreValidations) {
          _.each(_.uniq(effectedRepeatStrip), function (stripID) {
            const payload = {
              type: 'ValidateAction',
              payload: {
                action: 'onCurrentStrip',
                currentId: stripID,
                index: null,
                noReveal: true,
              },
            }
            retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).push(fromJS(payload)))
          })
        }
      } catch (err) {
        console.error(err)
      }
      retState = retState.setIn(['params'], fromJS(currentParamsState)).setIn(['state'], fromJS(currentState))

      if (effectedRepeatStrip && effectedRepeatStrip.length && !isCallFromRepeat) {
        effectedRepeatStrip = _.uniq(effectedRepeatStrip)
        let pageUID = currentPageUID
        retState = fillRepeatStripDefaults(retState, pageUID, effectedRepeatStrip)
        _.each(effectedRepeatStrip, function (stripID) {
          try {
            let stripParams = state.getIn(
              ['pages', state.get('page'), 'Props', 'elements', stripID, 'props', 'params'],
              List()
            )
            stripParams.map((param) => {
              if (param) {
                changesPath.push([pageUID, stripID, param.get('id')])
              }
            })
          } catch (err) {
            console.error(err)
          }
          let stripData = retState.getIn(['state', pageUID, stripID])
          retState = retState.setIn(['meta', pageUID, 'child', stripID], List())
          if (_.get(window, ['__FT_PROJECT__API__FILES__', 'filesRelation', stripID])) {
            _.each(_.get(window, ['__FT_PROJECT__API__FILES__', 'filesRelation', stripID]), function (val, uid) {
              _.set(window, ['__FT_PROJECT__API__FILES__', 'files', uid], {})
              if (stripData && isImmutable(stripData)) {
                stripData = stripData.setIn([uid, 'ft_fileupload'], List())
              }
            })
            if (stripData && isImmutable(stripData)) {
              retState = retState.setIn(['state', pageUID, stripID], stripData)
            }
          }

          if (stripData && isImmutable(stripData)) {
            let size = getMappingCount(stripData.toJS())
            let rules = retState.getIn(['rules', pageUID, stripID])
            if (rules && isImmutable(rules)) {
              rules = rules.toJS()
              let childrens = getChildUIDs(retState, stripID)
              _.each(childrens, function (key) {
                let row = rules[key] || [[]]
                if (row && _.isArray(row)) {
                  if (repeatRoot.includes(key)) {
                    let elem = state.getIn(['pages', state.get('page'), 'Props', 'elements', key], Map())
                    if (elem && elem.getIn(['props', 'isRepeatCol'])) {
                      let isInvisibleByDefault = elem.getIn(['props', 'isInvisibleByDefault'], false)
                      if (isInvisibleByDefault) {
                        row[0] = ['hide']
                      }
                      return true
                    }
                  }
                  _.times(size, function (i) {
                    if (i == 0) {
                      let isInvisibleByDefault = retState.getIn(
                        ['pages', retState.get('page'), 'Props', 'elements', key, 'props', 'isInvisibleByDefault'],
                        false
                      )
                      if (isInvisibleByDefault) {
                        row[i] = ['hide']
                      }
                    }
                    if (i > 0) {
                      row[i] = row[0]
                    }
                  })
                  if (_.size(row)) {
                    rules[key] = row
                  }
                }
              })
              retState = retState.setIn(['rules', pageUID, stripID], fromJS(rules))
            }
          }
        })
      }

      retState = retState
        .setIn(['widgets', 'isPortalLoadData'], false)

        .setIn(['widgets', 'isShowSFMessage'], action.payload.isShowLoading)
        .setIn(['widgets', 'sfMessages'], fromJS(action.payload.sfMessages))
        .setIn(['sfActions', 'needCall'], false)
        .setIn(['sfActions', 'params'], List())
      retState = resetLoadingFlags(retState)
      if (changesPath.length) {
        if (action.payload.inQuery) {
          if (retState.getIn(['query', 'list'], List()).size === 0) {
            retState = doProcessRules(
              retState.setIn(['query', 'status'], 'none'),
              Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
              [],
              [],
              changesPath,
              false,
              false
            )
          } else {
            retState = doProcessRules(
              retState,
              Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
              [],
              [],
              changesPath,
              false,
              false
            )
          }
        } else {
          retState = doProcessRules(
            retState,
            Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
            [],
            [],
            changesPath,
            false,
            false
          )
        }
      }
      retState = hideSFLoadingMessages(retState)
      return retState
    }
    case actionTypes.PROCESS_SF_CHAT_BOT_MAPPING: {
      let retState = state
      const { data } = action.payload

      const getValueOfField = (value) => {
        let result = String(value)

        let fields = String(value).match(/\{\!(.*?)\}/g)
        _.each(fields, function (field) {
          if (field) {
            field = String(field).replace('{!', '')
            field = String(field).replace('}', '')

            result = result.replace(`{!${field}}`, _.get(data, field, ''))
          }
        })

        return result
      }

      retState = retState.setIn(
        ['project', 'Settings', 'chatBot', 'flow'],
        retState.getIn(['project', 'Settings', 'chatBot', 'flow'], List()).map((flow) => {
          return flow
            .setIn(['message'], getValueOfField(flow.get('message', '')))
            .setIn(
              ['meta', 'embed', 'iframe', 'completeMsg'],
              getValueOfField(flow.getIn(['meta', 'embed', 'iframe', 'completeMsg'], ''))
            )
        })
      )

      return retState
    }
    case actionTypes.PROCESS_SF_SURVEY_MAPPING: {
      let retState = state
      let { data } = action.payload

      let pageID = retState.get('page')
      let elements = retState.getIn(['pages', pageID, 'Props', 'elements'], Map()).toJS()

      if (data) {
        retState = retState.setIn(['state', 'surveyData'], fromJS(data))
      } else {
        data = retState.getIn(['state', 'surveyData'], Map()).toJS()
      }

      const paramNameHash = retState.getIn(['project', 'params'], List()).reduce(
        (r, v) => ({
          ...r,
          [v.get('name')]: v.get('id'),
        }),
        {}
      )
      const params = getParams(retState)

      const getValueOfParam = (value) => {
        let result = value

        let fields = String(value).match(/\{\#(.*?)\}/g)
        _.each(fields, function (field) {
          if (field) {
            field = String(field).replace('{#', '')
            field = String(field).replace('}', '')

            result = result.replace(`{#${field}}`, _.get(params, paramNameHash[field], ''))
          }
        })

        return result
      }

      const getValueOfField = (value) => {
        let result = value

        let fields = String(value).match(/\{\!(.*?)\}/g)
        _.each(fields, function (field) {
          if (field) {
            field = String(field).replace('{!', '')
            field = String(field).replace('}', '')

            result = result.replace(`{!${field}}`, _.get(data, field, ''))
          }
        })

        return result
      }

      _.each(elements, (elem, elemID) => {
        if (elem && elem.type == 'PageConditionalForm') {
          try {
            let tabs = _.get(elem, ['props', 'lg', 'tabs'])
            if (tabs) {
              _.each(tabs, function (tab) {
                if (tab && tab.info) {
                  _.each(tab.info, function (info) {
                    if (info && typeof info == 'object') {
                      if (info.title) {
                        info.title = getValueOfParam(getValueOfField(info.title))
                      }
                      if (info.description) {
                        info.description = getValueOfParam(getValueOfField(info.description))
                      }
                      info.isCustomFieldtitle = false
                      info.isCustomFielddescription = false
                    }
                  })
                }
              })
            }
          } catch (err) {
            console.error(err)
          }
        } else if (elem && elem.type == 'Typography') {
          _.each(DEVICE_DEFAULT_MAX_SIZE, function (v, layoutMode) {
            if (
              !_.get(elem, ['props', layoutMode, 'originText']) ||
              _.includes(_.get(elem, ['props', layoutMode, 'text']), '{#')
            ) {
              _.set(elem, ['props', layoutMode, 'originText'], _.get(elem, ['props', layoutMode, 'text']))
            }
            let val = _.get(elem, ['props', layoutMode, 'originText'])
            elem.props.isCustomField = false
            val = getValueOfParam(getValueOfField(val))
            _.set(elem, ['props', layoutMode, 'text'], val)
          })
        }
      })
      return retState.setIn(['pages', pageID, 'Props', 'elements'], fromJS(elements))
    }
    case actionTypes.PROCESS_RESULT_AI: {
      let retState = state
      const { params, data, nextStep } = action.payload

      let changesPath = []

      _.each(params, function (sett, action) {
        if (!data[action] || !data[action].status || !data[action].data) {
          return true
        }
        let mapData = data[action].data
        switch (action) {
          case 'KeyPhrases':
            {
              let paramID = _.get(sett, ['params', 'target'])
              let value = _.get(mapData, ['value'], '')
              if (value && paramID) {
                changesPath.push([paramID])
              }
              retState = retState.setIn(['params', paramID], value)
            }
            break
          case 'Entities':
            const aiEntitiesList = ['DATE', 'ORGANIZATION', 'LOCATION', 'PERSON']
            _.each(aiEntitiesList, (type) => {
              let paramID = _.get(sett, ['params', `target${type}`])
              if (paramID) {
                let val = _.get(mapData, [type, 'value'], '')
                changesPath.push([paramID])
                retState = retState.setIn(['params', paramID], val)
              }
            })
            _.each(mapData, (row, type) => {
              if (row) {
              }
            })
            break
          case 'Sentiment':
            {
              let paramID = _.get(sett, ['params', 'targetValue'])
              let paramIDType = _.get(sett, ['params', 'targetType'])
              if (paramID) {
                changesPath.push([paramID])
                if (mapData.scope) {
                  mapData.scope = Math.trunc(mapData.scope * 100)
                  retState = retState.setIn(['params', paramID], (mapData.scope / 100).toFixed(2))
                } else {
                  retState = retState.setIn(['params', paramID], '')
                }
              }
              if (paramIDType) {
                changesPath.push([paramIDType])
                retState = retState.setIn(['params', paramIDType], mapData.value)
              }
            }
            break
          case 'Language':
            {
              let paramID = _.get(sett, ['params', 'target'])
              let biggerScope,
                value = ''
              _.each(mapData.data, (row) => {
                if (!biggerScope || biggerScope < row.Score) {
                  biggerScope = row.Score
                  value = row.LanguageCode
                }
              })
              if (paramID) {
                changesPath.push([paramID])
                retState = retState.setIn(['params', paramID], value)
              }
            }
            break
        }
      })

      if (changesPath.length) {
        retState = doProcessRules(
          retState,
          Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
          [],
          [],
          changesPath,
          false,
          false
        )
      }

      if (nextStep) {
        retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).concat(fromJS(nextStep)))
      }
      return retState
    }
    case actionTypes.PROCESS_SF_MAPPING: {
      let retState = state
      const currentPageUID = retState
        .getIn(['project', 'Pages'], List())
        .find((page) => page.get('_id') === retState.get('page'))
        ?.get?.('uid')
      let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
      state.getIn(['project', 'Pages'], List()).map((page) => {
        const elems = _.keys(
          state
            .getIn(['pages', page.get('_id'), 'Props', 'elements'], Map())
            .filter(
              (elem) =>
                (elem.get('type') === 'Strip' &&
                  (elem.getIn(['props', 'isRepeat']) || elem.getIn(['props', 'isRepeatCol']))) ||
                elem.get('type') === 'RepeatAutoFit'
            )
            .toJS()
        )
        repeatRoot = [...repeatRoot, ...elems]
      })

      if (action.payload.sfPickListLang !== undefined) {
        retState = retState.setIn(['sfPickListLang'], action.payload.sfPickListLang)
      }

      if (action.payload.captchaElem) {
        retState = retState.setIn(['denideActionElements', action.payload.captchaElem], true)
      }
      let isCallFromRepeat = action.payload.repeatIndex !== null && action.payload.repeatIndex !== undefined
      const sfListInfo = {}

      let flatSfList = getPreviewFlatSFMapping(_.get(action, 'payload.list', {}))
      let sfSettList = getPreviewFlatSFMappingSettings(
        retState.getIn(['project', 'Settings', 'sfMapping'], Map()).toJS()
      )
      _.each(flatSfList, (item) => {
        const sfItem = sfSettList[item.uid]
        if (sfItem && sfItem.gridFields) {
          sfListInfo[item.uid] = {
            isArray: sfItem.isArray,
            fields: sfItem.gridFields,
          }
        }
      })

      const changesPath = []
      const paramsChanged = []
      let inData = _.omit(_.get(action.payload.data, 'data', {}), ['complex'])
      if (_.get(action.payload.data, 'data.complex')) {
        inData = formatComplexSFData(inData, _.get(action.payload.data, 'data.complex'))
      }
      let formatted = formatSFMappingResult({
        data: inData,
        settingsHash: _.get(action.payload.data, 'settingsHash', {}),
      })
      inData = formatted.data
      const isOnLoadProject = _.get(action.payload, ['isOnLoadProject'], false)
      const keys = _.keys(inData)
      if (
        _.find(
          keys,
          (key) =>
            key.indexOf('e_cart') > -1 ||
            key.startsWith('tableWidget') ||
            key.startsWith('formWidget') ||
            key.startsWith('infoBox')
        )
      ) {
        const patch = {}
        let uniqueTableKeys = []
        _.each(inData, (value, key) => {
          if (!key) {
            return true
          }
          if (String(key).indexOf('#-#') == -1) {
            key = '#-#' + key
          }
          const pathKey = key.split('#-#')[1].split(/\:/g)
          let isStripRepeat = false
          if (key.startsWith('formWidget') || key.startsWith('infoBox')) {
            isStripRepeat = _.find(pathKey, (key) => repeatRoot.indexOf(key) !== -1)
          }
          if (key.indexOf('e_cart') > -1 || key.startsWith('tableWidget') || isStripRepeat) {
            const path = _.last(String(key).split('#-#')).split(/:/g)
            let dataPath = _.initial(path).join('.')
            if (uniqueTableKeys.indexOf(dataPath) == -1) {
              uniqueTableKeys.push(dataPath)
              changesPath.push(_.initial(path))

              if (key.startsWith('tableWidget')) {
                if (
                  retState.getIn(['rules', path[0], path[1]]) &&
                  !List.isList(retState.getIn(['rules', path[0], path[1]]))
                ) {
                  retState = retState.setIn(['rules', path[0], path[1]], Map())
                }
              }
            }

            let fieldName = _.last(path)

            if (_.initial(path).length > 2 && key.indexOf('e_cart') > -1) {
              dataPath = _.slice(path, 0, 2).join('.')
              fieldName = path[2]
              let rest = _.slice(path, 3)
              value = _.set({}, rest, value)
            }

            if (patch[dataPath]) {
              if (!_.isArray(value)) {
                if (key.indexOf('e_cart') > -1 && fieldName != 'var') {
                  if (value) {
                    value = [value]
                  } else {
                    value = []
                  }
                } else {
                  value = [value]
                }
              }
              if (key.indexOf('e_cart') > -1 && fieldName == 'var') {
                let val = _.get(value, path[3], [])
                if (!_.isArray(val)) {
                  if (val == '') {
                    val = []
                  } else {
                    val = [val]
                  }
                }
                _.set(patch, [dataPath, fieldName, path[3]], val)
              } else {
                patch[dataPath][fieldName] = value
              }
              if (_.isArray(value)) {
                if (!patch[dataPath]['ftGuid'][value.length - 1]) {
                  let ftGuid = []
                  ftGuid = _.map(value, function () {
                    return uuid()
                  })
                  patch[dataPath].ftGuid = ftGuid
                }
              }
            } else {
              let ftGuid = []
              if (_.isArray(value)) {
                ftGuid = _.map(value, function () {
                  return uuid()
                })
              } else {
                if (key.indexOf('e_cart') > -1) {
                  if (value) {
                    value = [value]
                  } else {
                    value = []
                  }
                } else {
                  value = [value]
                }
                ftGuid = [uuid()]
              }
              patch[dataPath] = {
                [fieldName]: value,
                ftGuid: ftGuid,
              }
            }
          }
        })
        const data = {}
        _.each(patch, (row, path) => {
          data[path] = []
          const keys = _.keys(row)
          let firstKey = _.first(keys)
          if (row.ftGuid) {
            firstKey = 'ftGuid'
          }
          if (_.isArray(row[firstKey])) {
            _.each(_.get(row, firstKey, []), (val, index) => {
              const obj = {}
              _.each(keys, (key) => {
                if (row[key] && _.isObject(row[key]) && !_.isArray(row[key])) {
                  _.each(row[key], function (val, subKey) {
                    _.set(obj, [key, subKey], _.get(row, [key, subKey, index]))
                  })
                } else {
                  obj[key] = row[key][index]
                }
              })
              data[path].push(obj)
            })
          } else {
            const obj = {}
            _.each(keys, (key) => {
              obj[key] = row[key]
            })
            data[path].push(obj)
          }
          retState = retState.setIn(['state', ...path.split('.')], fromJS(data[path]))
        })
      }
      _.each(_.get(action.payload.data, 'metadata', {}), (value, key) => {
        if (value && value.items && String(key).indexOf('#-#') > -1) {
          let strKey = key.replace(':ft_picklist', '').replace(':ftListValue', '').replace(':ftListLabel', '')
          if (String(strKey).indexOf('e_catalog') === -1) {
            strKey = strKey.replace(':value', '')
          }
          let metaPath = ['meta', ...strKey.split('#-#')[1].split(':')]
          _.each(value.items, function (item) {
            if (item) {
              item.uid = uuid()
            }
          })
          retState = retState.setIn(metaPath, fromJS(value.items))
          if (value.controllerValues) {
            let metaPath2 = [...metaPath]
            metaPath2[metaPath2.length - 1] = metaPath2[metaPath2.length - 1] + '_sfControlValues'
            retState = retState.setIn(metaPath2, fromJS(value.controllerValues))
          } else {
            let metaPath2 = [...metaPath]
            metaPath2[metaPath2.length - 1] = metaPath2[metaPath2.length - 1] + '_sfControlValues'
            retState = retState.setIn(metaPath2, fromJS({}))
          }
        }
      })
      let optionsMap = {}
      _.map(inData, (value, key) => {
        if (!key) {
          return true
        }
        if (String(key).indexOf('#-#') == -1) {
          key = '#-#' + key
        }
        if (_.endsWith(key, ':ftListValue') || _.endsWith(key, ':ftListLabel')) {
          let sfItem = _.find(sfListInfo, (item) => _.includes(item?.fields, key))
          let path = _.initial(String(key).split('#-#')[1].split(':'))
          if (!_.isArray(value) && sfItem && sfItem.isArray) {
            value = [value]
          } else if (!repeatRoot.includes(path[1])) {
            if (!_.isArray(value)) {
              if (!sfItem || (sfItem && !sfItem.isArray)) {
                if (retState.getIn(['meta', ...path], List()).size) {
                  return false
                }
              }
              value = [value]
            }
          }

          if (isCallFromRepeat && repeatRoot.includes(path[1])) {
            path = [path[0], 'child', path[1], action.payload.repeatIndex, path[2]]
          }

          let setKey = _.last(String(key).split('#-#')[1].split(':'))
            .replace('ftListValue', 'value')
            .replace('ftListLabel', 'label')
          if (_.has(optionsMap, path)) {
            if (!_.isArray(value)) {
              value = [value]
              inData[key] = value
            }
            _.each(value, (val, index) => {
              _.set(optionsMap, [...path, index, setKey], val)
              if (!_.get(optionsMap, [...path, index, 'uid'])) {
                _.set(optionsMap, [...path, index, 'uid'], uuid())
              }
            })
          } else {
            if (!_.isArray(value)) {
              value = [value]
              inData[key] = value
            }
            _.each(value, (val, index) => {
              _.set(optionsMap, [...path, index, setKey], val)
              if (!_.get(optionsMap, [...path, index, 'uid'])) {
                _.set(optionsMap, [...path, index, 'uid'], uuid())
              }
            })
          }

          let allMetaInfo = retState.getIn(['metaInfo'], Map())
          if (!allMetaInfo) {
            allMetaInfo = Map()
            retState = retState.setIn(['metaInfo'], Map())
          }
        }
      })

      let meta = retState.get('meta', Map())?.toJS?.() || {}
      _.each(optionsMap, function (page, pageUID) {
        if (!meta[pageUID]) {
          meta[pageUID] = {}
        }
        if (page.child) {
          _.each(page.child, function (strip, stripId) {
            _.each(strip, function (row, index) {
              if (row) {
                _.each(row, function (elem, elemUID) {
                  _.set(meta, [pageUID, 'child', stripId, index, elemUID], elem)
                })
              }
            })
          })
        } else {
          _.each(page, function (elem, elemUID) {
            _.each(elem, function (opt) {
              if (opt.value && opt.label === undefined) {
                opt.label = String(opt.value)
              } else if (opt.value === undefined && opt.label) {
                opt.value = opt.label
                opt.label = String(opt.label)
              } else {
                opt.label = String(opt.label)
              }
            })
            meta[pageUID][elemUID] = elem
          })
        }
      })

      retState = retState.setIn(['meta'], fromJS(meta))
      _.each(inData, (value, key) => {
        if (!key) {
          return true
        }
        if (String(key).indexOf('#-#') == -1) {
          key = '#-#' + key
        }
        const pathKey = key.split('#-#')[1].split(/\:/g)
        const isStripRepeat = _.find(pathKey, (key) => repeatRoot.indexOf(key) !== -1)
        if (isStripRepeat && !isCallFromRepeat) {
          if (!_.endsWith(key, ':ftListValue') && !_.endsWith(key, ':ftListLabel')) {
            retState = safeSetIn(retState, ['state', pathKey[0], pathKey[1]], Map())
          }
        }
      })
      let effectedRepeatStrip = []
      let runValuesRules = []
      _.each(inData, (value, key) => {
        if (!key) {
          return true
        }
        if (String(key).indexOf('#-#') == -1) {
          key = '#-#' + key
        }
        if (_.endsWith(key, ':ftListValue') || _.endsWith(key, ':ftListLabel')) {
          if (isOnLoadProject) {
            if (repeatRoot.includes(_.last(String(key).split('#-#')).split(':')?.[1])) {
              return true
            }
          }
        }

        if (
          (_.endsWith(key, ':ftListValue') || _.endsWith(key, ':ftListLabel')) &&
          _.isArray(value) &&
          !repeatRoot.includes(_.last(String(key).split('#-#')).split(':')?.[1])
        ) {
          return true
        } else if (_.endsWith(key, ':ft_picklist') && _.isObject(value) && _.get(value, [0, 'multiMatchs']) == 'all') {
          retState = mapChoicesByRecords(retState, value, key, true)
        } else if (
          !_.startsWith(key, 'tableWidget') &&
          String(key).indexOf(':REPEAT:') === -1 &&
          key.indexOf('e_cart') == -1
        ) {
          if (_.startsWith(key, 'PowerTableWidget') || _.startsWith(key, 'KanbanWidget')) {
            try {
              if (!_.isArray(value) && value !== '') {
                value = [value]
              }
              let path = key.split('#-#')[1].split(':')
              if (
                retState.getIn(['rules', path[0], path[1]]) &&
                !List.isList(retState.getIn(['rules', path[0], path[1]]))
              ) {
                if (
                  retState.getIn(['rules', path[0], path[1], 0]) == 'hide' ||
                  retState.getIn(['rules', path[0], path[1], '0', 0]) == 'hide'
                ) {
                  retState = retState.setIn(
                    ['rules', path[0], path[1]],
                    fromJS({
                      0: ['hide'],
                    })
                  )
                } else {
                  retState = retState.setIn(['rules', path[0], path[1]], Map())
                }
              }
            } catch (err) {
              console.error(err)
            }
          }

          if (_.endsWith(key, ':ft_picklist')) {
            if (value && (value.typelist == 'picklist' || value.typelist == 'multipicklist')) {
              value = value.value
            } else if (_.isArray(value) && value.length == 1) {
              if (value[0].advanced || value[0].value) {
                value = value[0]
              }
            }
          }
          if (_.startsWith(key, 'pageParam#-#') && !_.startsWith(key, 'pageParam#-#' + currentPageUID)) {
            value = ''
          }
          if (_.startsWith(key, 'param#-#')) {
            const path = _.last(String(key).split('#-#')).split(/:/g)
            retState = retState.setIn(['params', ...path], fromJS(value))
            paramsChanged.push(path)
            changesPath.push(path)
          } else {
            const pathKey = key.split('#-#')[1].split(/\:/g)
            const isStripRepeat = _.find(pathKey, (key) => repeatRoot.indexOf(key) !== -1)
            if (_.endsWith(key, 'startDate') || _.endsWith(key, 'endDate')) {
              value = formatSFDateValue(value)
            }
            if (isStripRepeat) {
              if (_.isArray(value)) {
                effectedRepeatStrip.push(pathKey[1])
                changesPath.push([pathKey[0], `${pathKey[1]}-totalRows`])
                retState = retState.setIn(['state', pathKey[0], `${pathKey[1]}-totalRows`], value.length)
                if (
                  _.endsWith(key, 'ft_value') ||
                  _.endsWith(key, 'ft_text') ||
                  _.endsWith(key, 'startDate') ||
                  _.endsWith(key, 'endDate') ||
                  _.endsWith(key, 'min') ||
                  _.endsWith(key, 'max')
                ) {
                  if (!retState.getIn(['state', ..._.initial(pathKey)])) {
                    retState = retState.setIn(['state', ..._.initial(pathKey)], List())
                  }
                  _.each(value, (val, index) => {
                    retState = retState.setIn(['state', ..._.initial(pathKey), index, _.last(pathKey)], fromJS(val))
                  })
                } else {
                  retState = retState.setIn(['state', ...pathKey], fromJS(parseArrayValues(value))) //on load multiple
                }
              } else {
                effectedRepeatStrip.push(pathKey[1])
                if (isCallFromRepeat) {
                  if (
                    _.endsWith(key, 'ft_value') ||
                    _.endsWith(key, 'ft_text') ||
                    _.endsWith(key, 'startDate') ||
                    _.endsWith(key, 'endDate') ||
                    _.endsWith(key, 'min') ||
                    _.endsWith(key, 'max')
                  ) {
                    if (!retState.getIn(['state', ..._.initial(pathKey)])) {
                      retState = retState.setIn(['state', ..._.initial(pathKey)], List())
                    }
                    retState = retState.setIn(
                      ['state', ..._.initial(pathKey), action.payload.repeatIndex, _.last(pathKey)],
                      fromJS(value)
                    )
                  } else {
                    retState = retState.setIn(
                      ['state', ...pathKey, action.payload.repeatIndex],
                      fromJS(parseValue(value))
                    ) //button pressed inside of strip
                  }
                } else if (value !== '') {
                  if (
                    _.endsWith(key, 'ft_value') ||
                    _.endsWith(key, 'ft_text') ||
                    _.endsWith(key, 'startDate') ||
                    _.endsWith(key, 'endDate') ||
                    _.endsWith(key, 'min') ||
                    _.endsWith(key, 'max')
                  ) {
                    if (!retState.getIn(['state', ..._.initial(pathKey)])) {
                      retState = retState.setIn(['state', ..._.initial(pathKey)], List())
                    }
                    retState = retState.setIn(['state', ..._.initial(pathKey), 0, _.last(pathKey)], fromJS(value))
                  } else {
                    retState = retState.setIn(['state', ...pathKey], fromJS(parseArrayValues([value]))) //button pressed outside of strip
                  }
                }
              }
            } else {
              runValuesRules.push(key.split('#-#')[1])
              if (!_.isArray(value) && String(key).toLowerCase().indexOf('gallery') > -1) {
                value = [value]
              }
              try {
                if (pathKey.length > 2) {
                  if (!isImmutable(retState.getIn(['state', ..._.initial(pathKey)]))) {
                    retState = retState.setIn(['state', ..._.initial(pathKey)], Map())
                  }
                }
                retState = retState.setIn(['state', ...pathKey], fromJS(parseValue(value))) //set value for text field
              } catch (err) {
                console.error(err)
              }
            }
            if (_.startsWith(key, 'listWidget')) {
              let ftGuildPath = [...pathKey]
              ftGuildPath[ftGuildPath.length - 1] = 'ftGuid'
              if (_.isArray(value)) {
                retState = retState.setIn(
                  ['state', ...ftGuildPath],
                  fromJS(
                    _.map(value, function () {
                      return uuid()
                    })
                  )
                )
              } else {
                retState = retState.setIn(['state', ...ftGuildPath], fromJS([uuid()]))
              }
            }
            changesPath.push(pathKey)
          }
        }
      })

      try {
        if (runValuesRules.length) {
          const payload = {
            type: 'ValidateAction',
            payload: {
              action: 'onFieldGroup',
              elemList: runValuesRules,
              index: null,
            },
          }
          retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).push(fromJS(payload)))
        }
      } catch (err) {
        console.error(err)
      }

      if (
        effectedRepeatStrip &&
        effectedRepeatStrip.length &&
        (action.payload.repeatIndex === null || action.payload.repeatIndex === undefined)
      ) {
        effectedRepeatStrip = _.uniq(effectedRepeatStrip)
        let pageUID = currentPageUID
        retState = fillRepeatStripDefaults(retState, pageUID, effectedRepeatStrip)
        _.each(effectedRepeatStrip, function (stripID) {
          let stripData = retState.getIn(['state', pageUID, stripID])
          if (_.get(window, ['__FT_PROJECT__API__FILES__', 'filesRelation', stripID])) {
            _.each(_.get(window, ['__FT_PROJECT__API__FILES__', 'filesRelation', stripID]), function (val, uid) {
              _.set(window, ['__FT_PROJECT__API__FILES__', 'files', uid], {})
              if (stripData && isImmutable(stripData)) {
                stripData = stripData.setIn([uid, 'ft_fileupload'], List())
              }
            })
            if (stripData && isImmutable(stripData)) {
              retState = retState.setIn(['state', pageUID, stripID], stripData)
            }
          }

          if (stripData && isImmutable(stripData)) {
            let size = getMappingCount(stripData.toJS())
            let rules = retState.getIn(['rules', pageUID, stripID])
            if (rules && isImmutable(rules)) {
              rules = rules.toJS()
              _.each(rules, function (row, key) {
                if (row && _.isArray(row)) {
                  if (repeatRoot.includes(key)) {
                    let elem = state.getIn(['pages', state.get('page'), 'Props', 'elements', key], Map())
                    if (elem && elem.getIn(['props', 'isRepeatCol'])) {
                      return true
                    }
                  }
                  _.times(size, function (i) {
                    if (i > 0) {
                      row[i] = row[0]
                    }
                  })
                }
              })
              retState = retState.setIn(['rules', pageUID, stripID], fromJS(rules))
            }
          }
        })
      }

      if (paramsChanged.length > 0) {
        retState = retState
          .setIn(
            ['portal', 'paramsUpdated'],
            fromJS([
              ...retState.getIn(['portal', 'paramsUpdated'], List()).toJS(),
              ..._.map(paramsChanged, (v) => ({ key: v })),
            ])
          )
          .setIn(['portal', 'reloadWidgets'], true)
      }

      retState = retState
        .setIn(['widgets', 'isPortalLoadData'], false)
        .setIn(['widgets', 'isShowSFMessage'], action.payload.isShowLoading)
        .setIn(['widgets', 'sfMessages'], fromJS(action.payload.sfMessages))

      if (!isOnLoadProject) {
        let flatSfList = getPreviewFlatSFMapping(_.get(action, 'payload.list', {}))
        if (!_.size(flatSfList)) {
          retState = retState.setIn(['sfActions', 'needCall'], false).setIn(['sfActions', 'params'], List())
        } else {
          let sfParams = retState.getIn(['sfActions', 'params'], List())
          sfParams = sfParams.filter((row) => {
            let isProcessed = false
            if (!row) {
              isProcessed = true
            } else {
              row.get('items', List()).map((sfItem) => {
                if (flatSfList[sfItem.get('value')]) {
                  isProcessed = true
                }
              })
            }

            return !isProcessed
          })
          retState = retState.setIn(['sfActions', 'params'], sfParams)
          if (!sfParams.size) {
            retState = retState.setIn(['sfActions', 'needCall'], false)
          } else {
            retState = retState.setIn(['sfActions', 'needCall'], true)
          }
        }

        retState = resetLoadingFlags(retState)
      }
      if (changesPath.length) {
        if (action.payload.inQuery) {
          if (retState.getIn(['query', 'list'], List()).size === 0) {
            retState = doProcessRules(
              retState.setIn(['query', 'status'], 'none'),
              Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
              [],
              [],
              changesPath,
              false,
              false
            )
          } else {
            retState = doProcessRules(
              retState,
              Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
              [],
              [],
              changesPath,
              false,
              false
            )
          }
        } else {
          retState = doProcessRules(
            retState,
            Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
            [],
            [],
            changesPath,
            false,
            false
          )
        }
      }
      retState = hideSFLoadingMessages(retState)
      return retState
    }
    case actionTypes.PROCESS_WB_TABLE_ACTION: {
      let { uid, actions, isRepeat, index, fieldType, rowValue, options } = action.payload
      const smartVParams = _.get(getPreviewDynamicData(), 'svParams', {})
      let iActions = List.isList(actions) ? actions : fromJS(actions)
      let processActions = iActions.filter((row) => row.get('enable', true) !== false)
      const allOptions = processActions.reduce(
        (r, v) => ({
          ...v.get('options', Map()).toJS(),
          ...r,
        }),
        _.assign({}, options)
      )
      const isActionFlow = Boolean(
        iActions.find((action) => action?.get?.('modeType') === 'flow' && action?.getIn?.(['enable'], true))
      )

      if (rowValue) {
        try {
          let values = state.getIn(['state', ...uid, 'value'], List())
          let newIndex = values.findIndex((val) => val === rowValue)
          if (newIndex > -1) {
            index = newIndex
          }
        } catch (err) {
          console.error(err)
        }
      }

      let retState = processSingleRule(
        fromJS({
          isActionRule: true,
          isTableRule: true,
          action: isActionFlow ? processActions : actions,
          index,
          options: allOptions || {},
          fieldType,
          modeType: isActionFlow ? 'flow' : '',
        }),
        [index],
        state.getIn(['state'], Map()).toJS(),
        getParams(state),
        smartVParams,
        state,
        false
      )

      if (retState.getIn(['redirectToPage'], '') !== '') {
        const pageUID = retState.getIn(['redirectToPage'], '')
        retState = retState.setIn(['redirectToPage'], '')
        setTimeout(() => {
          if (typeof window.__FT_PROJECT__API__?.goToPage === 'function') {
            window.__FT_PROJECT__API__.goToPage(pageUID)
          }
        }, 100)
      }
      return retState
    }
    case actionTypes.PROCESS_WB_BUTTON_ACTION: {
      let { uid, actions, isRepeat, index, options } = action.payload
      const smartVParams = _.get(getPreviewDynamicData(), 'svParams', {})
      let retState = state
      const isAllowSurveySlides =
        Boolean(state.get('page')) &&
        state.hasIn(['pages', state.get('page'), 'Props']) &&
        Boolean(state.getIn(['pages', state.get('page'), 'Props', 'Grid', 0]))
      if (retState.getIn(['project', 'ProjectType']) == 'surveyEmail' && !isAllowSurveySlides) {
        retState.getIn(['project', 'params'], List()).map((row) => {
          if (isImmutable(row)) {
            retState = retState.setIn(['params', row.get('id')], row.get('value'))
          }
        })
      }

      const regFormState = state.get('ftFormState', Map()).toJS()
      const appState = _.merge({}, regFormState, getState(state))
      const prevRulesState = state.get('prevRulesState', Map()).toJS()
      const prevRulesParams = state.get('prevRulesParams', Map()).toJS()
      if (isImmutable(actions) && List.isList(actions)) {
        let processActions = actions.filter((row) => {
          return isImmutable(row) && row.get('enable', true) !== false
        })
        if (processActions.size > 0) {
          processActions = processActions.push(
            fromJS({
              uid: 'auto-trigger',
              conditions: [],
              isAction: false,
              actions: {
                [`autoTrigger`]: [{ enabled: true }],
              },
            })
          )
        }
        const isActionFlow = Boolean(
          processActions.find((action) => action?.get?.('modeType') === 'flow' && action.getIn(['enable'], true))
        )
        const allOptions = processActions.reduce(
          (r, v) => ({
            ...safeMapToJS(v.get('options', Map())),
            ...r,
          }),
          _.assign({}, options)
        )
        retState = processSingleRule(
          fromJS({
            isActionRule: true,
            uid,
            action: processActions,
            index: isRepeat ? index : null,
            options: allOptions,
            modeType: isActionFlow ? 'flow' : '',
          }),
          isRepeat ? [index] : [],
          appState,
          getParams(retState),
          smartVParams,
          state,
          false,
          false,
          prevRulesState,
          prevRulesParams
        )
      } else if (Map.isMap(actions)) {
        const isActionFlow = Boolean(
          actions?.find?.((action) => action?.get?.('modeType') === 'flow' && action.getIn(['enable'], true))
        )
        retState = processSingleRule(
          fromJS({
            isActionRule: true,
            uid,
            action: [
              {
                uid: 'action',
                isAction: true,
                actions: actions,
              },
            ],
            index: isRepeat ? index : null,
            options,
            modeType: isActionFlow ? 'flow' : '',
          }),
          isRepeat ? [index] : [],
          appState,
          getParams(retState),
          smartVParams,
          state,
          false,
          false,
          prevRulesState,
          prevRulesParams
        )
      } else if (!_.isEmpty(actions)) {
        const isActionFlow = Boolean(
          _.find(actions, (action) => action?.modeType === 'flow' && _.get(action, ['enable'], true))
        )
        let iActions = fromJS({
          isActionRule: true,
          uid,
          action: [
            {
              uid: 'action',
              isAction: true,
              actions: actions,
            },
          ],
          index: isRepeat ? index : null,
          options,
          modeType: isActionFlow ? 'flow' : '',
        })
        retState = processSingleRule(
          iActions,
          isRepeat ? [index] : [],
          appState,
          getParams(retState),
          smartVParams,
          state,
          false,
          false,
          prevRulesState,
          prevRulesParams
        )
      }

      if (retState.getIn(['redirectToPage'], '') !== '') {
        const pageUID = retState.getIn(['redirectToPage'], '')
        retState = retState.setIn(['redirectToPage'], '')
        setTimeout(() => {
          if (typeof window.__FT_PROJECT__API__?.goToPage === 'function') {
            window.__FT_PROJECT__API__.goToPage(pageUID)
          }
        }, 100)
      }
      if (retState.getIn(['project', 'ProjectType']) == 'surveyEmail' && !isAllowSurveySlides) {
        retState.getIn(['project', 'params'], List()).map((row) => {
          if (isImmutable(row)) {
            retState = retState.setIn(['params', row.get('id')], row.get('value'))
          }
        })
      }
      if (uid === 'smartV-session-expire') {
        retState = retState.setIn(['isLocalLogout'], true)
      }
      return retState
    }

    case actionTypes.OPEN_LOOKUP_MODAL: {
      return state.setIn(
        ['ftModals', 'lookup'],
        fromJS({
          open: !action.payload.component.get('doNotOpenModal', false),
          component: action.payload.component,
          pageUID: action.payload.pageUID,
          uid: action.payload.uid,
          rulePath: action.payload.rulePath,
          statePath: action.payload.statePath,
          repeatIndex: action.payload.repeatIndex,
          isRepeat: action.payload.isRepeat,
          top: action.payload.top,
        })
      )
    }

    case actionTypes.CLOSE_LOOKUP_MODAL: {
      return state.setIn(
        ['ftModals', 'lookup'],
        fromJS({
          open: false,
        })
      )
    }

    case actionTypes.SET_IS_ALLOW_DEBUG_MODE: {
      return state.setIn(['IS_ALLOW_DEBUG_MODE'], action.payload.status)
    }
    case actionTypes.COND_RULES_SET_STATUS_BATCH: {
      let ret = state
      _.each(action.payload.rules, (payload) => {
        if (payload.path && _.isArray(payload.path)) {
          ret = ret.setIn(payload.path, fromJS(payload.status))
          try {
            if (typeof payload.isChanged === 'boolean') {
              ret = ret.setIn([...payload.path, 'isChanged'], payload.isChanged)
            }
          } catch (error) {}
        } else if (List.isList(payload?.path)) {
          ret = ret.setIn(payload.path.toJS(), fromJS(payload.status))
        }
      })
      return ret
    }
    case actionTypes.COND_RULES_SET_STATUS:
      {
        if (action.payload.path && _.isArray(action.payload.path)) {
          return state.setIn(action.payload.path, fromJS(action.payload.status))
        } else if (List.isList(action.payload?.path)) {
          return state.setIn(action.payload.path.toJS(), fromJS(action.payload.status))
        } else {
          if (process.env.NODE_ENV !== 'production') {
            console.error(action.payload)
          }
          return state
        }
      }
      break
    case actionTypes.COND_RULES_SET_STATUS_TO_FIELD:
      {
        return setValueByField(state, action.payload.mapToEl, action.payload.status.join(', '))
      }
      break
    case actionTypes.PROCESS_META_ITEMS: {
      const { PageUID, uid, choices, fieldProps } = action.payload
      let retState = state
      let resultChoices = choices
      if (!fieldProps) {
        return retState
      }
      if (fieldProps.isDistinct) {
        resultChoices = _.uniqBy(choices, function (e) {
          return e.label
        })
      }

      if (fieldProps.isRandomize) {
        resultChoices = _.shuffle(resultChoices)
      }

      retState = retState.setIn(['meta', PageUID, uid], fromJS(resultChoices))
      retState = retState.setIn(['metaInfo', PageUID, uid, 'processed'], true)
      return retState
    }
    case actionTypes.PROCESS_COND_RULES:
      return doProcessRules(
        state,
        _.get(action, 'payload.isPortal', false),
        _.get(action, 'payload.path'),
        _.get(action, 'payload.fullPath'),
        null,
        false,
        _.get(action, 'payload.isOnload'),
        _.get(action, 'payload.rowIndex')
      )
    case actionTypes.PROCESS_COND_RULES_BATCH: {
      return processCondRulesBatch(state, action)
    }
    case actionTypes.START_KANBAN_FIELDS_UPDATE: {
      let retState = startKanbanUpdate(state, action.payload)
      return retState
    }
    case actionTypes.APPLY_KANBAN_FIELDS_UPDATE: {
      let retState = applyKanbanUpdate(state, action.payload)
      return retState
    }
    case actionTypes.START_QUICK_UPDATE_TABLE: {
      const { pageUID, uid } = action.payload
      let retState = state
      // for single entry kanban
      retState = retState.setIn(['state', pageUID, `${uid}-PowerTableBatchChanged`], false)
      retState = retState.setIn(['state', pageUID, `${uid}-PowerTableBatchCompleted`], false)
      retState = retState.setIn(['state', pageUID, `${uid}-PowerTableBatchResult`], '')
      retState = retState.setIn(['state', pageUID, `${uid}-PowerTableBatchSuccess`], '')
      retState = retState.setIn(['state', pageUID, `${uid}-PowerTableBatchFailed`], '')

      retState = doProcessRules(
        retState,
        false,
        false,
        [],
        [
          [pageUID, `${uid}-PowerTableBatchChanged`],
          [pageUID, `${uid}-PowerTableBatchCompleted`],
          [pageUID, `${uid}-PowerTableBatchResult`],
          [pageUID, `${uid}-PowerTableBatchSuccess`],
          [pageUID, `${uid}-PowerTableBatchFailed`],
        ]
      )

      return retState
    }

    case actionTypes.APPLY_QUICK_UPDATE_TABLE: {
      const { pageUID, uid, data, updateRequest } = action.payload
      let hashInvalidRows = {}
      _.each(data.errors, function (row) {
        hashInvalidRows[row.row] = true
      })
      let retState = state
      let modified = state.getIn(['state', pageUID, `bulk-${uid}`], Map()).toJS()
      let defaultData = state.getIn(['state', pageUID, uid], Map()).toJS()

      let updatedSuccess = [],
        updateError = []
      let hashValues = {}
      if (typeof defaultData['valueFTHash'] === 'string') {
        hashValues[defaultData['valueFTHash']] = defaultData['value']
      } else {
        _.each(defaultData['valueFTHash'], (ftHash, index) => {
          hashValues[ftHash] = _.get(defaultData, ['value', index])
        })
      }
      _.each(updateRequest, function (row) {
        if (row && row.valueFTHash && hashValues[row.valueFTHash]) {
          if (hashInvalidRows[row.valueFTHash]) {
            updateError.push(hashValues[row.valueFTHash])
          } else {
            updatedSuccess.push(hashValues[row.valueFTHash])
          }
        }
      })

      retState = retState.setIn(['state', pageUID, `${uid}-PowerTableBatchChanged`], false)
      retState = retState.setIn(['state', pageUID, `${uid}-PowerTableBatchCompleted`], true)
      retState = retState.setIn(
        ['state', pageUID, `${uid}-PowerTableBatchResult`],
        [...updatedSuccess, ...updateError].join(',')
      )
      retState = retState.setIn(['state', pageUID, `${uid}-PowerTableBatchSuccess`], updatedSuccess.join(','))
      retState = retState.setIn(['state', pageUID, `${uid}-PowerTableBatchFailed`], updateError.join(','))

      retState = doProcessRules(
        retState,
        false,
        false,
        [],
        [
          [pageUID, `${uid}-PowerTableBatchChanged`],
          [pageUID, `${uid}-PowerTableBatchCompleted`],
          [pageUID, `${uid}-PowerTableBatchResult`],
          [pageUID, `${uid}-PowerTableBatchSuccess`],
          [pageUID, `${uid}-PowerTableBatchFailed`],
        ]
      )

      retState = retState.setIn(['formFieldStatuses', pageUID, uid], Map())

      _.each(modified, function (col, colUID) {
        _.each(col, function (val, rowIndex) {
          if (val !== undefined) {
            let ftHash = _.get(defaultData, ['valueFTHash', rowIndex])
            if (hashInvalidRows[ftHash]) {
              retState = retState.setIn(
                ['formFieldStatuses', pageUID, uid, 'row', rowIndex],
                fromJS({ status: 'error' })
              )
            } else {
              let path = ['state', pageUID, uid, colUID]
              if (isImmutable(retState.getIn(['state', pageUID, uid, colUID]))) {
                path.push(rowIndex)
                retState = retState.setIn(path, val)
              } else {
                retState = retState.setIn(path, fromJS([val]))
              }
              retState = retState.setIn(['state', pageUID, `bulk-${uid}`, colUID, rowIndex], undefined)
            }
          }
        })
      })

      return retState
    }
    case actionTypes.SET_ELEM_VALUE: {
      const { uid, value, type, path, doNotProcessCondition, propName, isIgnoreHidden } = action.payload
      let retState = state
      let allowAction = true
      const currentPageUID = state
        .getIn(['project', 'Pages'], List())
        .find((page) => page.get('_id') === state.get('page'))
        ?.get?.('uid')
      if (_.size(uid) === 1) {
        const isProjectElem = state.hasIn(['project', 'Settings', 'elements', _.first(uid)])
        const elem = state.hasIn(['project', 'Settings', 'elements', _.first(uid)])
          ? state.getIn(['project', 'Settings', 'elements', _.first(uid)], Map())
          : state.getIn(['pages', state.get('page'), 'Props', 'elements', _.first(uid)], Map())

        if (elem.size > 0) {
          //only if element exist continue check
          const rules = getElemReadOnlyRules(state, currentPageUID, uid, elem)
          let isReadOnlyRules = elem.getIn(['props', state.get('layoutMode', 'lg'), 'readOnly'])
          if (List.isList(rules) && rules.includes('readOnly')) {
            isReadOnlyRules = true
          } else if (List.isList(rules) && rules.includes('notReadOnly')) {
            isReadOnlyRules = false
          }
          if (isReadOnlyRules) {
            allowAction = false
          }
          if (List.isList(rules) && rules.includes('hide')) {
            allowAction = false
          }
        }
      } else {
        let [repeatUID, elemUid, index] = uid
        const isProjectElem = state.hasIn(['project', 'Settings', 'elements', elemUid])
        const elem = state.hasIn(['project', 'Settings', 'elements', elemUid])
          ? state.getIn(['project', 'Settings', 'elements', elemUid], Map())
          : state.getIn(['pages', state.get('page'), 'Props', 'elements', elemUid], Map())

        if (elem.size > 0) {
          //only if element exist continue check
          let repeatRoot = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
          if (repeatRoot.includes(repeatUID)) {
            const rules = state.getIn(
              ['rules', repeatUID, isProjectElem ? elem.get('parent') : currentPageUID, elemUid, index],
              List()
            )
            if (List.isList(rules) && rules.includes('hide')) {
              allowAction = false
            }
          }
        }
      }
      if (allowAction || isIgnoreHidden) {
        const changes = []
        if (type === 'ClearBulkPowerTable') {
          retState = retState.setIn(['formFieldStatuses', path[0], String(path[1]).replace('bulk-', '')], Map())
          retState = safeSetIn(retState, ['state', ...path], value)
        } else if (type === 'PowerTable') {
          let val = retState.getIn(['state', ...path])
          if (val === undefined) {
            let list = List()
            list = list.set(propName, value)
            retState = safeSetIn(retState, ['state', ...path], list)
          } else if (propName === 0 && !isImmutable(val)) {
            retState = safeSetIn(retState, ['state', ...path], List.of(value))
          } else {
            retState = safeSetIn(retState, ['state', ...path, propName], value)
          }
          return retState
        } else if (type === 'Lookup' || type === 'PickList') {
          retState = safeSetIn(retState, ['state', ...path, ...uid, propName], value)
          changes.push([...path, ...uid])
        } else if (type === 'Button') {
          retState = retState.setIn(['state', ...path, ...uid, 'BTN_TEXT'], value)
          changes.push([...path, ...uid, 'BTN_TEXT'])
        } else if (type === 'Image') {
          retState = retState.setIn(['state', ...path, ...uid, 'IMG_SRC'], value)
          changes.push([...path, ...uid, 'IMG_SRC'])
        } else if (type === 'Typography') {
          retState = retState.setIn(['state', ...path, ...uid, 'TYPO_TEXT'], value)
          changes.push([...path, ...uid, 'TYPO_TEXT'])
        } else {
          if (propName == 'checkboxSelectCount') {
            retState = safeSetIn(retState, ['state', ...path, ...uid], value)
            if (_.isArray(uid) && uid.length == 3) {
              let listValue = retState.getIn(['state', ...path, uid[0], uid[1]], List())
              if (isImmutable(listValue)) {
                let totalChecked = 0
                listValue.map((val) => {
                  if (val) {
                    totalChecked++
                  }
                })
                retState = retState.setIn(['state', path[0], uid[1] + '-selectedCount'], totalChecked)
                changes.push([path[0], uid[1] + '-selectedCount'])
              }
            }
          } else {
            try {
              retState = safeSetIn(retState, ['state', ...path, ...uid], value)
            } catch (error) {
              let appState = retState.get('state', Map()).toJS()
              _.set(appState, [...path, ...uid], value)
              retState = retState.setIn(['state'], fromJS(appState))
            }
          }
          changes.push([...path, ...uid])
        }
        if (doNotProcessCondition || IS_SERVER) {
          return retState
        }
        return doProcessRules(retState, Boolean(_.get(window.__FT_APP_STATE__, 'portal')), [], [], changes)
      }
    }
    case actionTypes.SET_ELEM_VALUE_BATCH: {
      return setElementValueBatch(state, action)
    }
    case actionTypes.REDIRECT_MODAL_CLOSE: {
      const { params } = action.payload
      let retState = state.setIn(['widgets', 'RedirectModal', 'needShow'], false)
      retState = retState.setIn(['widgets', 'PreviewDocGen', 'needShow'], false)
      retState = retState.setIn(['ftModals', 'lookup', 'open'], false)
      let changedPath = []
      if (params) {
        state.getIn(['project', 'params'], List()).map((param) => {
          let key = param.get('id')
          let oldVal = retState.getIn(['params', key])
          if (params && params[key] && params[key] !== oldVal) {
            retState = retState.setIn(['params', key], params[key])
            changedPath.push([key])
          }
        })
        if (changedPath.length) {
          retState = doProcessRules(retState, false, false, [], changedPath)
        }
      }

      return retState
    }
    case actionTypes.PROCESS_SHOW_MODAL:
      return state
        .setIn(['widgets', 'RedirectModal', 'needShow'], true)
        .setIn(['widgets', 'RedirectModal', 'params'], fromJS(action.payload.options))
    case actionTypes.SET_ELEM_RULE_STATUS: {
      const { target, status, path, settings } = action.payload
      const nextStatus = settings ? `${status}-${settings}` : status

      const elemPath = _.findIndex(target, (s) => _.startsWith(s, 'i?')) !== -1 ? _.tail(target) : [_.last(target)]
      return state.setIn(
        ['rules', ...elemPath],
        state
          .getIn(['rules', ...elemPath], List())
          .filter(
            (currentStatus) =>
              currentStatus !== getOpposite(status) && ['hide-move-top', 'hide-move-left'].indexOf(currentStatus) === -1
          )
          .push(nextStatus)
      )
    }
    case actionTypes.CALL_SF_ACTIONS:
      return state
        .setIn(['sfActions', 'needCall'], true)
        .setIn(['sfActions', 'params'], state.getIn(['sfActions', 'params'], List()).push(fromJS(action.payload.props)))
    case actionTypes.WIDGET_LAYOUT_MODE: {
      let page = state.get('page')
      try {
        if (window) {
          window.isRefreshedGrid = {}
        }
      } catch (err) {}

      let retState = state
        .setIn(['layoutMode'], action.payload.mode)
        .setIn(['widgets', 'recalcUI'], action.payload.mode !== 'lg')
        .setIn(['selected'], List())
        .setIn(['selectedArea'], List())

      let prevDevice = retState.getIn(['state', 'device'], '')
      retState = retState.setIn(['state', 'device'], LayoutNames[action.payload.mode])

      if (!action.payload.isProjectPreview) {
        if (retState.getIn(['pages', page])) {
          let isConfiguredSetConfigure = true
          if (state.getIn(['project', 'Settings', 'useResponsiveAI'], true)) {
            if (state.getIn(['project', 'Settings', 'responsiveAIConf', 'version']) == 2) {
              isConfiguredSetConfigure = false
            }
          }
          if (isConfiguredSetConfigure || state.get('isWebBuilder')) {
            retState = retState.setIn(['pages', page, 'Props', 'IsConfiguredDevice', action.payload.mode], true)
          }
        }
      }
      if (prevDevice !== LayoutNames[action.payload.mode] && !state.get('isWebBuilder')) {
        return doProcessRules(retState, false, [], [], [['device']], false, false, null)
      } else {
        return retState
      }
    }
    case actionTypes.WIDGET_SET_TARGET_RULES: {
      const { rules, target } = action.payload
      return state
        .setIn(
          HISTORY_PREV,
          state.getIn(HISTORY_PREV, List()).size >= HISTORY_ENTRY_COUNT
            ? state.getIn(HISTORY_PREV, List()).shift().push(CURRENT_PROJECT(state))
            : state.getIn(HISTORY_PREV, List()).push(CURRENT_PROJECT(state))
        )
        .setIn(
          ['project', 'Settings', 'rules'],
          state.getIn(['project', 'Settings', 'rules'], Map()).set(target, rules)
        )
        .setIn(['isProjectChanged'], true)
    }
    case actionTypes.WIDGET_VIEW_ITEM_DND_MOVE: {
      const { from, to, area, mode, place, pageID, columns, rowID, colID } = action.payload
      const root = getElementDataRoot(pageID)
      let toPageID = state.hasIn([...root, 'elements', to])
        ? pageID
        : pageID === 'project'
          ? state.get('page')
          : 'project'
      const toRoot = state.hasIn([...root, 'elements', to]) ? getElementDataRoot(pageID) : getElementDataRoot(toPageID)

      const fromElemParent = state.getIn([...root, 'elements', from, 'parent'])

      let retState = state.setIn(['isPageChanged'], true)

      if (!retState.hasIn([...toRoot, 'elements', to])) {
        return state
      }
      let isTitanFit = false
      try {
        if (String(from).startsWith('fit_') || String(to).startsWith('fit_')) {
          isTitanFit = true
        } else {
          let layoutMode = state.getIn(['layoutMode'], 'lg')
          if (layoutMode !== 'lg') {
            const gridArea = retState.getIn([...root, 'elements', from, 'props', layoutMode, 'gridArea'])
            if (gridArea === 'ft_auto_fit') {
              isTitanFit = true
            }
          }
        }
      } catch (err) {
        console.error(err)
      }
      if (isTitanFit) {
        const notification = fromJS({
          key: uuid(),
          message: `You can't add new elements here while on Auto Layout Mode.`,
          type: 'error',
        })
        return disableHistory(state).set('notifications', state.get('notifications', List()).push(notification))
      }
      const toType = retState.getIn([...toRoot, 'elements', to, 'type'])
      if (
        !['Strip', 'Stack', 'Scroll', 'Section', ...TAB_TYPES, 'Modal', 'DrawerEl', 'Form', 'RepeatAutoFit'].includes(
          toType
        )
      ) {
        return state
      }
      if (toType === 'Form') {
        const elemType = retState.getIn([...root, 'elements', from, 'type'])
        if (isWidgetType(elemType) || elemType == 'Form') {
          const notification = fromJS({
            key: 'error',
            message: 'You can not drop this field into the form area',
            type: 'error',
          })
          return state.set('notifications', state.get('notifications', List()).push(notification))
        }
      }
      if (place) {
        const ref = retState.getIn([...root, 'elements', from, 'props', 'styleRef'])
        retState = retState.setIn(
          [...root, 'styles', ref, mode, 'root'],
          retState.getIn([...root, 'styles', ref, mode, 'root'], Map()).merge(fromJS(getPlaceToStyle(place)))
        )
      }

      const isLandingProject =
        retState.getIn(['project', 'ProjectType'], 'web') === LANDING_TYPE ||
        retState.getIn([...toRoot, 'elements', columns?.stripUID, 'type']) === 'DrawerEl'

      if (isLandingProject && !_.isEmpty(columns)) {
        let toColumn = parseInt(columns.toColumn, 10)
        let fromColumn = parseInt(columns.fromColumn, 10)
        let elemUID = columns.uid
        let stripUID = columns.stripUID
        let fromChild = retState.getIn([...toRoot, 'elements', stripUID, 'children', fromColumn], List()).toJS()
        let toChild = retState.getIn([...toRoot, 'elements', to, 'children', toColumn], List())
        let toType = retState.getIn([...toRoot, 'elements', to, 'type'])

        if (
          (stripUID === to && toColumn === fromColumn) ||
          elemUID === to ||
          !['FlexStrip', 'DrawerEl'].includes(toType)
        ) {
          return state
        }

        if (elemUID && stripUID) {
          retState = retState.setIn([...toRoot, 'elements', to, 'children', toColumn], toChild.push(elemUID))
          retState = retState.setIn(
            [...toRoot, 'elements', stripUID, 'children', fromColumn],
            fromJS(_.filter(fromChild, (v) => v !== elemUID))
          )
          if (to !== stripUID) {
            retState = retState.setIn([...root, 'elements', from, 'parent'], to)
          }
        }
      }
      if (
        [
          'Form',
          'Stack',
          'Scroll',
          'Tab',
          'Stepper',
          'MultiStepper',
          'Accordion',
          'CarouselContainer',
          'TwoSideSection',
          'ContinualForm',
          'RepeatAutoFit',
          'Modal',
          'DrawerEl',
        ].indexOf(retState.getIn([...root, 'elements', fromElemParent, 'type'])) !== -1
      ) {
        retState = retState
          .setIn(
            [...root, 'elements'],
            retState.getIn([...root, 'elements'], Map()).map(processRemoveChildElements([from]))
          )
          .setIn(
            ['project', 'Settings', 'elements'],
            retState.getIn(['project', 'Settings', 'elements'], Map()).map(processRemoveChildElements([from]))
          )
      }
      if (pageID !== 'project') {
        ///remove elem from project
        retState = retState.setIn(
          ['project', 'Settings', 'elements'],
          retState
            .getIn(['project', 'Settings', 'elements'], Map())
            .delete(from)
            .map(processRemoveChildElements([from]))
        )
      }

      if (
        area &&
        toType !== 'Form' &&
        toType !== 'Tab' &&
        toType !== 'Stepper' &&
        toType !== 'MultiStepper' &&
        toType !== 'Accordion' &&
        toType !== 'CarouselContainer' &&
        toType !== 'TwoSideSection' &&
        toType !== 'ContinualForm'
      ) {
        _.each(_.slice(LAYOUT_MODE, 0, LAYOUT_MODE.indexOf(mode) + 1), (mode) => {
          retState = retState.setIn([...root, 'elements', from, 'props', mode, 'gridArea'], area)
        })
      } else if (area && toType === 'Form') {
        let children
        let col

        if (!colID) {
          children = retState
            .getIn([...toRoot, 'elements', to, 'props', mode, 'children', area, 'children'], Map())
            .toJS()
          col = _.first(_.keys(children))
        } else {
          children = retState
            .getIn([...toRoot, 'elements', to, 'props', mode, 'children', rowID || area, 'children'], Map())
            .toJS()
          col = colID
        }

        retState = retState.setIn(
          [...toRoot, 'elements', to, 'props', mode, 'children', area, 'children', col, 'children'],
          retState
            .getIn([...toRoot, 'elements', to, 'props', mode, 'children', area, 'children', col, 'children'], List())
            .push(from)
        )
        retState = retState.setIn(
          [...root, 'elements', from, 'props', mode, 'position'],
          retState
            .getIn([...root, 'elements', from, 'props', mode, 'position'], Map())
            .set('left', '0')
            .set('top', '0')
        )
        retState = retState.setIn([...root, 'styles', from, mode, 'root', 'widthUnit'], '%')
        retState = retState.setIn([...root, 'styles', from, mode, 'root', 'width'], '100')
      } else if (
        area &&
        (toType === 'Tab' ||
          toType === 'Stepper' ||
          toType === 'MultiStepper' ||
          toType === 'Accordion' ||
          toType === 'CarouselContainer' ||
          toType === 'TwoSideSection' ||
          toType === 'ContinualForm')
      ) {
        const tabs = retState.getIn([...toRoot, 'elements', to, 'props', mode, 'tabs'], List()).toJS()
        let tabIndex = _.findIndex(tabs, (tab) => tab.id === area)
        if (tabIndex === -1) {
          tabIndex = 0
        }
        retState = retState.setIn(
          [...toRoot, 'elements', to, 'props', mode, 'tabs', tabIndex, 'children'],
          retState.getIn([...toRoot, 'elements', to, 'props', mode, 'tabs', tabIndex, 'children'], List()).push(from)
        )
        if (toType !== 'MultiStepper') {
          retState = retState.setIn(
            [...root, 'elements', from, 'props', mode, 'position'],
            retState
              .getIn([...root, 'elements', from, 'props', mode, 'position'], Map())
              .set('left', '0')
              .set('top', '0')
          )
        }
      }

      if (to !== from && !isLandingProject) {
        let parentType = retState.getIn([...root, 'elements', fromElemParent, 'type'])
        let isExp = retState.getIn([...root, 'elements', fromElemParent, 'props', 'isExp'])
        if ((parentType == 'Modal' && !isExp) || parentType == 'DrawerEl') {
          let children = retState.getIn([...root, 'elements', fromElemParent, 'children'], List()).map((col) => {
            if (col && List.isList(col)) {
              return col.filter((uid) => uid !== from)
            } else {
              return List()
            }
          })
          retState = retState.setIn([...root, 'elements', fromElemParent, 'children'], children)
        } else if (
          ['Modal'].includes(retState.getIn([...root, 'elements', fromElemParent, 'type'])) &&
          retState.getIn([...root, 'elements', fromElemParent, 'props', 'isExp'])
        ) {
          _.each(LAYOUT_MODE, (mode) => {
            const tabs = retState
              .getIn([...root, 'elements', fromElemParent, 'props', mode, 'tabs'], List())
              .map((tab) => {
                if (tab.get('id') === action.payload?.columns?.toColumn) {
                  return tab.set(
                    'children',
                    tab.get('children', List()).filter((val) => val !== from)
                  )
                }
                return tab
              })
            retState = retState
              .setIn(
                [...root, 'elements', fromElemParent, 'children'],
                retState.getIn([...root, 'elements', fromElemParent, 'children'], List()).filter((val) => val !== from)
              )
              .setIn([...root, 'elements', fromElemParent, 'props', mode, 'tabs'], tabs)
          })
        } else {
          let children = retState.getIn([...root, 'elements', fromElemParent, 'children'], List())
          if (children && List.isList(children)) {
            retState = retState.setIn(
              [...root, 'elements', fromElemParent, 'children'],
              children.filter((uid) => uid !== from)
            )
          }
        }
        if (!isLandingProject) {
          if (
            ['Modal', 'DrawerEl'].includes(retState.getIn([...toRoot, 'elements', to, 'type'])) &&
            !retState.getIn([...toRoot, 'elements', to, 'props', 'isExp'])
          ) {
            let toColumn = 0
            if (columns && columns.toColumn) {
              toColumn = columns.toColumn
            }
            retState = retState.setIn(
              [...toRoot, 'elements', to, 'children', toColumn],
              retState.getIn([...toRoot, 'elements', to, 'children', toColumn], List()).push(from)
            )
          } else if (
            ['Modal'].includes(retState.getIn([...toRoot, 'elements', to, 'type'])) &&
            retState.getIn([...toRoot, 'elements', to, 'props', 'isExp'])
          ) {
            const mode = retState.get('layoutMode', 'lg')
            const tabs = retState.getIn([...toRoot, 'elements', to, 'props', mode, 'tabs'], List()).map((tab) => {
              if (tab.get('id') === action.payload?.columns?.toColumn) {
                return tab.set('children', tab.get('children', List()).push(from))
              }
              return tab
            })
            retState = retState
              .setIn(
                [...toRoot, 'elements', to, 'children'],
                retState.getIn([...toRoot, 'elements', to, 'children'], List()).push(from)
              )
              .setIn([...toRoot, 'elements', to, 'props', mode, 'tabs'], tabs)
            if (action.payload.columns.top || action.payload.columns.left) {
              retState = retState
                .setIn([...toRoot, 'elements', from, 'props', mode, 'position', 'top'], action.payload.columns.top || 0)
                .setIn([...toRoot, 'elements', from, 'props', mode, 'position', 'topUnit'], 'px')
                .setIn(
                  [...toRoot, 'elements', from, 'props', mode, 'position', 'left'],
                  action.payload.columns.left || 0
                )
                .setIn([...toRoot, 'elements', from, 'props', mode, 'position', 'leftUnit'], 'px')
            }
          } else {
            retState = retState.setIn(
              [...toRoot, 'elements', to, 'children'],
              retState.getIn([...toRoot, 'elements', to, 'children'], List()).push(from)
            )
          }
        }
        retState = retState.setIn([...root, 'elements', from, 'parent'], to)
      }
      if (area && ['Strip', 'Section'].indexOf(retState.getIn([...root, 'elements', fromElemParent, 'type'])) !== -1) {
        retState = retState.setIn([...root, 'elements', from, 'props', mode, 'gridArea'], area)
      }

      if (pageID !== toPageID) {
        const el = retState.getIn([...root, 'elements', from], Map())
        if (pageID == 'project') {
          let styleRef = el.getIn(['props', 'styleRef'])
          if (styleRef) {
            let isFoundRef = false
            let eleStyle = retState.getIn([...root, 'styles', styleRef], Map())
            retState.getIn([...root, 'elements'], Map()).map((elem, uid) => {
              if (uid != from && elem.getIn(['props', 'styleRef']) == styleRef) {
                isFoundRef = true
              }
            })

            if (!isFoundRef) {
              retState = retState.deleteIn([...root, 'styles', styleRef]).setIn([...toRoot, 'styles', from], eleStyle)
            }
          }
        }
        retState = retState.deleteIn([...root, 'elements', from]).setIn([...toRoot, 'elements', from], el)
      }

      let selected = [from]
      return retState.setIn(['selected'], fromJS(selected))
    }
    case actionTypes.PROJECT_PAGE_LOADING_STATUS:
      return disableHistory(state).setIn(['isPageLoading'], action.payload.status)
    case actionTypes.CLOSE_PERMISSION_ERROR:
      return state.setIn(['isShowInvalidLicenseModal'], false).setIn(['portalPermissionError'], false)
    case actionTypes.SET_PERMISSION_ERROR:
      return state.setIn(['portalPermissionError'], action.payload.error)
    case actionTypes.SET_DEFAULT_THEME:
      return state.set('DEFAULT_THEME', fromJS(action.payload.theme))
    case actionTypes.WIDGET_VIEW_ITEM_GRID_ADD_WIDGET: {
      return action.payload.state
    }
    case actionTypes.SET_RECALC_DEVICE_ELEMENT: {
      let retState = moveElementsToAutoFit(state, 'page')
      retState = moveElementsToAutoFit(retState, 'project')
      return retState.setIn(
        ['recalcDeviceElement'],
        fromJS({
          uid: action.payload.uid,
          isResize: action.payload.isResize,
          height: action.payload.height,
        })
      )
    }
    case actionTypes.PAGE_PROCESS_NEW_ELEM: {
      return action.payload.state
    }
    case actionTypes.WIDGET_VIEW_MODE:
      return state.setIn(['widgets', 'responsiveMode'], action.payload.mode)
    case actionTypes.WIDGET_VIEW_ITEM_GRID_ITEM_SPLIT: {
      return action.payload.state
    }
    case actionTypes.CONFIRM_DELETE_STRIP_AREA: {
      return state.setIn(['panels', 'confirmDeleteStripArea'], fromJS(action.payload))
    }
    case actionTypes.WIDGET_VIEW_ITEM_DELETE: {
      return action.payload.state
    }
    case actionTypes.WIDGET_VIEW_MULY_POSITION_CHANGED: {
      return action.payload.state
    }
    case actionTypes.WIDGET_VIEW_ITEM_CHANGE_PROP: {
      return action.payload.state
    }
    case actionTypes.WIDGET_VIEW_ITEM_RESIZE_PARENT: {
      const pageID = action.payload.pageID
      const root = getElementDataRoot(pageID)
      const layoutMode = state.getIn(['layoutMode'], 'lg')
      let retState = state.setIn(['isPageChanged'], true)
      const ref = getStyleRef(state, action.payload.parent, pageID)
      const elem = state.getIn([...getElementDataRoot(pageID), 'elements', action.payload.parent], Map())
      const mode = state.getIn(['layoutMode'], 'lg')

      const parentType = elem.get('type')
      const isResizeActiveStep = elem.getIn(['props', mode, 'isResizeActiveStep'])
      const isTabType = TAB_TYPES.includes(parentType)
      const allowResizeMultiStep = parentType === 'MultiStepper' && isResizeActiveStep
      const PageUID = state
        .getIn(['project', 'Pages'], List())
        .find((page) => page.get('_id') === state.get('page'))
        ?.get?.('uid')
      if (((isTabType && parentType != 'MultiStepper') || allowResizeMultiStep) && PageUID) {
        const getParentRepeatPath = (type) => {
          const parentType = getParentIdInModal(
            state,
            state.getIn([...getElementDataRoot(pageID), 'elements', action.payload.parent, 'parent']),
            state.get('page') !== pageID
          )
          return state.get('page') !== pageID
            ? ['state', parentType, action.payload.parent, 'ftListValue']
            : ['state', PageUID, action.payload.parent, 'ftListValue']
        }
        let tabs = updateTabValue(elem.getIn(['props', layoutMode, 'tabs'], List()))
        let valuePath = getParentRepeatPath(parentType)
        let valueOrigin = state.getIn(valuePath, tabs.getIn([0, 'ftValue']))
        let value = fixID(valueOrigin)
        tabs.map((tab) => {
          if (tab.get('ftValue') === valueOrigin) {
            value = fixID(tab.get('id'))
          }
        })
        if (parentType === 'Accordion') {
          tabs.map((tab) => {
            if (tab.get('ftValue') === valueOrigin) {
              value = fixID(`content-${tab.get('id')}`)
            }
          })
        }
        if (value) {
          if (parentType === 'Tab') {
            return retState
              .setIn([...root, 'styles', ref, mode, 'root', 'minHeight'], '')
              .setIn([...root, 'styles', ref, mode, 'root', 'height'], action.payload.value)
              .setIn([...root, 'styles', ref, mode, 'root', 'heightUnit'], 'px')
              .setIn([...root, 'styles', ref, mode, value, 'minHeight'], '')
              .setIn([...root, 'styles', ref, mode, value, 'height'], action.payload.value)
              .setIn([...root, 'styles', ref, mode, value, 'heightUnit'], 'px')
          } else {
            return retState
              .setIn([...root, 'styles', ref, mode, 'root', 'minHeight'], '')
              .setIn([...root, 'styles', ref, mode, 'root', 'height'], 'auto')
              .setIn([...root, 'styles', ref, mode, value, 'minHeight'], action.payload.value)
              .setIn([...root, 'styles', ref, mode, value, 'height'], '')
          }
        }
      } else {
        return retState
          .setIn([...root, 'styles', ref, mode, 'root', 'minHeight'], action.payload.value)
          .setIn([...root, 'styles', ref, mode, 'row0'], action.payload.value)
          .setIn([...root, 'styles', ref, mode, 'row0Unit'], 'px')
      }
    }
    case actionTypes.WIDGET_VIEW_ITEM_RESIZE_ITERATION: {
      return state.setIn(['autoSize', action.payload.uid], action.payload.index)
    }
    case actionTypes.WIDGET_VIEW_ITEM_RESIZE: {
      const isClean = _.get(action, ['payload', 'isClean']) || _.get(action, ['payload', 'params', 'isEffect'])
      const pageID = action.payload.pageID
      const root = getElementDataRoot(pageID)
      let retState = state
      if (!isClean) {
        retState = retState
          .setIn(
            HISTORY_PREV,
            state.getIn(HISTORY_PREV, List()).size >= HISTORY_ENTRY_COUNT
              ? state.getIn(HISTORY_PREV, List()).shift().push(CURRENT_PROJECT(state))
              : state.getIn(HISTORY_PREV, List()).push(CURRENT_PROJECT(state))
          )
          .setIn(['isPageChanged'], true)
          .setIn(['isProjectChanged'], true)
          .setIn(['effectedPages', pageID || state.get('page')], true)
      } else {
        retState = retState.set('disableDelta', true)
      }

      const selected = action.payload.uid
      if (!selected) {
        return state
      }

      let widthKeys = ['width', 'widthUnit', 'minWidth', 'minWidthUnit']
      let heightKeys = ['height', 'heightUnit', 'minHeight', 'minHeightUnit']
      if (_.startsWith(selected, 'Header') || _.startsWith(selected, 'Footer')) {
        if (selected === 'Header' || selected === 'Footer') {
          const [layout, ...rest] = action.payload.path
          let styles = retState.getIn(['project', 'Settings', 'styles', selected, layout, ...rest], Map())
          if (action.payload.params) {
            if (action.payload.params.isWidth) {
              _.each(widthKeys, function (key) {
                if (action.payload.value.get(key)) {
                  styles = styles.set(key, action.payload.value.get(key))
                }
              })
            }
            if (action.payload.params.isHeight) {
              _.each(heightKeys, function (key) {
                if (action.payload.value.get(key)) {
                  styles = styles.set(key, action.payload.value.get(key))
                }
              })
            }
          }
          retState = retState.setIn(['project', 'Settings', 'styles', selected, layout, ...rest], styles)
        } else {
          return state
        }
      } else {
        const styleRef = retState.getIn([...root, 'elements', selected, 'props', 'styleRef'])

        const isGlobalStyle = retState.getIn(['project', 'Settings', 'styles', styleRef, 'isGlobal'])
        const styleKey = isGlobalStyle ? ['project', 'Settings'] : root

        const type = retState.getIn([...root, 'elements', selected, 'type'])

        const layout = state.get('layoutMode', 'lg')
        const width = action.payload.value.get('width')
        const disableInherit = retState.getIn([
          ...root,
          'elements',
          selected,
          'props',
          layout,
          'position',
          'disableInherit',
        ])
        const isPowerTable = type === 'PowerTable'
        const oldWidth =
          retState.getIn([...styleKey, 'styles', styleRef, layout, 'root', 'width']) ||
          retState.getIn([...styleKey, 'styles', styleRef, layout, 'root', 'minWidth'])

        if (type === 'Form') {
          let delta = width - oldWidth
          const cols = retState.getIn([...styleKey, 'styles', selected, 'cols', layout], Map()).toJS()
          const lastCol = _.max(_.keys(cols))
          if (lastCol) {
            let val = parseInt(cols[lastCol])
            retState = retState.setIn([...styleKey, 'styles', selected, 'cols', layout, lastCol], `${val + delta}px`)
          }
        }

        let prefix = []
        if (action.payload.value.has('root')) {
          prefix = ['root']
        }
        if (disableInherit) {
          let position = retState.getIn([...root, 'elements', selected, 'props', layout, 'position'], Map())
          if (action.payload.params) {
            if (action.payload.params.isWidth) {
              _.each(widthKeys, function (key) {
                position = position.set(key, action.payload.value.getIn([...prefix, key]))
              })
            }
            if (action.payload.params.isHeight) {
              _.each(heightKeys, function (key) {
                if (!(isPowerTable && key === 'minHeight')) {
                  position = position.set(key, action.payload.value.getIn([...prefix, key]))
                }
              })
            }
          }
          retState = retState.setIn([...root, 'elements', selected, 'props', layout, 'position'], position)
        } else {
          retState = retState.setIn(
            [...styleKey, 'styles', styleRef, ...action.payload.path],
            fromJS(action.payload.value)
          )
        }

        if (action.payload.params && action.payload.params.isDismiss) {
          return retState
        }
        retState.getIn(['selected'], List()).map((elemUID) => {
          if (action.payload.uid != elemUID) {
            let elemRef = retState.getIn([...root, 'elements', elemUID, 'props', 'styleRef'])
            const disableInherit = retState.getIn([
              ...root,
              'elements',
              elemUID,
              'props',
              layout,
              'position',
              'disableInherit',
            ])
            if (disableInherit) {
              let position = retState.getIn([...root, 'elements', elemUID, 'props', layout, 'position'], Map())
              if (action.payload.params) {
                if (action.payload.params.isWidth) {
                  _.each(widthKeys, function (key) {
                    position = position.set(key, action.payload.value.getIn([...prefix, key]))
                  })
                }
                if (action.payload.params.isHeight) {
                  _.each(heightKeys, function (key) {
                    position = position.set(key, action.payload.value.getIn([...prefix, key]))
                  })
                }
              }
              retState = retState.setIn([...root, 'elements', elemUID, 'props', layout, 'position'], position)
            } else {
              let styles = retState.getIn([...styleKey, 'styles', elemRef, ...action.payload.path], Map())
              if (action.payload.params) {
                if (action.payload.params.isWidth) {
                  _.each(widthKeys, function (key) {
                    if (action.payload.value.get(key)) {
                      styles = styles.set(key, action.payload.value.get(key))
                    }
                  })
                }
                if (action.payload.params.isHeight) {
                  _.each(heightKeys, function (key) {
                    if (action.payload.value.get(key)) {
                      styles = styles.set(key, action.payload.value.get(key))
                    }
                  })
                }
              }
              retState = retState.setIn([...styleKey, 'styles', elemRef, ...action.payload.path], styles)
            }
          }
        })
      }

      return retState
    }
    case actionTypes.WIDGET_VIEW_ITEM_MULTIPLE_RESIZE: {
      let isClean = false
      _.each(action.payload, (payload) => {
        if (_.get(payload, ['params', 'isEffect']) || _.get(payload, ['isClean'])) {
          isClean = true
          return false
        }
      })
      let retState = state
      if (!isClean) {
        retState = retState
          .setIn(
            HISTORY_PREV,
            state.getIn(HISTORY_PREV, List()).size >= HISTORY_ENTRY_COUNT
              ? state.getIn(HISTORY_PREV, List()).shift().push(CURRENT_PROJECT(state))
              : state.getIn(HISTORY_PREV, List()).push(CURRENT_PROJECT(state))
          )
          .setIn(['isPageChanged'], true)
          .setIn(['isProjectChanged'], true)
          .setIn(['effectedPages', action.payload.pageID || state.get('page')], true)
      } else {
        retState = retState.set('disableDelta', true)
      }

      _.map(action.payload, function (payload) {
        const pageID = payload.pageID
        const root = getElementDataRoot(pageID)
        const selected = payload.uid
        if (!selected) {
          return false
        }

        let widthKeys = ['width', 'widthUnit', 'minWidth', 'minWidthUnit']
        let heightKeys = ['height', 'heightUnit', 'minHeight', 'minHeightUnit']
        if (_.startsWith(selected, 'Header') || _.startsWith(selected, 'Footer')) {
          if (selected === 'Header' || selected === 'Footer') {
            const [layout, ...rest] = payload.path
            let styles = retState.getIn(['project', 'Settings', 'styles', selected, layout, ...rest], Map())
            if (payload.params) {
              if (payload.params.isWidth) {
                _.each(widthKeys, function (key) {
                  if (payload.value.get(key)) {
                    styles = styles.set(key, payload.value.get(key))
                  }
                })
              }
              if (payload.params.isHeight) {
                _.each(heightKeys, function (key) {
                  if (payload.value.get(key)) {
                    styles = styles.set(key, payload.value.get(key))
                  }
                })
              }
            }
            retState = retState.setIn(['project', 'Settings', 'styles', selected, layout, ...rest], styles)
          } else {
            return false
          }
        } else {
          const styleRef = retState.getIn([...root, 'elements', selected, 'props', 'styleRef'])
          const type = retState.getIn([...root, 'elements', selected, 'type'])

          const layout = state.get('layoutMode', 'lg')
          const width = payload.value.get('width')
          const oldWidth =
            retState.getIn([...root, 'styles', selected, layout, 'root', 'width']) ||
            retState.getIn([...root, 'styles', selected, layout, 'root', 'minWidth'])

          if (type === 'Form') {
            let delta = width - oldWidth
            const cols = retState.getIn([...root, 'styles', selected, 'cols', layout], Map()).toJS()
            const lastCol = _.max(_.keys(cols))
            if (lastCol) {
              let val = parseInt(cols[lastCol])
              retState = retState.setIn([...root, 'styles', selected, 'cols', layout, lastCol], `${val + delta}px`)
            }
          }

          let elemStyles = retState.getIn([...root, 'styles', styleRef, ...payload.path], Map())
          if (payload.params) {
            if (payload.params.isWidth) {
              _.each(widthKeys, function (key) {
                if (payload.value.get('root')) {
                  if (payload.value.getIn(['root', key])) {
                    elemStyles = elemStyles.setIn(['root', key], payload.value.getIn(['root', key]))
                  }
                }
                if (payload.value.get(key) || String(key).indexOf('row') > -1) {
                  elemStyles = elemStyles.set(key, payload.value.get(key))
                }
              })
            }
            if (payload.params.isHeight) {
              _.each(heightKeys, function (key) {
                if (payload.value.get('root')) {
                  payload.value.map((newStyle, pathKey) => {
                    if (payload.value.getIn([pathKey, key]) && isImmutable(newStyle)) {
                      elemStyles = elemStyles.setIn([pathKey, key], newStyle.getIn([key]))
                    }
                  })
                }
                if (payload.value.get(key) || String(key).indexOf('row') > -1) {
                  elemStyles = elemStyles.set(key, payload.value.get(key))
                }
              })
            }
            if (TAB_TYPES.includes(type)) {
              elemStyles = payload.value
            }
            if (type === 'Strip') {
              elemStyles = payload.value
            }
          }
          retState = retState.setIn([...root, 'styles', styleRef, ...payload.path], elemStyles)

          if (payload.params && payload.params.isDismiss) {
            return false
          }
          retState.getIn(['selected'], List()).map((elemUID) => {
            if (payload.uid != elemUID) {
              let elemRef = retState.getIn([...root, 'elements', elemUID, 'props', 'styleRef'])
              let styles = retState.getIn([...root, 'styles', elemRef, ...payload.path], Map())
              if (payload.params) {
                if (payload.params.isWidth) {
                  _.each(widthKeys, function (key) {
                    if (payload.value.get(key)) {
                      styles = styles.set(key, payload.value.get(key))
                    }
                  })
                }
                if (payload.params.isHeight) {
                  _.each(heightKeys, function (key) {
                    if (payload.value.get(key)) {
                      styles = styles.set(key, payload.value.get(key))
                    }
                  })
                }
              }
              retState = retState.setIn([...root, 'styles', elemRef, ...payload.path], styles)
            }
          })
        }
      })
      return retState
    }
    case actionTypes.FETCH_DATA_ERROR: {
      const notification = fromJS({
        key: uuid(),
        message: action.payload.error,
        type: 'error',
      })
      return state.set('notifications', state.get('notifications', List()).push(notification))
    }
    case actionTypes.NOTIFY_ERROR: {
      const notification = fromJS({
        key: action.payload.key,
        message: action.payload.message,
        type: 'error',
      })
      return disableHistory(state).set('notifications', state.get('notifications', List()).push(notification))
    }
    case actionTypes.NOTIFY_SUCCESS: {
      const notification = fromJS({
        key: action.payload.key,
        message: action.payload.message,
        type: 'success',
      })
      return disableHistory(state).set('notifications', state.get('notifications', List()).push(notification))
    }
    case actionTypes.SAVE_THEME:
      return state.set('isThemeSave', true)
    case actionTypes.APPLY_THEME:
      return state.setIn(['Theme'], fromJS(action.payload.theme)).set('isThemeChanged', false)
    case actionTypes.WIDGET_UPDATE_PARAMS: {
      let retState = state
        .setIn(action.payload.path, action.payload.params)
        .setIn(['isProjectChanged'], true)
        .setIn(['isPageChanged'], true)
      if (action.payload.path[1] != 'Settings') {
        retState = retState.setIn(['iAllPagesChanged'], true).setIn(['effectedPages', action.payload.path[1]], true)
      }
      return retState
    }
    case actionTypes.WB_SRV_LIST:
      return state.setIn(['widgets', 'isWidgetsLoading'], true).setIn(['widgets', 'list'], List())
    case actionTypes.WB_SRV_LIST_ERROR:
      return state.setIn(['widgets', 'isWidgetsLoading'], false).set(
        'notifications',
        state.get('notifications', List()).push(
          fromJS({
            key: uuid(),
            message: action.payload.error === 'network_error' ? 'Network error' : `Can't load widgets list. Try later.`,
            type: 'error',
          })
        )
      )
    case actionTypes.WB_SRV_LIST_SUCCESS:
      return state
        .setIn(['widgets', 'isWidgetsLoading'], false)
        .setIn(['widgets', 'list'], fromJS(action.payload.widgets).toList())
    case actionTypes.WIDGET_BUILDER_UPDATE: {
      return action.payload.state
    }
    case actionTypes.PORTAL_SERVER_LOAD_PORTAL_ERROR:
      return state.setIn(['portal', 'isPortalFetching'], false).set(
        'notifications',
        state.get('notifications', List()).push(
          fromJS({
            key: uuid(),
            message:
              action.payload.error === 'network_error'
                ? 'Network error'
                : `Can't load Salesforce portal now. Try later.`,
            type: 'error',
          })
        )
      )
    case actionTypes.PORTAL_SERVER_LOAD_LIST:
      return state.setIn(['portal', 'isPortalFetchingList'], true).setIn(['portals'], List())
    case actionTypes.PORTAL_SERVER_LOAD_LIST_SUCCESS:
      return state.setIn(['portal', 'isPortalFetchingList'], false).setIn(['portals'], fromJS(action.payload.portals))
    case actionTypes.PROJECT_SERVER_UPDATE:
      return state.setIn(['isProjectSaving'], true)
    case actionTypes.SHOW_MODAL_ASK_USER_TEXT: {
      return state.setIn(['panels', 'askUserText'], fromJS(action.payload))
    }
    case actionTypes.PROJECT_SERVER_UPDATE_SUCCESS: {
      const {
        project,
        page,
        isSaveProject,
        isSavePage,
        pageStatus,
        projectStatus,
        docGenRefreshed,
        version,
        committedVersionId,
      } = action.payload
      let ret = state
        .setIn(['isProjectSaving'], false)
        .setIn(['iAllPagesChanged'], false)
        .setIn(['effectedPages'], Map())
      if (isSaveProject && projectStatus) {
        ret = ret.set('isProjectChanged', false)
        if (project) {
          ret = ret.set('project', fromJS(project))
        }
        ret = ret.setIn(['project', 'Settings', 'private', 'isVersionCommitted'], Boolean(version))
        if (committedVersionId) {
          ret = ret.setIn(['project', 'Settings', 'private', 'VersionId'], committedVersionId)
        }
      }
      if (action.payload.shortUrl) {
        ret = ret
          .setIn(['project', 'Settings', 'ui', 'shortUrl'], action.payload.shortUrl)
          .setIn(['project', 'ShortUrl'], action.payload.previewShortUrl)
      }
      if (isSavePage && pageStatus) {
        const pageID = ret.get('page')
        ret = ret.set('isPageChanged', false)
        if (page) {
          ret = ret.setIn(['pages', pageID], fromJS(page))
        }
      }

      if (docGenRefreshed) {
        _.each(docGenRefreshed, function (row, uid) {
          if (row && uid) {
            ret = ret.setIn(['project', 'Settings', 'store', 'private', uid], fromJS(row))
          }
        })
      }

      if (state.getIn(['project', 'ProjectType']) === 'surveyEmail') {
        ret = ret.setIn(['iAllPagesChanged'], false).setIn(['isPageChanged'], false).setIn(['effectedPages'], Map())
      }

      return ret
    }
    case actionTypes.PORTAL_SF_REPORT_DATA_FETCH:
      return state.setIn(['sf', 'report'], null).setIn(['sf', 'isLoadingReportData'], true)
    case actionTypes.PORTAL_SF_REPORT_DATA_ERROR: {
      action.payload.error && console.error(action.payload.error)
      return state
        .setIn(['sf', 'report'], null)
        .setIn(['sf', 'isLoadingReportData'], false)
        .set(
          'notifications',
          state.get('notifications', new List()).push(
            fromJS({
              key: uuid(),
              message: `Can't get Salesforce report info`, //check network error or grant
              type: 'error',
            })
          )
        )
    }
    case actionTypes.PORTAL_SF_REPORT_DATA_SUCCESS: {
      if (action.payload.report && _.isObject(action.payload.report)) {
        return state
          .setIn(['sf', 'report'], fromJS(action.payload.report).toMap())
          .setIn(['sf', 'isLoadingReportData'], false)
      } else {
        return state.setIn(['sf', 'isLoadingReportData'], false)
      }
    }
    case actionTypes.PORTAL_SF_REPORT_LIST_FETCH:
      return state.setIn(['sf', 'reports'], new List())?.setIn(['sf', 'isLoadingReports'], true)
    case actionTypes.PORTAL_SF_REPORT_LIST_ERROR: {
      action.payload.error && console.error(action.payload.error)
      return state
        .setIn(['sf', 'reports'], new List())
        ?.setIn(['sf', 'isLoadingReports'], false)
        ?.set(
          'notifications',
          state.get('notifications', new List())?.push(
            fromJS({
              key: uuid(),
              message: `Can't get Salesforce reports`, //check network error or grant
              type: 'error',
            })
          )
        )
    }
    case actionTypes.PORTAL_SF_REPORT_LIST_SUCCESS: {
      return state
        .setIn(['sf', 'reports'], fromJS(action.payload.reports)?.toList())
        ?.setIn(['sf', 'isLoadingReports'], false)
    }
    case actionTypes.REFRESH_PREVIEW_MODE: {
      const { mode } = action.payload
      if (state.getIn(['layoutMode']) !== mode) {
        return setWidgetElemStaticVal(state.setIn(['layoutMode'], mode))
      } else {
        return state
      }
    }
    case actionTypes.SET_WIDGET_PREVIEW_MAPPED_DATA: {
      const { data } = action.payload
      if (get(data, ['ssoParams', 'data'])) {
        _.each(get(data, ['ssoParams', 'data']), function (val, key) {
          let path = key.split(':')
          state = state.setIn(['state', ...path], val)
        })
      }
      return state
    }

    case actionTypes.PORTAL_SET_WIDGET_DATA:
      const widget = action.payload.widget
      if (widget.Type === 'view') {
        if (widget?.Props?.Grid?.lg) {
          _.set(widget, 'Props.Grid', [widget?.Props?.Grid?.lg])
        }
      }
      return state.setIn(['widgets', 'data', action.payload.widget._id], fromJS(widget))
    case actionTypes.PROJECT_UPDATE_PAGES: {
      let retState = disableHistory(state)
      _.each(action.payload.pages, function (page, pageID) {
        let badPageElements = {}
        badPageElements[pageID] = []
        _.each(_.get(page, ['Props', 'elements'], {}), (elem, id) => {
          if (!elem.type) {
            badPageElements[pageID].push(id)
          }
          if (_.isEmpty(elem)) {
            badPageElements[pageID].push(id)
          }
        })
        let pageElements = _.omit(_.get(page, ['Props', 'elements'], {}), badPageElements[pageID])
        let pageStyles = _.omit(_.get(page, ['Props', 'styles'], {}), badPageElements[pageID])
        _.each(pageElements, (elem, id) => {
          let parent = elem.parent
          if (pageElements[parent]) {
            if (!_.includes(pageElements[parent].children, id)) {
              if (_.isArray(pageElements[parent].children)) {
                pageElements[parent].children.push(id)
              }
            }
            try {
              if (pageElements[parent]?.type === 'Form') {
                _.each(LAYOUT_MODE, (mode) => {
                  if (pageElements[parent]?.props?.[mode]) {
                    let isHaveChild = false
                    _.each(pageElements[parent]?.props?.[mode]?.children, (row) => {
                      if (!isHaveChild) {
                        _.each(row?.children, (col) => {
                          if (_.includes(col?.children, id)) {
                            isHaveChild = true
                            return false
                          }
                        })
                      } else {
                        return false
                      }
                    })
                    if (!isHaveChild) {
                      let child = pageElements[parent]?.props?.[mode]?.children
                      let rows = _.reduce(child, (ret, row, rowID) => [...ret, { id: rowID, row }], [])
                      rows = _.sortBy(rows, 'row.index')
                      if (rows && rows.length) {
                        let rowID = rows[rows.length - 1].id
                        let colId = _.first(_.keys(child[rowID]?.children))
                        if (_.isArray(child[rowID]?.children?.[colId]?.children)) {
                          child[rowID].children[colId].children.push(id)
                        }
                        pageElements[parent].props[mode].children = child
                      }
                    }
                  }
                })
              }
            } catch (error) {
              console.error(error)
            }
          }
        })
        _.set(page, ['Props', 'elements'], pageElements)
        _.set(page, ['Props', 'styles'], pageStyles)
        retState = retState.setIn(['pages', pageID], fromJS(page))
      })
      return processUpdateFormFieldStyles(retState)
    }
    case actionTypes.PROJECT_BUILDER_SELECT_PAGE:
      return disableHistory(state)
        .setIn(['layoutMode'], 'lg')
        .set('page', action.payload.page)
        .set('selected', List())
        .setIn(['panels', 'elemenSettings'], fromJS({ open: false }))
        .setIn(['panels', 'elementStyle'], fromJS({ open: false }))
        .setIn(['devPage'], null)
    case actionTypes.PREPARE_GET_LANG:
      return disableHistory(state).set('lang', fromJS(action.payload))
    case actionTypes.PREPARE_GET_OAUTH_LINKS:
      return disableHistory(state).setIn(['sf', 'links'], fromJS(action.payload.links))
    case actionTypes.PREPARE_SF_GET_OAUTH_STATUS:
      return disableHistory(state).setIn(['sf', 'alive'], fromJS(action.payload))
    case actionTypes.PREPARE_GET_OAUTH_STATUS:
      return disableHistory(state).setIn(
        ['sf', 'connection'],
        action.payload.connection ? fromJS(action.payload.connection) : List()
      )
    case actionTypes.PREPARE_GET_STRIP_TEMPLATES:
      return disableHistory(state)
        .setIn(['prepare', 'stripTemplates'], fromJS(action.payload.list))
        .setIn(['prepare', 'templateCategories'], fromJS(action.payload.categories))
    case actionTypes.PREPARE_GET_OAUTH_ALIVE_STATUS: {
      let hashAlive = {}
      if (action.payload.allAlive) {
        _.each(action.payload.allAlive, function (row) {
          if (row) {
            hashAlive[row.service] = row
          }
        })
      }
      if (action.payload.status) {
        return disableHistory(state)
          .setIn(['sf', 'alive', 'status'], action.payload.status)
          .setIn(['sf', 'alive', 'username'], action.payload.username)
          .setIn(['sf', 'alive', 'platform'], action.payload.platform)
          .setIn(['sf', 'alive', 'instanceUrl'], action.payload.instanceUrl)
          .setIn(['sf', 'alive', 'hashAlive'], fromJS(hashAlive))
      } else {
        return disableHistory(state)
          .setIn(['sf', 'alive', 'status'], action.payload.status)
          .setIn(['sf', 'alive', 'username'], undefined)
          .setIn(['sf', 'alive', 'hashAlive'], fromJS(hashAlive))
          .setIn(['sf', 'alive', 'platform'], undefined)
      }
    }
    case actionTypes.REFRESH_PUSH_SALESFORCE_GRID_FIELDS:
      return disableHistory(state).setIn(action.payload.path, fromJS(action.payload.fields))
    case actionTypes.REFRESH_GET_SALESFORCE_GRID_FIELDS:
      return disableHistory(state).setIn(action.payload.path, fromJS(action.payload.fields))
    case actionTypes.GET_SALESFORCE_OBJECTS_FIELDS_REQUEST_SUCCESS:
      return disableHistory(state)
        .setIn(['sf', 'isLoadingFields'], false)
        .setIn(['sf', 'fields', action.payload.object], fromJS(action.payload.fields))
    case actionTypes.GET_SALESFORCE_OBJECTS_FIELDS_REQUEST_ERROR:
      return disableHistory(state)
        .setIn(['sf', 'isLoadingFields'], false)
        .set(
          'notifications',
          state.get('notifications', new List()).push(
            fromJS({
              key: uuid(),
              message: `Can't get Salesforce object`, //check network error or grant
              type: 'error',
            })
          )
        )
    case actionTypes.GET_SALESFORCE_OBJECTS_FIELDS_REQUEST:
      return disableHistory(state).setIn(['sf', 'isLoadingFields'], true)

    case actionTypes.GET_SALESFORCE_OBJECTS_REQUEST_SUCCESS: {
      let retState = disableHistory(state)
        .setIn(['sf', 'isLoadingObjects'], false)
        .setIn(['sf', 'objects'], fromJS(action.payload.objects))

      if (action.payload.isClearFields) {
        retState = retState.setIn(['sf', 'fields'], Map())
        retState = retState.setIn(['sf', 'reports'], List())
      }
      return retState
    }
    case actionTypes.GET_SALESFORCE_OBJECTS_REQUEST_ERROR:
      return disableHistory(state)
        .setIn(['sf', 'isLoadingObjects'], false)
        .set(
          'notifications',
          state.get('notifications', new List()).push(
            fromJS({
              key: uuid(),
              message: `Can't get Salesforce object`, //check network error or grant
              type: 'error',
            })
          )
        )
    case actionTypes.GET_SALESFORCE_OBJECTS_REQUEST:
      return disableHistory(state).setIn(['sf', 'isLoadingObjects'], true)
    case actionTypes.SET_USER:
      return state
        .setIn(['session', 'userInfo'], fromJS(action.payload.user))
        .setIn(['session', 'isAuth'], action.payload.user.UserID !== undefined)
    case actionTypes.REMOVE_SNACKBAR:
      return disableHistory(state).set(
        'notifications',
        state.get('notifications', new List()).filter((notification) => notification.get('key') !== action.payload.key)
      )
    case actionTypes.ENQUEUE_SNACKBAR: {
      const notification = fromJS({
        key: action.payload.notification.key || uuid(),
        message: action.payload.notification.message,
        type: action.payload.notification.type,
        options: action.payload.notification.options,
      })
      return disableHistory(state).set(
        'notifications',
        state.get('notifications', new List()).push(notification.set('action', action.payload.notification.action))
      )
    }
    case actionTypes.DOCUMENT_REQUEST_INVALID_LICENSE:
      return state
        .set('isShowInvalidLicenseModal', true)
        .set('licenseErrorDetails', action.payload)
        .setIn(['prepare', 'isUpload'], false)
        .setIn(['prepare', 'isUpdate'], false)
        .setIn(['prepare', 'isUpdateError'], true)
    case actionTypes.GET_AUTH_REQUEST: {
      if (action.payload.status === false) {
        window.location.href = '/SignIn?page=' + location.pathname
      }
      return state.setIn(['session', 'isAuth'], action.payload.status)
    }
    default:
      return state
  }
}

export const ftProjectUpdateParams = (params) => (dispatch, getState) => {
  let store = getState()
  _.each(params, (value, key) => {
    store = store.setIn(['params', key], value)
  })
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: store,
    },
  })
}

export const historyBatchStart = () => (dispatch, getState) =>
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().set('historyBatch', true).set('historyBatchBegin', true),
    },
  })

export const historyBatchEnd = () => (dispatch, getState) =>
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().set('historyBatch', true).set('historyBatchEnd', true),
    },
  })

let commitData = null

const historyReducer = (state = appInitialState, action) => {
  try {
    const prevState = state
    let nextState = reducer(state, action)
    if (nextState.get('historyBatch') && nextState.get('historyBatchBegin')) {
      commitData = nextState
      nextState = nextState.set('disableDelta', true).delete('historyBatchBegin')
    } else if (nextState.get('historyBatch') && nextState.get('historyBatchEnd') && isImmutable(commitData)) {
      nextState = nextState.set('disableDelta', true).delete('historyBatch').delete('historyBatchEnd')
      window?.__FT__BUILDER_API__?.calcHistory?.(
        commitData,
        nextState,
        nextState.get('historyKey'),
        nextState.get('keepNext')
      )
      commitData = null
    } else if (nextState.get('historyBatch')) {
      nextState = nextState.set('disableDelta', true)
    }
    if (!IS_SERVER && !nextState.get('disableDelta')) {
      window?.__FT__BUILDER_API__?.calcHistory?.(
        prevState,
        nextState,
        nextState.get('historyKey'),
        nextState.get('keepNext')
      )
    }
    return nextState.set('disableDelta', false).delete('historyKey').delete('keepNext')
  } catch (error) {
    console.error(error.stack)
    if (!IS_SERVER) {
      logError('REDUCER', error, {
        type: action.type,
        uid: action?.payload?.uid || null,
        pageID: state.get('page'),
        pageUID: getActivePageField(state),
        pageName: getActivePageField(state),
        device: state.get('layoutMode', 'lg'),
        projectID: state.getIn(['project', '_id']) || null,
      })
    }
    return state.set('disableDelta', false).delete('historyKey').delete('keepNext')
  }
}

export const bindMiddleware = (middleware) => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('redux-devtools-extension')
    return composeWithDevTools(applyMiddleware(...middleware))
  }
  return applyMiddleware(...middleware)
}

export const makeStore = (context) => createStore(historyReducer, bindMiddleware([thunkMiddleware]))
